export const translations = {
  en: {
    header: {
      home: "Home",
      pricing: "Pricing",
      locations: "Datacenters",
      support: "Support",
      about: "About",
      partners: "Partners",
      login: "Log In",
      language: "Language"
    },
    hero: {
      badge: "Trusted by 12,000+ developers",
      title1: "Fast, reliable VPS hosting",
      title2: "across Europe & the US",
      subtitle: "Spin up a virtual private server in 60 seconds. NVMe storage, a 1 Gbps port, and 99.9% uptime — across twelve datacenters from Amsterdam to Miami.",
      signUp: "Get Started",
      viewLocations: "View Locations",
      nvmeSSD: "NVMe SSD Storage",
      nvmeDesc: "High-performance NVMe drives with minimal latency",
      port10G: "1Gbps Port",
      portDesc: "Shared 1 Gigabit internet connection with unlimited data transfer",
      unlimitedTraffic: "Unlimited Traffic",
      trafficDesc: "Unmetered bandwidth for all your needs"
    },
    locations: {
      globalNetwork: "Global Network",
      title: "A datacenter close to your users",
      subtitle: "Twelve locations across Europe and the US. Pick the one that gives your visitors the lowest ping — switch later if your audience moves.",
      latency: "Average Latency",
      uptime: "Uptime SLA",
      networkSpeed: "Network Speed",
      monitoring: "Monitoring",
      deploy: "VPS Deployment in 60 Seconds",
      comingSoon: "Coming Soon"
    },
    pricing: {
      title: "Transparent pricing, built for business",
      subtitle: "Start small, upgrade when you need more. No setup fees, no long-term contracts, cancel whenever.",
      specifications: "Specifications",
      perMonth: "/mo",
      choose: "Choose"
    },
    payment: {
      subtitle: "We accept payments from 190+ countries worldwide. Pay with bank cards, USDT, Bitcoin and other cryptocurrencies, as well as bank transfers with zero commission.",
      crypto: "Cryptocurrency",
      card: "Card Payment",
      bank: "Bank Transfer"
    },
    features: {
      title: "Built for real workloads",
      subtitle: "The things that actually matter when your VPS is running production traffic.",
      nvme: {
        title: "NVMe SSD storage",
        desc: "Databases, builds, and caches stop being the bottleneck. Real I/O performance, not shared spinning disks."
      },
      uptime: {
        title: "99.9% uptime SLA",
        desc: "Redundant power, cooling, and network. If something fails, we fail it over before you notice."
      },
      support: {
        title: "Human support, 24/7",
        desc: "Real engineers, no chatbots. Replies usually within 30 minutes, any day of the week."
      },
      root: {
        title: "Full root access",
        desc: "Your server, your rules. Install what you want, tune the kernel, break things — we don't lock you in."
      },
      ip: {
        title: "Dedicated IPs",
        desc: "A clean IPv4 and IPv6, yours alone. No shared reputation issues, no surprises."
      },
      os: {
        title: "Your choice of OS",
        desc: "Ubuntu, Debian, Rocky, AlmaLinux, FreeBSD, Windows — pick one when you order."
      }
    },
    technical: {
      cpu: {
        title: "Powerful Processors",
        subtitle: "Supercharged Intel Xeon Processors",
        desc: "Our servers run on the latest generations of Intel Xeon, providing maximum performance, stability and reliability. High core count and support for modern technologies allow running hundreds of virtual servers without speed loss."
      },
      storage: {
        title: "Ultra-Fast Storage",
        subtitle: "Lightning-Fast NVMe Drives",
        desc: "We use only Enterprise NVMe SSDs that are tens of times faster than regular drives. This guarantees instant response, high IOPS and eliminates bottlenecks when running your applications and databases."
      },
      virtualization: {
        title: "Advanced Virtualization",
        subtitle: "Hardware KVM Virtualization",
        desc: "Each VPS runs on KVM technology, ensuring complete resource isolation, fair CPU and RAM distribution, and maximum compatibility with any operating systems."
      },
      ipAddress: {
        title: "Flexible IP Addressing",
        subtitle: "IPv4 + Optional IPv6 Subnet",
        desc: "We provide IPv4 address with every VPS. Additionally, you can order IPv6 subnets for modern networking requirements and future-proof connectivity solutions."
      },
      deployment: {
        title: "Instant Deployment",
        subtitle: "VM Ready in Under 30 Seconds",
        desc: "Your virtual machine is created and ready to use in less than 60 seconds. No waiting, no delays - start working with your server immediately after ordering."
      },
      panel: {
        title: "Advanced Control Panel",
        subtitle: "Complete VM Management Suite",
        desc: "Comprehensive control panel with detailed statistics, full VM management, OS reinstallation, reboot controls, and real-time monitoring of your server resources."
      },
      backup: {
        title: "RAID 1 Mirroring",
        subtitle: "Hardware-Level Data Protection",
        desc: "All data is automatically mirrored across RAID 1 arrays for redundancy. Hardware-level protection ensures your data remains safe even in case of disk failure."
      },
      monitoring: {
        title: "Infrastructure Monitoring",
        subtitle: "Real-Time Node & Network Monitoring",
        desc: "Comprehensive monitoring of all infrastructure nodes, servers, and network components. Real-time alerts, performance metrics, and proactive maintenance ensure maximum uptime and reliability."
      }
    },
    useCases: {
      title: "What VPS NetGrid Host Is Used For",
      subtitle: "From VPN solutions to game servers, our VPS hosting powers diverse applications across industries",
      vpn: {
        title: "VPN Solutions",
        desc: "Secure private networks with multiple protocols"
      },
      web: {
        title: "Web Hosting",
        desc: "Websites, e-commerce stores, and admin panels"
      },
      gaming: {
        title: "Game Servers",
        desc: "High-performance gaming and business applications"
      },
      os: {
        title: "Operating Systems",
        desc: "Choose from Linux or Windows environments"
      },
      dev: {
        title: "Development",
        desc: "Perfect environment for testing and development"
      },
      scale: {
        title: "Scalability",
        desc: "Seamlessly upgrade to higher tiers with automated resource scaling. Quick and efficient transitions minimize downtime."
      }
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Got questions? We've got answers. Find everything you need to know about our VPS services.",
      ready: "Ready to get started?",
      readyDesc: "Explore our pricing plans and global server locations to find the perfect solution for your needs.",
      viewPricing: "View Pricing",
      viewLocations: "View Locations"
    },
    footer: {
      description: "Premium VPS hosting solutions across Europe. Experience lightning-fast performance with enterprise-grade infrastructure and 24/7 expert support.",
      quickLinks: "Quick Links",
      legal: "Legal",
      home: "Home",
      pricing: "Pricing",
      locations: "Locations",
      support: "Support",
      wiki: "Knowledge base",
      about: "About",
      blog: "Blog",
      affiliate: "Partners",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      refund: "Refund Policy",
      rights: "All rights reserved."
    },
    support: {
      hero: {
        title: "Support Center",
        subtitle: "We're here to help you 24/7. Our expert team is ready to assist with any questions or issues."
      },
      departments: {
        technical: {
          title: "Technical Support",
          description: "Server issues, network problems, and urgent technical matters",
          hours: "Mon-Fri, 9:00-18:00 UTC"
        },
        financial: {
          title: "Financial Department",
          description: "Billing, payments, invoices, and refund requests",
          hours: "Mon-Fri, 9:00-18:00 UTC"
        },
        abuse: {
          title: "Abuse Department",
          description: "Report abuse, spam, copyright violations, and security incidents",
          hours: "Response within 24 hours"
        }
      },
      clientNotice: {
        title: "Are you our client?",
        description: "If you are our existing customer, please open a ticket in your client area. This is the fastest way to get technical support with priority handling. Use this contact form only if you are not our client, forgot your account password, or have other general inquiries.",
        button: "Open Ticket"
      },
      form: {
        title: "Contact Form",
        name: "Your Name",
        email: "Email Address",
        department: "Department",
        subject: "Subject",
        message: "Message",
        agreement: "By submitting this form, you agree to our Privacy Policy",
        submit: "Send Message",
        sending: "Sending...",
        successMessage: "Your message has been sent successfully! We'll get back to you shortly."
      },
      contact: {
        title: "Contact Information",
        generalQuestions: "General Questions",
        general: "General Support",
        abuse: "Abuse Reports"
      },
      info: {
        title: "Need Immediate Help?",
        description: "For urgent technical issues, our team is available 24/7. Financial and administrative matters are handled during business hours (Mon-Fri, 9:00-18:00 UTC). All requests are typically answered within 2-4 hours."
      },
      social: {
        title: "Real-time updates on Telegram",
        subtitle: "We post infrastructure notifications, maintenance schedules and incident updates as they happen — join the channel to know about issues before opening a ticket.",
        description: "Get instant notifications about server availability, scheduled maintenance, network issues, and important infrastructure updates. We post all operational status changes and technical announcements to our Telegram channel.",
        telegram: "Join our Telegram channel"
      },
      knowledgeBase: {
        title: "Before you open a ticket",
        description: "Save yourself a wait — check the knowledge base or our Telegram channel first. Most answers are already there.",
        kbButton: "Browse knowledge base",
        tgButton: "Telegram channel"
      }
    },
    about: {
      hero: {
        title: "About NetGrid Host",
        subtitle: "Building the future of VPS infrastructure with 15 years of expertise in IT, networking, and VPN services."
      },
      stats: {
        years: "Years of Experience",
        clients: "Happy Clients",
        locations: "Global Locations",
        uptime: "Uptime SLA"
      },
      story: {
        title: "Our Story",
        paragraph1: "NetGrid Host was founded by a team of IT professionals with over 15 years of combined experience in the technology sector. Our journey began in network engineering, VPN services, and software development, giving us a deep understanding of what businesses and individuals need from their VPS provider.",
        paragraph2: "Throughout our history, we've worked as a VPN provider, developed complex network infrastructures, and created innovative software solutions. This diverse background allows us to offer VPS hosting services that are not just fast and reliable, but truly understand the needs of modern applications.",
        paragraph3: "Today, we're proud to serve over 12,000 clients across 12 strategic locations worldwide, and we're just getting started. Our commitment to affordable pricing without compromising on quality has made us one of the most competitive VPS providers in the market."
      },
      vision: {
        title: "Our Vision & Goals",
        subtitle: "We're building a global infrastructure that makes VPS hosting accessible to everyone",
        global: {
          title: "Global Expansion to 40 Countries",
          desc: "Our ambitious goal is to expand our VPS infrastructure to 40 countries worldwide, bringing low-latency, high-performance virtual private servers closer to users everywhere."
        },
        accessibility: {
          title: "Affordable VPS Hosting",
          desc: "We believe quality VPS hosting shouldn't break the bank. Our mission is to offer enterprise-grade virtual private servers at prices that are accessible to startups, developers, and businesses of all sizes."
        },
        innovation: {
          title: "Continuous Innovation",
          desc: "We're constantly evolving, adopting the latest technologies, and improving our services based on customer feedback to stay ahead of industry trends."
        }
      },
      whyUs: {
        title: "Why Choose NetGrid Host?",
        subtitle: "What makes us different from other VPS providers"
      },
      values: {
        pricing: {
          title: "Competitive Pricing",
          desc: "We offer some of the lowest prices on the market without compromising on quality, reliability, or performance."
        },
        experience: {
          title: "15+ Years Expertise",
          desc: "Our team brings extensive experience from VPN services, network engineering, and software development."
        },
        performance: {
          title: "High Performance",
          desc: "Enterprise NVMe storage, modern processors, and optimized network infrastructure ensure maximum speed."
        },
        support: {
          title: "Dedicated Support",
          desc: "Our knowledgeable support team is ready to help you with any technical or billing questions."
        }
      },
      company: {
        title: "Company Information",
        legalName: "Legal Name",
        address: "Office Address",
        email: "Corporate Email"
      },
      cta: {
        title: "Ready to Get Started?",
        subtitle: "Join thousands of satisfied customers who trust NetGrid Host for their VPS hosting needs",
        contact: "Contact Us",
        pricing: "View Pricing"
      },
      social: {
        title: "Stay Informed",
        subtitle: "Follow our social media for real-time updates, infrastructure notifications, and technical maintenance schedules",
        description: "Get instant notifications about server availability, scheduled maintenance, network issues, and important infrastructure updates. We post all operational status changes and technical announcements on our social channels.",
        twitter: "Follow on X",
        telegram: "Join Telegram"
      }
    },
    legal: {
      terms: {
        title: "Terms of Service",
        subtitle: "These terms govern your use of NetGrid Host VPS hosting services. Please read carefully before proceeding.",
        lastUpdated: "Last Updated: December 1, 2025",
        section1: {
          title: "1. Agreement Acceptance and User Eligibility",
          content: "These Terms of Service constitute a legally binding agreement between you (the 'User' or 'Client') and NetGrid Host Ltd ('NetGrid', 'we', 'us', or 'our'). By creating an account, accessing our website, or using any of our VPS hosting services, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree with any part of these Terms, you must immediately cease using our services. Users must be at least 18 years of age or have reached the age of majority in their jurisdiction. By using our services, you represent and warrant that you meet this age requirement and have the legal capacity to enter into this agreement. We reserve the right to refuse service to any person or entity at our sole discretion."
        },
        section2: {
          title: "2. Service Description and Modifications",
          content: "NetGrid Host provides Virtual Private Server (VPS) hosting services with high-performance infrastructure, multiple global datacenter locations, and round-the-clock technical support. Our services include but are not limited to: dedicated CPU and RAM resources, NVMe SSD storage, network connectivity with guaranteed bandwidth, operating system installations, and backup solutions. We strive to maintain 99.9% uptime for all VPS instances. NetGrid reserves the right to modify, enhance, suspend, or discontinue any aspect of our services, features, or pricing at any time without prior notice. We will make reasonable efforts to notify users of significant changes that may affect their service usage. Scheduled maintenance will be announced in advance whenever possible, though emergency maintenance may be performed without notice to protect system integrity and security."
        },
        section3: {
          title: "3. User Responsibilities and Prohibited Activities",
          content: "You are solely responsible for: (a) maintaining the confidentiality and security of your account credentials; (b) all activities that occur under your account; (c) ensuring that your use of services complies with all applicable laws and regulations; (d) the content, data, and applications you store, process, or transmit using our VPS services. You must not use our services for: illegal activities including but not limited to copyright infringement, distribution of pirated content, hacking, phishing, or fraud; sending unsolicited bulk email (spam) or engaging in any form of network abuse; hosting or distributing malware, viruses, or malicious code; cryptocurrency mining without prior approval; running Tor exit nodes or proxy services without authorization; hosting content that violates intellectual property rights; engaging in activities that could damage, disable, or impair our infrastructure or other users' services. You agree to implement reasonable security measures to protect your VPS and immediately notify us of any security breaches or unauthorized access."
        },
        section4: {
          title: "4. Payment Terms and Billing",
          content: "All services are billed according to the pricing plan you select at the time of purchase. Prices are stated in the currency specified during checkout and exclude applicable taxes unless otherwise noted. Payment is due in advance for each billing period (monthly, quarterly, or annually as applicable). We accept various payment methods as displayed on our website, and payment processing is handled through third-party payment processors. By providing payment information, you authorize us to charge the specified payment method for all fees incurred. If a payment fails or is declined, we will attempt to notify you and may retry the charge. Your service will be immediately suspended upon payment delay and permanently deleted after 3 days of non-payment without possibility of recovery. You are responsible for ensuring your payment information remains current and valid. All fees are non-refundable except as explicitly stated in our Refund Policy. We reserve the right to change our pricing with at least 30 days' notice to existing customers."
        },
        section5: {
          title: "5. Service Level Agreement and Uptime Guarantee",
          content: "NetGrid Host guarantees 99.9% monthly uptime for VPS services, calculated as the percentage of time that your VPS is accessible and operational during each calendar month. This guarantee excludes: scheduled maintenance windows (announced at least 24 hours in advance), emergency maintenance required for security or system stability, downtime caused by factors outside our control (including internet connectivity issues, force majeure events, or third-party service failures), and downtime resulting from user actions or misconfigurations. In the event that we fail to meet the 99.9% uptime guarantee in a given month, you may be eligible for service credits calculated as follows: 99.5-99.89% uptime: 5% credit; 99.0-99.49% uptime: 10% credit; below 99.0% uptime: 25% credit. Service credits are your sole remedy for uptime guarantee failures and must be requested within 7 days of the end of the affected month. Credits are issued as account credits only and cannot be redeemed for cash."
        },
        section6: {
          title: "6. Data Protection and Privacy",
          content: "We are committed to protecting your personal information and data. Our collection, use, and disclosure of personal data is governed by our Privacy Policy, which forms an integral part of these Terms. You retain all rights, title, and interest in your data stored on our VPS services. We will not access, view, or use your data except: when required by law or legal process; with your express permission; as necessary to provide technical support or maintain service functionality; to investigate potential violations of these Terms or to protect our rights and property. We implement industry-standard security measures including encryption, access controls, and regular security audits. However, no system is completely secure, and we cannot guarantee absolute security of your data. You are responsible for maintaining your own backups of critical data, as we do not guarantee data recovery in all circumstances."
        },
        section7: {
          title: "7. Limitation of Liability and Disclaimers",
          content: "TO THE MAXIMUM EXTENT PERMITTED BY LAW: Our services are provided 'AS IS' and 'AS AVAILABLE' without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement. NetGrid Host shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, or other intangible losses, arising from: your use or inability to use our services; unauthorized access to or alteration of your data; any third-party conduct or content on our services; any interruption or cessation of services. Our total liability to you for all claims arising from or related to these Terms or our services shall not exceed the amount you paid to NetGrid Host in the 12 months preceding the claim. Some jurisdictions do not allow the exclusion of certain warranties or limitation of liability, so these limitations may not apply to you."
        },
        section8: {
          title: "8. Indemnification",
          content: "You agree to indemnify, defend, and hold harmless NetGrid Host, its officers, directors, employees, agents, and affiliates from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising from: your use or misuse of our services; your violation of these Terms; your violation of any rights of third parties, including intellectual property rights; your violation of any applicable laws or regulations; any content or data you upload, store, or transmit through our services. This indemnification obligation will survive termination of these Terms and your use of our services."
        },
        section9: {
          title: "9. Termination and Suspension",
          content: "You may terminate your account and services at any time by contacting our support team or through your account dashboard. Termination does not relieve you of any payment obligations for services already rendered. NetGrid Host may immediately suspend or terminate your access to services without prior notice if: you breach any provision of these Terms; your account is significantly past due on payment; your use of services poses a security risk or violates applicable laws; we are required to do so by law or court order. Upon termination, your right to use our services will immediately cease. We will make reasonable efforts to provide you with access to retrieve your data for a period of 7 days following termination, after which all data associated with your account may be permanently deleted. Certain provisions of these Terms will survive termination, including sections relating to intellectual property, limitation of liability, and indemnification."
        },
        section10: {
          title: "10. Governing Law and Dispute Resolution",
          content: "These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions. Any dispute arising from or relating to these Terms or our services shall be subject to the exclusive jurisdiction of the courts of England and Wales. Before initiating any legal proceedings, parties agree to attempt to resolve disputes through good faith negotiations. If a dispute cannot be resolved through negotiations within 30 days, either party may pursue formal legal remedies. You agree that any claim must be brought within one year of the cause of action arising, or such claim shall be permanently barred."
        },
        section11: {
          title: "11. Network Service, Shared Port, and Fair Use",
          content: "Each VPS is provisioned with a network port advertised at up to 1 Gbps. The Client expressly acknowledges that this port is shared infrastructure: the physical uplink of each host node is shared between all virtual machines running on the same node, in line with standard industry practice (oversubscription). The 1 Gbps figure represents the theoretical burst speed available when the underlying uplink is otherwise idle and is not a guaranteed dedicated bandwidth allocated exclusively to the Client. Sustained throughput available to any individual VPS is statistical in nature and depends on the moment-by-moment activity of all neighbours on the same node, the upstream route to the destination, and the destination's own capacity. NetGrid does not commit to any specific minimum sustained bandwidth, single-flow throughput, packet rate, or speedtest score on entry-level tariffs. Speed measurements performed against arbitrary third-party endpoints (including but not limited to speedtest.net, iperf3 against random hosts, browser-based tests, or VPN-tunnelled tests) measure the entire network path and any intermediate transit congestion, not the performance of the VPS itself, and are not accepted as evidence of a service-level breach. Fair Usage Policy: Our network is engineered for typical web hosting, application backends, personal projects, development environments, mail relays in moderate volume, and similar mixed workloads. Continuous high-bandwidth applications — including but not limited to public file mirrors, content delivery / CDN edge nodes, video streaming origins, large-scale torrent seeding, traffic exchange or proxy services intended for resale, and any pattern of sustained outbound throughput that materially degrades service for other Clients on the same node — fall outside the scope of an entry tariff and are subject to: (a) automatic rate limiting to protect node capacity, (b) suspension in clear cases of abuse, and (c) a requirement to migrate to a plan that includes dedicated bandwidth, available on request from support. NetGrid reserves the right at all times to apply traffic shaping, throttle individual VPS instances, or suspend service when, in its sole reasonable judgement, an account\'s usage adversely affects the operational stability of a host node or the experience of other Clients. Where applicable, monthly outbound traffic quotas published in the plan description are binding; on exceeding the quota the network port may be reduced for the remainder of the billing cycle, or additional traffic may be purchased on terms displayed in the Client area. Inbound traffic is unmetered, subject to the same fair-use principles and to active anti-abuse filtering. Plans, quotas, and rate-limit thresholds may be updated from time to time; the current state is always reflected on netgrid.host and inside the Client area, and that current state takes precedence over any historical advertisement. A plain-language explanation of how shared bandwidth works on a VPS is published at netgrid.host/wiki and is incorporated into these Terms by reference for clarification, not as an alternative source of obligations."
        }
      },
      privacy: {
        title: "Privacy Policy",
        subtitle: "NetGrid Host Ltd is committed to protecting your personal data and privacy rights",
        lastUpdated: "Last Updated: December 1, 2025",
        section1: {
          title: "1. Information Collection and Types of Data",
          content: "NetGrid Host collects several types of information to provide and improve our VPS hosting services: Personal Information - When you register for an account, we collect your name, email address, physical address, phone number, and billing information. This information is necessary to create your account, process payments, and communicate with you about your services. Technical Information - We automatically collect technical data including IP addresses, browser type and version, operating system, server logs, access times, and pages viewed. This information helps us maintain service quality, troubleshoot issues, and prevent fraud. Usage Data - We collect information about how you use our VPS services, including resource consumption (CPU, RAM, bandwidth), configuration settings, and support tickets. This data helps us optimize our infrastructure and provide better support. Cookies and Tracking - Our website uses cookies and similar tracking technologies to enhance user experience, remember preferences, and analyze website traffic. Please refer to our Cookie Policy for detailed information."
        },
        section2: {
          title: "2. How We Use Your Information",
          content: "We process your personal data for the following purposes: Service Provision - To create and manage your account, provision VPS resources, maintain infrastructure, and ensure service availability and performance. Communication - To send service notifications, billing statements, technical alerts, security updates, and respond to your support requests. We may also send marketing communications if you have opted in, and you can unsubscribe at any time. Payment Processing - To process payments, prevent fraud, and maintain billing records. We work with trusted third-party payment processors who comply with PCI DSS standards. Legal Compliance - To comply with applicable laws and regulations, respond to legal requests from government authorities, enforce our Terms of Service, and protect our rights and property. Service Improvement - To analyze usage patterns, identify technical issues, develop new features, and enhance overall service quality. Security - To detect and prevent unauthorized access, maintain system security, and protect against malicious activities. We never sell, rent, or trade your personal information to third parties for their marketing purposes."
        },
        section3: {
          title: "3. Data Sharing and Third-Party Services",
          content: "We may share your information in the following circumstances: Service Providers - We work with carefully selected third-party service providers who assist us in delivering our services, including payment processors, datacenter operators, CDN providers, and support tools. These providers are bound by confidentiality agreements and may only use your information to perform services on our behalf. Legal Requirements - We may disclose your information when required by law, court order, or government regulation, or when we believe disclosure is necessary to protect our rights, your safety, or the safety of others. WHOIS Information - If you register a domain through us or use our services, certain information (name, address, email, phone number) may be published in public WHOIS databases as required by domain registries and ICANN regulations. Business Transfers - In the event of a merger, acquisition, or sale of assets, your information may be transferred to the acquiring entity. We will notify you of any such change in ownership. With Your Consent - We may share your information with other third parties when you have given us explicit permission to do so. We do not share your data with third parties for their independent marketing purposes without your explicit consent."
        },
        section4: {
          title: "4. Data Security and Protection Measures",
          content: "We implement comprehensive security measures to protect your personal data: Technical Safeguards - All data transmissions are encrypted using industry-standard TLS/SSL protocols. Data at rest is encrypted using AES-256 encryption. We employ firewalls, intrusion detection systems, and regular security audits to protect our infrastructure. Access Controls - Access to personal data is restricted to authorized personnel only on a need-to-know basis. All employees sign confidentiality agreements and receive regular security training. We use multi-factor authentication and strong password policies for all administrative access. Payment Security - We do not store complete credit card information on our servers. All payment processing is handled through PCI DSS Level 1 certified payment processors, ensuring the highest level of payment security. Physical Security - Our datacenters feature 24/7 physical security, biometric access controls, video surveillance, and environmental monitoring systems. Incident Response - We maintain an incident response plan to quickly detect, respond to, and recover from security incidents. In the event of a data breach that may affect you, we will notify you in accordance with applicable laws. While we implement strong security measures, no system is completely secure. You are responsible for maintaining the security of your account credentials and promptly notifying us of any unauthorized access."
        },
        section5: {
          title: "5. Data Retention and Deletion",
          content: "We retain your personal data for different periods depending on the type of information and purpose: Active Accounts - Personal and account information is retained for as long as your account remains active and you continue using our services. Closed Accounts - After you close your account, we retain certain information for up to 24 months to comply with legal obligations, resolve disputes, and prevent fraud. Billing Records - Financial records and invoices are retained for 7 years to comply with tax and accounting regulations. Server Logs - Technical logs are typically retained for 90 days for troubleshooting and security purposes, after which they are automatically deleted. Marketing Data - If you opt out of marketing communications, we will retain minimal information to honor your opt-out preference. You may request deletion of your personal data at any time by contacting our support team at support@netgrid.host. We will process your request within 30 days, subject to our legal obligations to retain certain information."
        },
        section6: {
          title: "6. Your Privacy Rights",
          content: "Under applicable data protection laws, including GDPR and UK GDPR, you have the following rights: Right of Access - You can request a copy of the personal data we hold about you. Right to Rectification - You can request correction of inaccurate or incomplete personal data. Right to Erasure - You can request deletion of your personal data, subject to legal retention requirements. Right to Restriction - You can request that we restrict processing of your personal data in certain circumstances. Right to Data Portability - You can request a copy of your data in a structured, machine-readable format. Right to Object - You can object to processing of your personal data for certain purposes, including marketing. Right to Withdraw Consent - Where processing is based on consent, you can withdraw consent at any time. Right to Lodge a Complaint - You have the right to file a complaint with the Information Commissioner's Office (ICO) in the UK if you believe we have violated your privacy rights. To exercise any of these rights, please contact us at support@netgrid.host with your account details and specific request. We will respond within 30 days."
        },
        section7: {
          title: "7. International Data Transfers",
          content: "NetGrid Host operates globally and may transfer your personal data to countries outside your country of residence, including countries that may not have the same data protection laws. When we transfer data internationally, we implement appropriate safeguards including: Standard Contractual Clauses - We use EU Standard Contractual Clauses approved by the European Commission for transfers from the EEA to countries without adequate protection. Adequacy Decisions - We may transfer data to countries that have been deemed to provide adequate data protection by the European Commission or UK authorities. Security Measures - Regardless of location, all data transfers are encrypted and subject to our comprehensive security policies. By using our services, you consent to the transfer of your information to our facilities and those of third parties with whom we share it as described in this policy."
        },
        section8: {
          title: "8. Children's Privacy",
          content: "Our services are not directed to individuals under the age of 18, and we do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately at support@netgrid.host, and we will take steps to delete such information from our systems."
        },
        section9: {
          title: "9. Changes to This Privacy Policy",
          content: "We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors. We will post the updated policy on this page with a new 'Last Updated' date. For material changes, we will provide prominent notice on our website or send you an email notification at least 30 days before the changes take effect. Your continued use of our services after the effective date constitutes acceptance of the updated policy."
        },
        section10: {
          title: "10. Contact Information",
          content: "If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at: Email: support@netgrid.host, Corporate Email: about@netgrid.host, Address: NetGrid Host Ltd, Unit A, 82 James Carter Road, Mildenhall, IP28 7DE, United Kingdom. We are committed to resolving any privacy concerns you may have and will respond to all inquiries within a reasonable timeframe."
        }
      },
      cookie: {
        title: "Cookie Policy",
        subtitle: "Understanding how NetGrid Host uses cookies and similar tracking technologies",
        lastUpdated: "Last Updated: December 1, 2025",
        section1: {
          title: "1. What Are Cookies and How Do They Work",
          content: "Cookies are small text files that are placed on your computer, smartphone, or other device when you visit our website. They contain information that is transferred to your device's hard drive and allow our website to recognize your device and remember certain information about your visit. Cookies serve various purposes, from enabling basic functionality to helping us understand how visitors interact with our website. They can be 'session cookies' that expire when you close your browser, or 'persistent cookies' that remain on your device for a set period or until you delete them. First-party cookies are set directly by our website, while third-party cookies are set by other services that appear on our pages. By using our website, you consent to the use of cookies in accordance with this Cookie Policy. If you do not agree to our use of cookies, you should set your browser settings accordingly or not use our website."
        },
        section2: {
          title: "2. Types of Cookies We Use",
          content: "Strictly Necessary Cookies - These cookies are essential for the website to function properly and cannot be disabled in our systems. They are usually set in response to actions you make, such as logging in, filling in forms, or setting your privacy preferences. These cookies do not store any personally identifiable information. Examples include authentication cookies, security cookies, and load balancing cookies. Functional Cookies - These cookies enable enhanced functionality and personalization, such as remembering your language preference, region selection, or login information. They may be set by us or by third-party providers whose services we use. If you disable these cookies, some or all of these features may not function properly. Performance and Analytics Cookies - We use these cookies to count visits and traffic sources so we can measure and improve the performance of our site. They help us understand which pages are most popular, how visitors navigate our website, and identify technical issues. All information collected by these cookies is aggregated and anonymous. If you do not allow these cookies, we will not be able to monitor our site's performance or improve user experience based on visitor behavior. Preference Cookies - These cookies remember your choices and settings to provide a more personalized experience, such as your preferred currency, language, or notification preferences."
        },
        section3: {
          title: "3. Specific Cookies We Use",
          content: "Our website uses the following specific cookies: Session Cookie (PHPSESSID) - Essential cookie that maintains your session state as you navigate through our website. It expires when you close your browser. Authentication Token (auth_token) - Keeps you logged in to your account during your session. Expires after 30 days of inactivity. Language Preference (lang_pref) - Remembers your selected language preference. Persistent cookie that lasts for 1 year. Analytics Cookies (Google Analytics: _ga, _gid, _gat) - These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. _ga cookie lasts for 2 years, _gid for 24 hours, and _gat for 1 minute. Security Cookie (csrf_token) - Protects against Cross-Site Request Forgery attacks. Essential for security, expires with session. The specific cookies we use may change over time as we improve our services and adopt new technologies. We will update this policy to reflect any significant changes."
        },
        section4: {
          title: "4. Third-Party Cookies and Services",
          content: "Our website may include content and services from third parties that may set their own cookies. We do not control these third-party cookies and recommend reviewing their privacy and cookie policies: Payment Processors - When you make a payment, our payment partners may set cookies to facilitate secure transactions and prevent fraud. Customer Support Tools - We use third-party support services that may set cookies to provide chat functionality and track support interactions. Content Delivery Networks (CDN) - Our CDN providers may use cookies to optimize content delivery and improve loading times. Analytics Providers - We use third-party analytics services to understand website usage and improve user experience. Please note that we do not have control over third-party cookies, and their use is subject to the respective third party's privacy and cookie policies. We encourage you to review these policies to understand how your information may be used."
        },
        section5: {
          title: "5. How to Manage and Delete Cookies",
          content: "You have the right to decide whether to accept or reject cookies. Most web browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies if you prefer. Browser Settings - You can manage cookies through your browser settings. Each browser is different, so check your browser's 'Help' menu to learn how to change your cookie preferences. Please note that if you disable cookies, some features of our website may not function correctly, and your user experience may be diminished. Browser-Specific Instructions: Chrome - Settings > Privacy and Security > Cookies and other site data; Firefox - Settings > Privacy & Security > Cookies and Site Data; Safari - Preferences > Privacy > Cookies and website data; Edge - Settings > Cookies and site permissions > Cookies and site data. Opt-Out Tools - You can opt out of analytics cookies by installing browser add-ons such as Google Analytics Opt-out Browser Add-on. Mobile Devices - Mobile device users can manage cookies through their device settings or through the browser app settings. Do Not Track Signals - Our website does not currently respond to Do Not Track (DNT) signals, as there is no industry standard for how DNT signals should be interpreted."
        },
        section6: {
          title: "6. Updates to This Cookie Policy",
          content: "We may update this Cookie Policy from time to time to reflect changes in our cookie practices or for legal, regulatory, or operational reasons. We will notify you of any material changes by posting the new Cookie Policy on this page with an updated 'Last Updated' date. We encourage you to review this Cookie Policy periodically to stay informed about our use of cookies and how you can manage them. Your continued use of our website after any changes to this Cookie Policy will constitute your acceptance of such changes."
        }
      },
      refund: {
        title: "Refund Policy",
        subtitle: "Our commitment to your satisfaction - clear and fair refund terms",
        lastUpdated: "Last Updated: December 1, 2025",
        section1: {
          title: "1. Money-Back Guarantee Overview",
          content: "NetGrid Host is committed to providing high-quality VPS hosting services and customer satisfaction. We offer a 3-day money-back guarantee for new customers who are not satisfied with our services. This guarantee applies from the moment of initial account activation on netgrid.host or any of its subdomains. If you decide our VPS services are not suitable for your needs within the first 3 days, you may request a refund subject to the conditions outlined in this policy. If you order multiple VPS instances simultaneously, only the first service is eligible for a refund. This refund policy demonstrates our confidence in our services and ensures you can try NetGrid with minimal financial risk. Please read this policy carefully to understand the terms, conditions, and procedures for requesting a refund."
        },
        section2: {
          title: "2. Eligible Services and Customers",
          content: "Refunds are available under the following conditions: New Customers Only - The money-back guarantee applies only to customers purchasing NetGrid Host VPS services for the first time. Returning customers who have previously used our services are not eligible for refunds. First Service Only - Refunds are provided only for the first VPS service ordered. If you order multiple VPS instances simultaneously, only the first service is eligible for a refund. Other services ordered at the same time are not refundable. VPS Services Only - This refund policy applies exclusively to VPS hosting services. It does not cover domain registrations, SSL certificates, dedicated IP addresses, backup services, or any add-on services purchased separately. Time Frame - You must request a refund within 3 days (72 hours) from the initial activation of your VPS service. Refund requests submitted after this period will not be processed. Account Status - Your account must be in good standing with no violations of our Terms of Service. Accounts suspended or terminated for policy violations are not eligible for refunds."
        },
        section3: {
          title: "3. Refund Request Process",
          content: "To request a refund under our money-back guarantee, please follow these steps: Step 1: Delete All Active Services - Before submitting a refund request, you must delete all active VPS services from your account. Services that remain active during the refund processing period will invalidate your refund request. Step 2: Contact Support - Open a support ticket through your account dashboard ONLY. Email requests will not be processed. Include your account email, order number, and reason for requesting a refund (optional). Step 3: KYC Identity Verification - For security and fraud prevention purposes, all customers must complete KYC (Know Your Customer) verification by providing government-issued identification. Business customers must submit a formal refund application on company letterhead, signed by an authorized representative and bearing the company seal. Step 4: Processing Time - Refund requests are processed within 30 days from submission, provided there are no abuse complaints filed against your account. The actual time for funds to appear in your account depends on your payment provider and may take an additional 3-7 business days. Step 5: Refund Method - Refunds are issued to the original payment method used for the purchase. If the original payment method is no longer available, alternative arrangements may be discussed with our support team."
        },
        section4: {
          title: "4. Refund Calculations and Deductions",
          content: "Only the price of the product (service) itself is refundable, minus the refund fee and after discounts. The refund fee depends on the payment method and can be up to 14% of the payment amount — ask support before paying. Fees and costs related to the payment itself are non-refundable: payment-processor fees, service fees, bank or exchange fees, network fees for cryptocurrency, currency-conversion costs and any other costs of executing the payment. If the refund currency differs from the payment currency, a currency-conversion fee is additionally withheld; conversion is performed at the mid-market rate on the refund date as determined by us. Discounts and bonuses are deducted from the refundable base: you receive the amount actually paid, not the pre-discount price. There is no such thing as unused days: outside the 3-day window the service is considered fully paid and delivered, and no refund is issued for the remaining term. In particular cases we may request identity (KYC) or business (KYB) verification; if it is not completed or the documents are not provided, the refund is not issued. Account balance funds are non-refundable (only a specific top-up payment can be refunded, in full, within 3 days, and only if nothing from it has been spent) — this rule also serves anti-money-laundering (AML/KYC) compliance."
        },
        section5: {
          title: "5. Non-Refundable Services and Fees",
          content: "The following items are NOT covered by our refund policy and are non-refundable under any circumstances: Abuse Complaints - If any abuse complaint has been filed to abuse@netgrid.host or abuse-report@netgrid.host regarding your service, your account is immediately ineligible for any refund. Domain Registrations - Domain name registration and renewal fees are non-refundable. Domain registrations involve third-party registrars and cannot be reversed. SSL Certificates - SSL certificate purchases are processed through third-party certificate authorities and are non-refundable once issued. Dedicated IP Addresses - Additional IP address fees are non-refundable once allocated to your account. Setup Fees - Any one-time setup or migration fees are non-refundable. Backup Services - Automated backup service fees for the period used are non-refundable. Bandwidth Overages - Charges for bandwidth usage exceeding your plan limits are non-refundable. Services Beyond 3 Days - Any VPS service usage beyond the 3-day money-back guarantee period is non-refundable. If you cancel after 3 days, no refund will be provided, but your service will remain active until the end of your current billing period. Renewal Charges - Automatic renewal charges are non-refundable if the service has been renewed and used beyond the original 3-day guarantee period."
        },
        section6: {
          title: "6. Disqualification and Refusal Conditions",
          content: "Refund requests will be denied in the following circumstances: Terms of Service Violations - If your account has been suspended or terminated for violating our Terms of Service, including but not limited to: sending spam, hosting malicious content, engaging in illegal activities, excessive resource usage, or abuse of our systems. Abuse Complaints - If we receive an abuse complaint about your VPS or the IP address allocated to your account at abuse@netgrid.host during the 3-day guarantee period or the refund processing period, your refund request will be automatically denied. Fraudulent Activity - Any indication of fraudulent activity, including chargeback disputes filed with payment providers, false information provided during registration, or attempted manipulation of the refund process. Multiple Accounts - Creation of multiple accounts with the same payment information without prior notification and approval from NetGrid Host Host. Resource Abuse - Excessive use of system resources that impacts other users or our infrastructure, including but not limited to cryptocurrency mining, botnet operations, or DDoS attacks. Previous Refunds - Customers who have previously received refunds from NetGrid Host Host are not eligible for additional refunds on new purchases."
        },
        section7: {
          title: "7. Post-Refund Account Status",
          content: "Once a refund is processed: Account Closure - Your NetGrid account will be permanently closed, and you will lose access to all services, data, and account information. Data Deletion - All data stored on your VPS, including files, databases, configurations, and backups, will be permanently deleted within 7 days of refund approval. We strongly recommend downloading any important data before submitting a refund request. No Data Recovery - After account closure and data deletion, we cannot recover any information. Data recovery services are not available for closed accounts. Future Service - If you wish to use NetGrid Host services again in the future, you will need to create a new account. However, the new account will not be eligible for the money-back guarantee as you will no longer be considered a new customer."
        },
        section8: {
          title: "8. Cancellation Without Refund",
          content: "If you wish to cancel your VPS service after the 3-day money-back guarantee period has expired: No Refund - No refund will be provided for the remaining time in your billing period. Service Continuity - Your VPS service will remain active and accessible until the end of your current paid period. Auto-Renewal - To prevent future charges, you must disable auto-renewal in your account settings. If auto-renewal is not disabled, your service will automatically renew at the end of the billing period. Cancellation Process - To cancel, log into your account dashboard, navigate to your active services, and select the cancellation option. You may also contact our support team to assist with cancellation. Final Invoice - You remain responsible for any outstanding invoices or charges incurred before the cancellation date."
        },
        section9: {
          title: "9. Dispute Resolution",
          content: "If you believe your refund request was unfairly denied or you have concerns about our refund process: Internal Review - Contact our support team to request a review of the refund decision. Provide any additional information or documentation that may support your case. Management Escalation - If the initial review does not resolve your concern, you may request escalation to management for further consideration. Chargebacks - We strongly discourage initiating chargebacks with your payment provider without first attempting to resolve the issue with our support team. Chargebacks may result in additional fees, account termination, and potential legal action. Please note that initiating a chargeback voids any current or future refund requests. Alternative Dispute Resolution - For unresolved disputes, we are open to alternative dispute resolution methods such as mediation, as outlined in our Terms of Service."
        },
        section10: {
          title: "10. Policy Updates and Contact Information",
          content: "NetGrid Host reserves the right to modify this Refund Policy at any time. Changes will be effective immediately upon posting to this page with an updated revision date. Continued use of our services after changes constitutes acceptance of the modified policy. For questions about this Refund Policy or to request a refund, please contact: Email: support@netgrid.host, Subject Line: Refund Request, Required Information: Account email, order number, and reason for refund. Our support team typically responds within 24 hours during business days (Monday-Friday, 9:00-18:00 UTC). We are committed to processing all legitimate refund requests fairly and promptly."
        }
      }
    },
    seo: {
      home: {
        title: "NetGrid Host — Fast VPS hosting across Europe & the US",
        description: "Fast, reliable VPS hosting across Europe and the US. NVMe storage, 1 Gbps network, 99.9% uptime. Twelve datacenters from Amsterdam to Miami. Starting at €2.98/month.",
        keywords: "VPS hosting, virtual private server, cloud hosting, dedicated server, affordable VPS, cheap VPS, high performance VPS, NVMe VPS, Linux VPS, VPS provider"
      },
      about: {
        title: "About NetGrid Host - 15+ Years of VPS Hosting Excellence",
        description: "Learn about NetGrid Host Ltd - a leading VPS hosting provider with 15+ years of experience. We serve 12,000+ clients across 12 global locations with affordable, high-performance virtual private servers.",
        keywords: "about NetGrid, VPS company, hosting provider, NetGrid Host Ltd, virtual private server provider, VPS hosting company"
      },
      support: {
        title: "NetGrid Host Support - 24/7 Technical Support & Customer Service",
        description: "Get help from NetGrid Host Host's expert support team. Contact us for technical support, billing questions, or abuse reports. Response within 24 hours. Email: support@netgrid.host",
        keywords: "VPS support, technical support, customer service, hosting support, NetGrid Host contact, VPS help"
      },
      terms: {
        title: "Terms of Service - NetGrid Host VPS Hosting",
        description: "Read NetGrid Host's Terms of Service. Clear and fair conditions for using our VPS hosting services. Learn about user responsibilities, payment terms, and our 99.9% uptime SLA.",
        keywords: "terms of service, VPS terms, hosting terms, service agreement, user agreement, TOS"
      },
      privacy: {
        title: "Privacy Policy - How NetGrid Host Protects Your Data",
        description: "NetGrid Host Privacy Policy explains how we collect, use, and protect your personal data. GDPR compliant. Learn about your privacy rights and data security measures.",
        keywords: "privacy policy, data protection, GDPR, personal data, data security, privacy rights"
      },
      cookie: {
        title: "Cookie Policy - How NetGrid Host Uses Cookies",
        description: "Learn about cookies used on NetGrid Host website. We use essential, functional, and analytics cookies to improve your experience. Manage your cookie preferences.",
        keywords: "cookie policy, cookies, website cookies, cookie management, tracking cookies"
      },
      refund: {
        title: "Refund Policy - 3-Day Money-Back Guarantee | NetGrid Host",
        description: "NetGrid Host offers a 3-day money-back guarantee for new VPS customers. Learn about our refund process, eligibility requirements, and conditions. Fair and transparent refund policy.",
        keywords: "refund policy, money back guarantee, VPS refund, hosting refund, 3 day guarantee"
      },
      affiliateTerms: {
        title: "Affiliate Program Rules | NetGrid Host",
        description: "Rules of the NetGrid Host affiliate program: promotional material requirements, prohibition of spam and misleading claims, reward accrual and payout, and termination of the partnership.",
        keywords: "affiliate program rules, referral program terms, affiliate terms, hosting affiliate rules"
      },
      legal: {
        title: "Legal Information | NetGrid Host",
        description: "All legal documents of NetGrid Host Ltd in one place: terms of service, privacy policy, refund policy, cookie policy, affiliate program rules and sanctions compliance.",
        keywords: "legal information, legal documents, terms of service, privacy policy, refund policy, cookie policy, sanctions compliance"
      },
      compliance: {
        title: "Sanctions Compliance | NetGrid Host",
        description: "How NetGrid Host Ltd complies with UK (OFSI), EU, US (OFAC) and UN sanctions regimes, the list of restricted jurisdictions, and how we verify the location of our customers.",
        keywords: "sanctions compliance, restricted jurisdictions, OFSI, OFAC, sanctions policy, hosting compliance"
      },
      affiliate: {
        title: "Partners - Earn 20% Commission | NetGrid Host VPS Partners",
        description: "Join NetGrid Host's affiliate program and earn 20% commission with no time limit on every VPS or VPN sale. Best hosting affiliate rates in the industry. Withdraw earnings in USDT TRC20 within 24 hours. Start earning with our VPS & VPN affiliate program today!",
        keywords: "VPS affiliate program, VPN affiliate program, VPS hosting affiliate, VPN hosting affiliate, hosting affiliate program, VPS affiliate commission, VPN affiliate commission, earn money with VPS affiliate, earn money with VPN affiliate, passive income VPS, passive income VPN, 20% commission, VPS affiliate partnership, USDT affiliate payout, VPS referral program, VPN referral program, hosting affiliate network"
      },
      netherlands: {
        title: "VPS Netherlands - VPS Hosting in Meppel | NetGrid Host",
        description: "VPS hosting in Netherlands (Meppel). Enterprise-grade infrastructure with 1Gbps port, NVMe SSD, unlimited traffic. EU data protection, 99.9% uptime. Deploy VPS in Netherlands today!",
        keywords: "VPS Netherlands, VPS Нидерланды, Netherlands VPS hosting, Meppel datacenter, EU VPS hosting, Netherlands server, Dutch VPS, VPS Holland, Netherlands dedicated server, European VPS"
      },
      germany: {
        title: "VPS Germany - Dusseldorf VPS Hosting | NetGrid Host",
        description: "VPS hosting in Germany (Dusseldorf). Direct connection to DE-CIX, Europe's largest internet exchange. Enterprise NVMe SSD, 1Gbps port, 99.9% uptime. Deploy your German VPS server today!",
        keywords: "VPS Germany, VPS Dusseldorf, German VPS hosting, DE-CIX datacenter, Dusseldorf VPS, Germany server, VPS Deutschland, European VPS, Germany dedicated server"
      },
      poland: {
        title: "VPS Poland - Gdansk VPS Hosting | NetGrid Host",
        description: "VPS hosting in Poland (Gdansk). Cost-effective European VPS with premium quality. NVMe SSD, 1Gbps port, Baltic connectivity. Perfect for startups and Eastern European markets.",
        keywords: "VPS Poland, VPS Gdansk, Polish VPS hosting, Gdansk datacenter, Poland VPS server, VPS Polska, Eastern Europe VPS, Baltic VPS, affordable European VPS"
      },
      latvia: {
        title: "VPS Latvia - Riga VPS Hosting | NetGrid Host",
        description: "VPS hosting in Latvia (Riga). Premium Baltic connectivity, enterprise NVMe SSD, 1Gbps port. EU data protection, low latency to Northern Europe. Deploy VPS in Riga today!",
        keywords: "VPS Latvia, VPS Riga, Latvian VPS hosting, Riga datacenter, Latvia VPS server, Baltic VPS hosting, Riga VPS, EU VPS, Northern Europe VPS"
      },
      romania: {
        title: "VPS Romania - Bucharest VPS Hosting | NetGrid Host",
        description: "VPS hosting in Romania (Bucharest). Premium Southeast Europe connectivity, enterprise NVMe SSD, 1Gbps port. EU data protection, low latency. Deploy VPS in Bucharest today!",
        keywords: "VPS Romania, VPS Bucharest, Romanian VPS hosting, Bucharest datacenter, Romania VPS server, Southeast Europe VPS, Bucharest VPS, EU VPS, Romanian hosting"
      },
      snapshots: {
        title: "VPS Snapshots — one-click restore points | NetGrid Host",
        description: "Capture your whole VPS in one click and roll back in minutes after a bad update, hack or mistake. Snapshots cost 30% of the VPS monthly price.",
        keywords: "VPS snapshot, server snapshot, restore point, VPS backup, rollback VPS, NetGrid Host snapshot"
      },
      api: {
        title: "Developer API — NetGrid Host VPS REST API",
        description: "Manage VPS programmatically with the NetGrid Host REST API: create, reinstall, reboot servers, list plans, OS and datacenters. Bearer auth and IP allowlist.",
        keywords: "VPS API, server API, REST API hosting, NetGrid Host API, create VPS API, reseller API"
      },
      ukraine: {
        title: "VPS Ukraine - Kyiv VPS Hosting | NetGrid Host",
        description: "VPS hosting in Ukraine (Kyiv). Low latency across Ukraine, NVMe SSD, 1 Gbps port, DDoS protection. Deploy in 60 seconds.",
        keywords: "VPS Ukraine, Kyiv VPS, Ukraine hosting"
      },
      italy: {
        title: "VPS Italy - Milan VPS Hosting | NetGrid Host",
        description: "VPS hosting in Italy (Milan). Premium Southern Europe connectivity, enterprise NVMe SSD, 1Gbps port. EU data protection, low latency. Deploy VPS in Milan today!",
        keywords: "VPS Italy, VPS Milan, Italian VPS hosting, Milan datacenter, Italy VPS server, Southern Europe VPS, Milan VPS, EU VPS, Italian hosting"
      },
      switzerland: {
        title: "VPS Switzerland - Geneva Premium VPS Hosting | NetGrid Host",
        description: "Premium VPS hosting in Switzerland (Geneva). Swiss quality, banking-grade security, 1Gbps network. Swiss privacy laws, 99.99% uptime. Deploy in Geneva today!",
        keywords: "VPS Switzerland, VPS Geneva, Swiss VPS hosting, Geneva datacenter, Switzerland VPS server, Swiss hosting, premium VPS, secure VPS, Geneva VPS, Swiss privacy"
      },
      usa: {
        title: "VPS USA - Los Angeles VPS Hosting | NetGrid Host",
        description: "Premium VPS hosting in USA (Los Angeles). World-class connectivity, enterprise infrastructure, 100Gbps network. SOC 2 certified, sub-5ms US latency. Deploy in LA today!",
        keywords: "VPS USA, VPS Los Angeles, American VPS hosting, LA datacenter, USA VPS server, Los Angeles VPS, West Coast hosting, US VPS, California VPS, LA hosting"
      },
      czechia: {
        title: "VPS Czech Republic - Prague VPS Hosting | NetGrid Host",
        description: "VPS hosting in Czech Republic (Prague). Central European hub with NIX.CZ peering, 1Gbps port, NVMe SSD, 99.9% uptime. EU GDPR compliant. Deploy VPS in Prague!",
        keywords: "VPS Czech Republic, VPS Prague, Czech VPS hosting, Prague datacenter, Czechia VPS server, Central Europe VPS, NIX.CZ, EU VPS, Prague hosting"
      },
      miami: {
        title: "VPS Miami - Florida VPS Hosting | NetGrid Host",
        description: "VPS hosting in Miami, Florida. Strategic gateway to Latin America and Caribbean. 1Gbps port, NVMe SSD, 99.9% uptime. Deploy your Miami VPS today!",
        keywords: "VPS Miami, VPS Florida, Miami VPS hosting, Florida datacenter, Miami VPS server, Southeast US hosting, Latin America VPS, Caribbean hosting, Miami hosting"
      },
      vpn: {
        title: "Personal VPN with dedicated IP — WireGuard, OpenVPN, AmneziaVPN, XRay VLESS | NetGrid Host",
        description: "Run your own private VPN on a dedicated IP that nobody else uses. WireGuard, OpenVPN, AmneziaVPN and XRay VLESS support. 13 locations, unlimited traffic, plans from €6/month.",
        keywords: "personal VPN, dedicated IP VPN, WireGuard VPN hosting, OpenVPN hosting, AmneziaVPN, XRay VLESS, private VPN server, VPN with own IP, NetGrid Host VPN"
      },
      wiki: {
        title: "Knowledge base — VPS hosting explained | NetGrid Host",
        description: "Plain-English deep-dives on how VPS hosting actually works: shared bandwidth, fair use, billing, OS templates, network policy. The details most providers leave unsaid.",
        keywords: "VPS knowledge base, VPS wiki, shared port explained, VPS bandwidth, fair use policy, VPS hosting docs"
      },
      "wiki-shared-1gbps-port-explained": {
        title: "How shared 1 Gbps ports work in VPS hosting | NetGrid Host",
        description: "Why every VPS provider sells 1 Gbps but never delivers a dedicated gigabit 24/7. Honest explanation of shared ports, oversubscription, burst vs sustained, and fair-use throttling.",
        keywords: "shared 1 Gbps port, VPS bandwidth explained, oversubscription, burst rate, sustained bandwidth, fair use VPS, traffic shaping"
      },
      "wiki-internet-speed-explained": {
        title: "Internet speed on a VPS, honestly explained | NetGrid Host",
        description: "1 Gbps on your VPS port isn't 1 Gbps to your home. What your speedtest actually measures, why VPNs typically lose speed, what dedicated bandwidth between two cities really costs.",
        keywords: "VPS internet speed, VPN speed loss, public internet, dedicated bandwidth cost, iperf3, speedtest, latency, packet loss, RTT, peering, fair use"
      },
      "wiki-throttling-explained": {
        title: "Throttling on VPS, plainly explained — the awkward question every provider dodges | NetGrid Host",
        description: "Every VPS provider on the planet throttles sustained traffic on entry-tier plans — almost none admit it on the landing page. Plain-English: why €2.98 can't include permanent 1 Gbps, when our shaper kicks in, and how to tell whether throttling is what you're seeing or something else.",
        keywords: "throttling, traffic shaping, fair use, VPS bandwidth, sustained traffic, rate limit, oversubscription, shared port, speedtest accuracy, repeated speed measurement"
      },
      "wiki-ip-geolocation-explained": {
        title: "IP geolocation explained — why your VPS may show up in the wrong country | NetGrid Host",
        description: "An IP address has no built-in country. Geolocation is a third-party guess from private databases that update at very different speeds. How it really works, what we do every time we add a new IP block, and why a fresh server may show up in the wrong country for the first 2 weeks.",
        keywords: "IP geolocation, GeoIP, MaxMind, IPinfo, DB-IP, IP2Location, Ipregistry, IPGeolocation, GeoMyIP, WHOIS, BGP, geolocation accuracy, VPS country wrong"
      },
      "wiki-firewall-and-ports-explained": {
        title: "Open ports, firewalls and 'why my port shows closed' on a VPS | NetGrid Host",
        description: "Every TCP/UDP port on your VPS is open by default — except SMTP. If an external port checker says 'closed', the issue is inside the VM: nothing listening, the wrong firewall is on, or the service is bound to localhost. How to diagnose each case in under a minute.",
        keywords: "open port VPS, firewall VPS, port closed from outside, ufw, iptables, nftables, firewalld, ss, netstat, SMTP block, port 25, listen 0.0.0.0, listen 127.0.0.1, port checker"
      },
      "wiki-essential-linux-diagnostics": {
        title: "Essential Linux server diagnostics — daily commands cheatsheet | NetGrid Host",
        description: "Copy-pasteable cheatsheet of every Linux VPS admin's daily commands: system info, CPU/RAM, disk, network, ping, mtr, speedtest, listening ports, firewall, logs. Install commands tabbed by Ubuntu/Debian and RHEL/Rocky/AlmaLinux.",
        keywords: "Linux diagnostics, VPS commands cheatsheet, htop install, mtr install, ping, traceroute, ss netstat, df du, free, journalctl, dig, iperf3, speedtest, smartctl, ufw firewalld"
      },
      "wiki-launch-website-quick-start": {
        title: "Launch a website on a VPS in 30 minutes — domain, Cloudflare, free SSL & DDoS | NetGrid Host",
        description: "Cheapest fast path to a live HTTPS website in 2026: GoDaddy domain, Cloudflare for free SSL + DDoS, NetGrid Host VPS. Step-by-step with ready commands for HTML, PHP, Python and Node.js.",
        keywords: "deploy website VPS, GoDaddy Cloudflare VPS, free SSL website, Cloudflare DDoS free, A record VPS, nginx setup, LEMP, gunicorn nginx, pm2 nginx, Origin SSL, Full strict"
      },
      "wiki-wireguard-vpn-setup": {
        title: "Set up your own WireGuard VPN on a VPS — one script, five minutes | NetGrid Host",
        description: "WireGuard is the modern, fast, in-kernel VPN protocol replacing OpenVPN. Set up a personal VPN on any NetGrid Host VPS with a single command. Installer creates server, first user, prints QR code in the terminal for the WireGuard mobile app.",
        keywords: "WireGuard setup, WireGuard VPS, WireGuard install script, WireGuard vs OpenVPN, personal VPN, self-hosted VPN, WireGuard QR code, WireGuard config, wg0.conf"
      },
      "wiki-crypto-payment-exact-amount": {
        title: "Paying with crypto: why the amount must match to the last digit | NetGrid Host",
        description: "Our crypto gateway identifies your payment by its exact amount. Send a different sum — even one digit off — and the payment cannot be matched and is lost. Why it works this way and how to pay safely from an exchange via your own wallet (SafePal).",
        keywords: "crypto payment, exact amount, USDT TRC-20, Bitcoin payment, underpaid invoice, exchange withdrawal fee, SafePal, VPS hosting crypto",
      },
      bulgaria: {
        title: "VPS Bulgaria — Sofia VPS Hosting | NetGrid Host",
        description: "VPS hosting in Sofia, Bulgaria. Balkan crossroads with BIX.BG peering, single-AS reach to Istanbul, Bucharest, Athens. NVMe SSD, 1 Gbps port, 99.9% uptime, EU GDPR.",
        keywords: "VPS Bulgaria, VPS Sofia, Bulgarian VPS hosting, Sofia datacenter, BIX.BG, Balkan hosting, EU VPS, Sofia VPS server, Eastern Europe VPS"
      },
      greece: {
        title: "VPS Greece — Thessaloniki VPS Hosting | NetGrid Host",
        description: "VPS hosting in Thessaloniki, Greece. Mediterranean data port with GR-IX peering and submarine cable landings. NVMe SSD, 1 Gbps port, low latency to Athens, Cyprus, the Levant.",
        keywords: "VPS Greece, VPS Thessaloniki, Greek VPS hosting, Thessaloniki datacenter, GR-IX, Mediterranean VPS, Athens VPS, Greece VPS server, Cyprus hosting"
      },
      spain: {
        title: "VPS Spain — Barcelona VPS Hosting | NetGrid Host",
        description: "VPS hosting in Barcelona, Spain. CATNIX peering, MAREA / 2Africa submarine cable landings. NVMe SSD, 1 Gbps port, 99.9% uptime. Sub-4 ms to Madrid, EU GDPR compliant.",
        keywords: "VPS Spain, VPS Barcelona, Spanish VPS hosting, Barcelona datacenter, CATNIX, Madrid VPS, Iberian VPS, Spain VPS server, Mediterranean hosting"
      },
    },
    affiliate: {
      hero: {
        badge: "Industry-Leading Commission Rates",
        title: "Earn 20% Commission",
        subtitle: "Join the most profitable affiliate program in the hosting industry — covering both VPS and VPN. Earn generous commissions with no time limit on every sale and renewal. Get paid in USDT within 24 hours. Start your VPS & VPN affiliate partnership today.",
        joinNow: "Join Affiliate Program",
        learnMore: "Learn More"
      },
      stats: {
        commission: "20%",
        commissionLabel: "Commission Rate",
        duration: "Unlimited",
        durationLabel: "Cookie Duration",
        payout: "24 Hours",
        payoutLabel: "Fast Payout",
        minimum: "€50",
        minimumLabel: "Minimum Withdrawal"
      },
      why: {
        title: "Why Choose NetGrid Host's VPS & VPN Affiliate Program?",
        subtitle: "Industry-leading commissions on both VPS and VPN sales, with unmatched benefits for our affiliate partners",
        commission: {
          title: "20% on VPS & VPN",
          desc: "Earn 20% commission on every VPS or VPN sale and renewal — same rate, no time limit. Best affiliate rates in the hosting industry."
        },
        duration: {
          title: "Unlimited Cookie Duration",
          desc: "Your VPS affiliate referral link stays active with no time limit. Maximum conversion potential for VPS hosting sales."
        },
        renewals: {
          title: "Recurring VPS Revenue",
          desc: "Earn commission on every renewal — VPS or VPN — with no time limit. Build sustainable passive income with our affiliate program."
        },
        payout: {
          title: "Fast USDT Affiliate Payouts",
          desc: "Withdraw your VPS affiliate earnings to USDT TRC20 within 24 hours on business days."
        }
      },
      howItWorks: {
        title: "How VPS Affiliate Program Works",
        subtitle: "Start earning with VPS affiliate program in 4 simple steps",
        step1: {
          title: "Register for VPS Affiliate",
          desc: "Sign up for free VPS affiliate program and get your unique VPS referral link instantly"
        },
        step2: {
          title: "Promote VPS & VPN",
          desc: "Share your affiliate link (covers both VPS and VPN) with your audience through website, blog, or social media"
        },
        step3: {
          title: "Earn Commissions",
          desc: "Receive 20% commission on every VPS or VPN sale with no time limit, renewals included"
        },
        step4: {
          title: "Withdraw Earnings",
          desc: "Request VPS affiliate payout to USDT TRC20. Processed within 24 hours on business days"
        }
      },
      comparison: {
        title: "Compare Hosting Affiliate Programs",
        subtitle: "See why NetGrid Host offers the best affiliate deal in the hosting industry — for both VPS and VPN",
        tableHeaders: {
          program: "Program",
          commission: "Commission",
          cookie: "Cookie Duration",
          renewals: "Renewals",
          payout: "Payout Method",
          speed: "Payout Speed"
        },
        netgrid: "NetGrid Host",
        competitor1: "Competitor A",
        competitor2: "Competitor B",
        competitor3: "Competitor C",
        yes: "Yes (unlimited)",
        limited: "Limited (3 months)",
        no: "No",
        months: "months",
        days: "days",
        hours: "24 hours",
        slowPayout: "5-7 days",
        verySlow: "7-14 days"
      },
      terms: {
        title: "VPS Affiliate Payment Terms",
        withdrawalTitle: "VPS Affiliate Withdrawal",
        accrualTitle: "VPS Commission Accrual",
        minimum: "Minimum VPS affiliate withdrawal: €50",
        fee: "Withdrawal fee: €3 (converted at current rate)",
        method: "VPS affiliate payment method: USDT TRC20",
        timing: "Processing time: Within 24 hours on business days (Mon-Fri)",
        monthlyAccrual: "VPS affiliate commissions are credited on the 1st of each month",
        commission60: "Earn 20% commission from every VPS or VPN purchase",
        renewals12: "Earn commission from every VPS or VPN renewal with no time limit",
        realtime: "Track your VPS affiliate earnings in real-time dashboard",
        support: "Need help? Contact our VPS affiliate support team"
      },
      form: {
        title: "Register as Affiliate Partner",
        subtitle: "Fill out the form below to join our affiliate program",
        name: "Full Name",
        email: "Email Address",
        website: "Website/Social Media URL",
        experience: "Affiliate Experience",
        experienceOptions: {
          beginner: "Beginner (0-1 year)",
          intermediate: "Intermediate (1-3 years)",
          expert: "Expert (3+ years)"
        },
        traffic: "Monthly Traffic/Audience Size",
        message: "Tell us about your promotion strategy (optional)",
        agreement: "I agree to the Affiliate Program Terms and Conditions",
        submit: "Submit Application",
        submitting: "Submitting...",
        successMessage: "Application submitted! We'll review and contact you within 24 hours."
      },
      cta: {
        title: "Ready to Start Earning with Our Affiliate Program?",
        subtitle: "Join thousands of affiliate partners earning passive income with NetGrid Host — both VPS and VPN sales pay the same 20% commission",
        button: "Join Affiliate Program"
      }
    },
    netherlands: {
      seo: {
        title: "VPS Netherlands - VPS Hosting in Meppel | NetGrid Host",
        description: "VPS hosting in Netherlands (Meppel). Enterprise-grade infrastructure with 1Gbps port, NVMe SSD, unlimited traffic. EU data protection, 99.9% uptime. Deploy your VPS in Netherlands today!",
        keywords: "VPS Netherlands, VPS Нидерланды, Netherlands VPS hosting, Meppel datacenter, EU VPS hosting, Netherlands server, Dutch VPS, VPS Holland, Netherlands dedicated server, European VPS"
      },
      hero: {
        badge: "Netherlands Datacenter - Meppel",
        title: "VPS Hosting in Netherlands",
        subtitle: "Deploy your VPS in Netherlands (Meppel) with lightning-fast 1Gbps connectivity, EU data protection, and 99.9% uptime guarantee. Perfect location for European and global projects.",
        getStarted: "Get Started",
        viewPricing: "View Pricing"
      },
      stats: {
        uptime: "99.9%",
        uptimeLabel: "Guaranteed Uptime",
        speed: "1 Gbps",
        speedLabel: "Network Speed",
        traffic: "Unlimited",
        trafficLabel: "Data Transfer",
        location: "Meppel",
        locationLabel: "Netherlands City"
      },
      why: {
        title: "Why Choose VPS in Netherlands?",
        subtitle: "Netherlands offers the best infrastructure for VPS hosting in Europe",
        privacy: {
          title: "EU Data Protection",
          desc: "Strict European Union privacy laws (GDPR) ensure maximum data protection and anonymity for your VPS in Netherlands."
        },
        infrastructure: {
          title: "World-Class Infrastructure",
          desc: "Netherlands has one of the best internet infrastructures globally. Most VPN services and major websites choose Netherlands for superior connectivity."
        },
        speed: {
          title: "Ultra-Fast Connectivity",
          desc: "Direct connection to major European internet exchange points (AMS-IX). 1Gbps port with unlimited traffic for your VPS Netherlands."
        },
        location: {
          title: "Strategic European Location",
          desc: "Meppel datacenter provides excellent connectivity to all of Europe with low latency to major cities across EU."
        }
      },
      features: {
        title: "VPS Netherlands Technical Specifications",
        subtitle: "Enterprise-grade VPS hosting in Netherlands with advanced features",
        nvme: {
          title: "NVMe SSD Storage",
          desc: "Ultra-fast NVMe drives provide 10x better performance than traditional SSD for your VPS Netherlands"
        },
        network: {
          title: "1Gbps Network Port",
          desc: "Shared 1 Gigabit connection with unlimited bandwidth for your Netherlands VPS server"
        },
        traffic: {
          title: "Unlimited Traffic",
          desc: "No bandwidth limits - use as much data transfer as you need for your VPS in Netherlands"
        },
        uptime: {
          title: "99.9% Uptime SLA",
          desc: "Guaranteed uptime backed by redundant infrastructure in our Netherlands datacenter"
        }
      },
      payment: {
        title: "Flexible Payment Methods",
        subtitle: "We accept multiple payment options for VPS Netherlands",
        methods: "Credit Cards, PayPal, Cryptocurrencies (Bitcoin, USDT), Bank Transfer"
      },
      location: {
        title: "Datacenter Location: Meppel, Netherlands",
        subtitle: "Our Netherlands datacenter is located in Meppel, providing excellent connectivity across Europe",
        about: "Meppel is strategically located in the northeastern Netherlands, offering direct fiber connections to Amsterdam Internet Exchange (AMS-IX) and other major European hubs. This location ensures low latency and high-speed connectivity for your VPS Netherlands hosting.",
        benefits: [
          "Direct connection to AMS-IX (Amsterdam)",
          "Low latency across Europe (5-15ms)",
          "Redundant power and cooling",
          "24/7 security and monitoring",
          "EU-compliant datacenter infrastructure"
        ]
      },
      cta: {
        title: "Ready to Deploy Your VPS in Netherlands?",
        subtitle: "Get started with VPS hosting in Netherlands (Meppel) today",
        button: "Order VPS Netherlands"
      },
      pricing: {
        title: "VPS Netherlands Plans - VPS Meppel Hosting with 1Gbps Port",
        subtitle: "VPS Netherlands Meppel datacenter with 99.9% uptime SLA, 1Gbps network port, NVMe SSD storage. Netherlands VPS hosting with GDPR compliance for EU projects."
      },
      flipCards: {
        title: "Interactive Features",
        subtitle: "Click cards to discover what makes Netherlands VPS special",
        clickFlip: "Click to flip",
        items: [
          { title: "EU Location", desc: "Netherlands datacenter with good European connectivity" },
          { title: "EU Privacy", desc: "GDPR compliant with Dutch data protection regulations" },
          { title: "Efficient Power", desc: "Energy-efficient datacenter operations" },
          { title: "24/7 Support", desc: "Support team available in English" },
          { title: "Good Latency", desc: "Low latency to Western Europe including UK, Germany, France" },
          { title: "DDoS Protection", desc: "Basic DDoS protection included with all plans" }
        ]
      },
      masonry: {
        title: "Why Netherlands?",
        subtitle: "Discover the advantages of Dutch VPS hosting",
        items: [
          { title: "EU Datacenter", desc: "Professional datacenter in Netherlands", badge: "Infrastructure" },
          { title: "Privacy Compliant", desc: "GDPR and EU data protection compliance", badge: "Privacy" },
          { title: "Good Network", desc: "Reliable network infrastructure", badge: "Connectivity" },
          { title: "European Base", desc: "Good location for European projects", badge: "Location" },
          { title: "Stable Power", desc: "Redundant power with backup systems", badge: "Reliability" },
          { title: "Central Europe", desc: "Access to Western European markets", badge: "Geography" }
        ]
      },
      process: {
        title: "Simple Deployment Process",
        subtitle: "From order to online in 4 easy steps",
        steps: [
          { title: "Choose Plan", desc: "Select VPS specs that fit your needs" },
          { title: "Configure", desc: "Pick OS and add-ons instantly" },
          { title: "Deploy", desc: "Automated deployment in 60 seconds" },
          { title: "Launch", desc: "Your VPS is ready to use!" }
        ]
      },
      comparison: {
        title: "Netherlands vs Others",
        subtitle: "See why NetGrid Host Netherlands stands out",
        feature: "Feature",
        netgrid: "NetGrid NL",
        others: "Others",
        items: [
          { feature: "NVMe Storage", netgrid: "Yes", others: "SSD or HDD" },
          { feature: "Setup Time", netgrid: "< 60 seconds", others: "Hours" },
          { feature: "DDoS Protection", netgrid: "Included", others: "Extra cost" },
          { feature: "Backup Options", netgrid: "Available", others: "Limited" },
          { feature: "GDPR Compliant", netgrid: "Yes", others: "Varies" },
          { feature: "24/7 Support", netgrid: "Included", others: "Business hours" }
        ]
      }
    },
    germany: {
      hero: {
        badge: "Dusseldorf Datacenter - DE-CIX Connected",
        title: "Premium VPS Hosting in Germany",
        subtitle: "Launch your VPS in Dusseldorf with direct DE-CIX connectivity, German data protection standards, and lightning-fast performance. The ultimate choice for European business applications.",
        getStarted: "Deploy Now",
        viewPlans: "View Plans"
      },
      stats: {
        latency: "<2ms",
        latencyLabel: "DE-CIX Latency",
        speed: "1 Gbps",
        speedLabel: "Network Port",
        uptime: "99.9%",
        uptimeLabel: "Uptime SLA",
        exchange: "DE-CIX",
        exchangeLabel: "Internet Exchange"
      },
      why: {
        title: "Why Choose VPS Hosting in Germany?",
        subtitle: "Germany offers unmatched infrastructure and connectivity for mission-critical applications",
        decix: {
          title: "DE-CIX Dusseldorf Hub",
          desc: "Direct connection to DE-CIX, the world's largest internet exchange by data throughput. Your VPS Germany benefits from unparalleled global connectivity and minimal latency."
        },
        dataProtection: {
          title: "German Data Protection",
          desc: "Benefit from Germany's strict data protection laws and GDPR compliance. Perfect for financial services, healthcare, and enterprise applications requiring maximum security."
        },
        centralLocation: {
          title: "Heart of Europe",
          desc: "Dusseldorf's strategic location provides optimal connectivity across Europe, Russia, and Middle East. Ideal latency for serving international audiences."
        },
        financial: {
          title: "Business Hub Hosting",
          desc: "Host in Dusseldorf's thriving business district, one of Germany's leading economic centers. Perfect for corporate applications and international business."
        }
      },
      infrastructure: {
        title: "World-Class Technical Infrastructure",
        subtitle: "Enterprise-grade VPS Germany hosting with cutting-edge technology",
        network: {
          title: "Tier-1 Network Connectivity",
          desc: "Multiple Tier-1 carrier connections and direct DE-CIX peering ensure maximum uptime and redundancy for your Dusseldorf VPS"
        },
        storage: {
          title: "Enterprise NVMe Arrays",
          desc: "High-performance NVMe SSD storage in RAID10 configuration provides exceptional speed and data protection"
        },
        power: {
          title: "N+1 Power Redundancy",
          desc: "Fully redundant power systems with backup generators ensure your German VPS stays online 24/7"
        },
        cooling: {
          title: "Advanced Cooling Systems",
          desc: "State-of-the-art cooling infrastructure maintains optimal temperatures for peak VPS performance"
        }
      },
      useCases: {
        title: "Perfect VPS Germany Solutions For",
        subtitle: "Discover how businesses leverage our Dusseldorf VPS hosting",
        ecommerce: {
          title: "E-Commerce Platforms",
          desc: "Fast page loads across Europe with Dusseldorf hosting. Perfect for online stores targeting EU customers with GDPR compliance built-in."
        },
        fintech: {
          title: "Financial Applications",
          desc: "Ultra-low latency for trading platforms and fintech apps. Host in Germany's business capital with maximum security."
        },
        gaming: {
          title: "Game Servers",
          desc: "Excellent connectivity for European game servers. Low ping times across entire continent for optimal gaming experience."
        },
        saas: {
          title: "SaaS Applications",
          desc: "Reliable hosting for SaaS platforms serving European clients. German infrastructure ensures data sovereignty compliance."
        }
      },
      location: {
        title: "Dusseldorf Datacenter Location",
        subtitle: "Strategic positioning in Germany's business and tech hub",
        about: "Our Dusseldorf datacenter is strategically located in one of Germany's most important business centers, with direct connectivity to DE-CIX - the world's premier internet exchange point. This location offers unmatched peering opportunities and ensures your VPS Germany hosting delivers exceptional performance across Europe, Russia, Middle East, and beyond.",
        benefits: [
          "Direct DE-CIX Dusseldorf peering",
          "Multiple Tier-1 carrier connections",
          "Sub-2ms latency to major exchanges",
          "ISO 27001 certified facility",
          "German Tier III+ datacenter standards"
        ]
      },
      cta: {
        title: "Ready to Deploy Your VPS in Germany?",
        subtitle: "Experience premium Dusseldorf VPS hosting with enterprise-grade infrastructure",
        button: "Get Started Now"
      },
      pricing: {
        title: "VPS Germany Plans - VPS Dusseldorf Hosting with 1Gbps Port",
        subtitle: "VPS Germany Dusseldorf datacenter with 99.9% uptime SLA, 1Gbps network port, NVMe SSD storage. German VPS hosting with GDPR compliance."
      }
    },
    poland: {
      hero: {
        badge: "Gdansk Datacenter - Baltic Sea Hub",
        title: "Cost-Effective VPS Hosting in Poland",
        subtitle: "Launch your VPS in Gdansk with European quality at competitive prices. Perfect for startups, Eastern European markets, and businesses seeking value without compromise.",
        getStarted: "Start Now",
        viewPlans: "View Plans"
      },
      stats: {
        price: "40%",
        priceLabel: "Lower Cost",
        speed: "1 Gbps",
        speedLabel: "Network Port",
        uptime: "99.9%",
        uptimeLabel: "Uptime SLA",
        location: "Gdansk",
        locationLabel: "Tech Hub"
      },
      costEffective: {
        title: "European Quality, Competitive Pricing",
        subtitle: "Get premium VPS hosting without the premium price tag",
        value: {
          title: "Best Value in Europe",
          desc: "Up to 40% lower costs compared to Western European datacenters while maintaining the same enterprise-grade infrastructure and performance standards."
        },
        quality: {
          title: "No Compromise on Quality",
          desc: "Same NVMe SSD storage, redundant network, and 24/7 monitoring as our premium locations. European data protection standards fully maintained."
        },
        market: {
          title: "Perfect for Growing Markets",
          desc: "Ideal positioning for serving Eastern European, Baltic, and Scandinavian customers. Low latency across the entire region."
        },
        startup: {
          title: "Startup-Friendly Infrastructure",
          desc: "Launch your business with minimal investment. Scale as you grow without breaking the bank. Perfect for bootstrapped startups and MVPs."
        }
      },
      techHub: {
        title: "Gdansk: Poland's Rising Tech Hub",
        subtitle: "Why choose VPS hosting in Gdansk",
        itCenter: {
          title: "Growing IT Center",
          desc: "Gdansk is one of Poland's fastest-growing tech cities, home to numerous software houses, startups, and international tech companies."
        },
        connectivity: {
          title: "Excellent Connectivity",
          desc: "Strategic location on the Baltic Sea with excellent fiber optic connections to Scandinavia, Germany, and Eastern Europe."
        },
        talent: {
          title: "Tech Talent Pool",
          desc: "Access to Poland's strong IT talent pool and growing developer community. Gdansk Technical University is a major tech education hub."
        },
        infrastructure: {
          title: "Modern Infrastructure",
          desc: "State-of-the-art datacenter with Tier III standards, redundant power and cooling, multiple carrier connections for maximum reliability."
        }
      },
      startups: {
        title: "Perfect VPS Poland Solutions For Startups",
        subtitle: "Launch and scale your business with confidence",
        mvp: {
          title: "MVP Development",
          desc: "Test your ideas without huge upfront costs. Our affordable Gdansk VPS hosting lets you validate your product quickly and efficiently."
        },
        saas: {
          title: "SaaS Platforms",
          desc: "Build and grow your SaaS business with scalable VPS infrastructure. European location ensures GDPR compliance for EU customers."
        },
        agencies: {
          title: "Web Agencies",
          desc: "Host multiple client websites on reliable infrastructure. Competitive pricing means better margins for your agency."
        },
        ecommerce: {
          title: "E-Commerce Stores",
          desc: "Fast loading times for Polish and Eastern European customers. Cost-effective hosting for online stores targeting regional markets."
        }
      },
      location: {
        title: "Gdansk Datacenter Location",
        subtitle: "Strategic positioning on the Baltic Sea coast",
        about: "Our Gdansk datacenter is strategically located in Poland's major port and tech city. This prime Baltic Sea location offers excellent connectivity to Northern and Eastern Europe, making it ideal for businesses targeting these rapidly growing markets. Combined with competitive pricing, it's the perfect choice for startups and cost-conscious businesses seeking European quality.",
        benefits: [
          "Tier III datacenter standards",
          "Multiple carrier connections",
          "Low latency to Baltic and Eastern Europe",
          "EU data protection compliance",
          "40% lower costs vs Western Europe"
        ]
      },
      cta: {
        title: "Ready to Launch Your VPS in Poland?",
        subtitle: "Start with cost-effective Gdansk VPS hosting today",
        button: "Get Started Now"
      },
      pricing: {
        title: "VPS Poland Plans - VPS Gdansk Hosting with 1Gbps Port",
        subtitle: "VPS Poland Gdansk datacenter with 99.9% uptime SLA, 1Gbps network port, NVMe SSD storage. Poland VPS hosting with GDPR compliance for Central Europe."
      }
    },
    latvia: {
      hero: {
        badge: "Latvia Datacenter - Baltic Gateway",
        title: "VPS Hosting in Latvia",
        subtitle: "Deploy your VPS in Latvia with exceptional Baltic connectivity. Perfect gateway to Northern Europe and Baltic markets with EU data protection standards.",
        getStarted: "Deploy Now",
        viewPlans: "View Plans"
      },
      stats: {
        latency: "<3ms",
        latencyLabel: "Baltic Latency",
        speed: "1 Gbps",
        speedLabel: "Network Port",
        uptime: "99.9%",
        uptimeLabel: "Uptime SLA",
        location: "Latvia",
        locationLabel: "EU Member"
      },
      why: {
        title: "Why Choose Latvia for VPS Hosting?",
        subtitle: "Strategic Baltic location with excellent infrastructure",
        gateway: {
          title: "Gateway to Baltic Region",
          desc: "Latvia's strategic position makes it the perfect gateway to Baltic states, Scandinavia, and Eastern Europe. Excellent fiber connectivity across the region."
        },
        infrastructure: {
          title: "Modern Infrastructure",
          desc: "Enterprise-grade datacenter facilities with latest NVMe storage, redundant power systems, and carrier-neutral connectivity for maximum reliability."
        },
        compliance: {
          title: "EU Data Protection",
          desc: "Full GDPR compliance and EU data protection standards. Ideal for businesses serving European customers with strict privacy requirements."
        },
        connectivity: {
          title: "Superior Connectivity",
          desc: "Multiple Tier-1 carrier connections and direct peering ensure low latency to Northern Europe, Baltic region, and Scandinavia."
        }
      },
      technical: {
        title: "Reliable Technical Infrastructure",
        subtitle: "Latvia datacenter with modern technology stack",
        network: {
          title: "Redundant Network",
          desc: "Multiple upstream providers and BGP routing ensure maximum uptime and failover capabilities for your Latvia VPS"
        },
        storage: {
          title: "NVMe SSD Performance",
          desc: "Latest generation NVMe SSD arrays deliver exceptional I/O performance for demanding applications"
        },
        power: {
          title: "Redundant Power Systems",
          desc: "N+1 power redundancy with UPS backup and diesel generators guarantee continuous operation"
        },
        monitoring: {
          title: "24/7 Monitoring",
          desc: "Round-the-clock infrastructure monitoring and support ensure your VPS stays online and performs optimally"
        }
      },
      useCases: {
        title: "VPS Latvia Use Cases",
        subtitle: "Ideal applications for Latvia VPS hosting",
        regional: {
          title: "Regional Services",
          desc: "Serve Baltic and Nordic customers with local presence. Optimal latency for Estonia, Lithuania, Finland, and Sweden."
        },
        fintech: {
          title: "Financial Services",
          desc: "Leverage Latvia's growing fintech sector. Compliant infrastructure for payment processing and financial applications."
        },
        media: {
          title: "Media & Streaming",
          desc: "High-bandwidth connectivity perfect for media delivery, streaming services, and content distribution networks."
        },
        business: {
          title: "Business Applications",
          desc: "Host CRM, ERP, and business software with reliable infrastructure and EU data residency for compliance."
        }
      },
      location: {
        title: "Latvia Datacenter Location",
        subtitle: "Strategic Baltic region positioning",
        about: "Our Latvia datacenter is strategically positioned in the Baltic region, a key hub for connectivity across Northern and Eastern Europe. Latvia offers excellent infrastructure and serves as a natural gateway to European markets. The location provides optimal connectivity to Estonia, Lithuania, Finland, Sweden, and Poland, making it ideal for businesses targeting Baltic and Nordic regions.",
        benefits: [
          "Premium Tier III datacenter facility",
          "Multiple international carrier connections",
          "Low latency to Baltic states and Scandinavia",
          "Full EU GDPR compliance",
          "Strategic gateway to Northern Europe"
        ]
      },
      cta: {
        title: "Ready to Deploy VPS in Latvia?",
        subtitle: "Start with reliable Latvia VPS hosting today",
        button: "Get Started Now"
      },
      pricing: {
        title: "VPS Latvia Plans - VPS Riga Hosting with 1Gbps Port",
        subtitle: "VPS Latvia Riga datacenter with 99.9% uptime SLA, 1Gbps network port, NVMe SSD storage. Latvia VPS hosting with GDPR compliance for Baltic region."
      }
    },
    romania: {
      hero: {
        badge: "Romania Datacenter - Southeast Europe Hub",
        title: "VPS Romania Bucharest",
        subtitle: "Deploy VPS in Romania Bucharest datacenter with 1Gbps port and EU compliance. VPS Bucharest for Southeast Europe connectivity.",
        getStarted: "Deploy Now",
        viewPlans: "View Plans"
      },
      stats: {
        latency: "<3ms",
        latencyLabel: "Regional Latency",
        speed: "1 Gbps",
        speedLabel: "Network Port",
        uptime: "99.9%",
        uptimeLabel: "Uptime SLA",
        location: "Bucharest",
        locationLabel: "Location"
      },
      why: {
        title: "Why Choose Romania VPS?",
        subtitle: "Strategically located in Bucharest, our Romanian datacenter offers exceptional value and performance",
        gateway: {
          title: "Southeast Europe Gateway",
          desc: "Perfect location for serving Romania, Bulgaria, Moldova, Ukraine and entire Southeast European region with low latency."
        },
        infrastructure: {
          title: "Modern Infrastructure",
          desc: "State-of-the-art datacenter with enterprise-grade hardware, redundant power, and advanced cooling systems."
        },
        compliance: {
          title: "EU Data Protection",
          desc: "Full compliance with EU regulations including GDPR. Your data is protected by European data protection standards."
        },
        connectivity: {
          title: "Premium Connectivity",
          desc: "Multiple Tier-1 carriers ensure excellent connectivity throughout Europe and beyond with low latency routes."
        }
      },
      features: {
        title: "Romania VPS Features",
        subtitle: "Enterprise-grade features included with every Romania VPS plan",
        nvme: {
          title: "NVMe SSD Storage",
          desc: "Lightning-fast NVMe storage for maximum performance and reliability."
        },
        security: {
          title: "DDoS Protection",
          desc: "Advanced DDoS protection included to keep your services online."
        },
        deployment: {
          title: "Instant Deployment",
          desc: "Deploy your VPS in under 60 seconds with our automated system."
        },
        backup: {
          title: "Automated Backups",
          desc: "Regular automated backups to protect your data and ensure business continuity."
        },
        network: {
          title: "1Gbps Port",
          desc: "Shared 1 Gigabit port with unlimited traffic for all your needs."
        },
        monitoring: {
          title: "24/7 Monitoring",
          desc: "Round-the-clock monitoring ensures maximum uptime and quick issue resolution."
        }
      },
      infrastructure: {
        title: "State-of-the-Art Datacenter Infrastructure",
        description: "Our Bucharest datacenter features cutting-edge technology and infrastructure designed for maximum performance, reliability, and security. Built to European standards with enterprise-grade components.",
        item1: "Tier III certified datacenter facility with redundant power and cooling systems",
        item2: "Multiple fiber optic connections to major European Internet Exchanges (DE-CIX, AMS-IX)",
        item3: "24/7 on-site security, monitoring, and technical staff for immediate issue resolution",
        item4: "Advanced fire suppression, climate control, and environmental monitoring systems"
      },
      location: {
        title: "Strategic Location in Bucharest",
        description: "Bucharest, Romania's capital and largest city, offers an ideal location for VPS hosting in Southeast Europe. With excellent connectivity to the Balkans, Eastern Europe, and beyond, our datacenter serves as a perfect hub for your applications.",
        subtitle: "Datacenter Location",
        details: "Str. Gara Herăstrău, Bucharest, Romania - Modern datacenter facility in the heart of Romania's technology district",
        benefits: [
          "Direct connectivity to major European and Asian networks",
          "Low latency to Romania, Bulgaria, Moldova, Ukraine, and Turkey",
          "Full EU data protection compliance (GDPR)",
          "Strategic gateway to Southeast European markets",
          "Excellent price-performance ratio compared to Western Europe",
          "Growing tech hub with skilled IT workforce"
        ]
      },
      cta: {
        title: "Ready to Deploy VPS in Romania?",
        subtitle: "Start with reliable Romania VPS hosting today",
        button: "Get Started Now"
      },
      pricing: {
        title: "VPS Romania Plans - VPS Bucharest Hosting with 1Gbps Port",
        subtitle: "VPS Romania Bucharest datacenter with 99.9% uptime SLA, 1Gbps network port, NVMe SSD storage. Romania VPS hosting with GDPR compliance for Southeast Europe."
      }
    },
    italy: {
      hero: {
        badge: "Italy Datacenter - Southern Europe Hub",
        title: "VPS Italy Milan Hosting",
        subtitle: "Deploy VPS in Italy Milan datacenter with 1Gbps port and EU GDPR compliance. VPS Milan for Southern Europe and Mediterranean connectivity.",
        getStarted: "Deploy Now",
        viewPlans: "View Plans"
      },
      stats: {
        latency: "<2ms",
        latencyLabel: "Regional Latency",
        speed: "1 Gbps",
        speedLabel: "Network Port",
        uptime: "99.9%",
        uptimeLabel: "Uptime SLA",
        location: "Milan",
        locationLabel: "Location"
      },
      why: {
        title: "Why Choose Italy VPS?",
        subtitle: "Strategically located in Milan, our Italian datacenter offers exceptional connectivity and performance",
        gateway: {
          title: "Southern Europe Gateway",
          desc: "Perfect location for serving Italy, Switzerland, France, and the entire Mediterranean region with low latency."
        },
        infrastructure: {
          title: "Premium Infrastructure",
          desc: "State-of-the-art Milan datacenter with enterprise-grade hardware, redundant systems, and advanced cooling."
        },
        compliance: {
          title: "EU Data Protection",
          desc: "Full compliance with EU regulations including GDPR. Your data is protected by strict European standards."
        },
        connectivity: {
          title: "World-Class Connectivity",
          desc: "Direct connections to MIX (Milan Internet Exchange) and multiple Tier-1 carriers for optimal performance."
        }
      },
      features: {
        title: "Italy VPS Features",
        subtitle: "Enterprise-grade features included with every Milan VPS plan",
        nvme: {
          title: "NVMe SSD Storage",
          desc: "Lightning-fast NVMe storage for maximum performance and reliability."
        },
        security: {
          title: "DDoS Protection",
          desc: "Advanced DDoS protection included to keep your services online."
        },
        deployment: {
          title: "Instant Deployment",
          desc: "Deploy your VPS in under 60 seconds with our automated system."
        },
        backup: {
          title: "Automated Backups",
          desc: "Regular automated backups to protect your data and ensure business continuity."
        },
        network: {
          title: "1Gbps Port",
          desc: "Shared 1 Gigabit port with unlimited traffic for all your needs."
        },
        monitoring: {
          title: "24/7 Monitoring",
          desc: "Round-the-clock monitoring ensures maximum uptime and quick issue resolution."
        }
      },
      infrastructure: {
        title: "Milan Datacenter Excellence",
        description: "Our Milan datacenter represents the pinnacle of Italian technology infrastructure. Built to the highest European standards with cutting-edge equipment and redundant systems.",
        item1: "Tier III+ certified facility with N+1 redundancy for power and cooling",
        item2: "Direct connection to MIX (Milan Internet Exchange) for optimal European connectivity",
        item3: "24/7 on-site security, monitoring, and technical support team",
        item4: "Advanced climate control and fire suppression systems for maximum uptime"
      },
      location: {
        title: "Milan - Italy's Technology Capital",
        description: "Milan, Italy's financial and technology hub, provides an ideal location for VPS hosting in Southern Europe. Our datacenter benefits from Milan's world-class infrastructure and connectivity.",
        subtitle: "Datacenter Location",
        details: "Via Caldera, Milan, Italy - Premium datacenter in Milan's technology district",
        benefits: [
          "Direct connectivity to Mediterranean and Southern European markets",
          "Low latency to Italy, Switzerland, France, and MENA region",
          "Full EU GDPR compliance",
          "Strategic gateway to Southern Europe and North Africa",
          "Italy's largest Internet Exchange (MIX) connectivity",
          "Fashion, finance, and technology hub with skilled workforce"
        ]
      },
      cta: {
        title: "Ready to Deploy VPS in Italy?",
        subtitle: "Start with reliable Milan VPS hosting today",
        button: "Get Started Now"
      },
      pricing: {
        title: "VPS Italy Plans - VPS Milan Hosting with 1Gbps Port",
        subtitle: "VPS Italy Milan datacenter with 99.9% uptime SLA, 1Gbps network port, NVMe SSD storage. Italy VPS hosting with GDPR compliance for Southern Europe."
      }
    },
    switzerland: {
      hero: {
        badge: "Switzerland Datacenter - Premium Hosting",
        title: "VPS Switzerland Geneva",
        subtitle: "Deploy VPS in Switzerland Geneva datacenter with Swiss privacy laws and GDPR compliance. VPS Geneva with 1Gbps port and reliable European connectivity.",
        getStarted: "Deploy Now",
        viewPlans: "View Plans"
      },
      stats: {
        latency: "<5ms",
        latencyLabel: "Regional Latency",
        speed: "1 Gbps",
        speedLabel: "Network Port",
        uptime: "99.9%",
        uptimeLabel: "Uptime SLA",
        location: "Geneva",
        locationLabel: "Location"
      },
      tabs: {
        title: "Swiss Excellence in Every Aspect",
        subtitle: "Discover what makes Swiss VPS hosting the premium choice",
        features: "Features",
        security: "Security",
        performance: "Performance",
        support: "Support"
      },
      features: {
        items: [
          {
            title: "NVMe SSD Storage",
            desc: "Fast NVMe storage for good performance"
          },
          {
            title: "Good Security",
            desc: "Standard security measures with DDoS protection"
          },
          {
            title: "Quick Deployment",
            desc: "Deploy your VPS in under 60 seconds"
          },
          {
            title: "Automated Backups",
            desc: "Regular backup options available"
          },
          {
            title: "Network",
            desc: "1Gbps connectivity with reliable uptime"
          },
          {
            title: "Swiss Privacy",
            desc: "Swiss data protection laws compliance"
          }
        ]
      },
      security: {
        title: "Swiss Banking-Level Security",
        description: "Our datacenter follows industry standard security practices to keep your data safe.",
        items: [
          "Secure datacenter facility",
          "Standard encryption for data",
          "DDoS protection included",
          "Access control systems",
          "24/7 monitoring",
          "Regular backup options"
        ]
      },
      performance: {
        title: "Swiss Performance Excellence",
        description: "Engineered with Swiss precision for maximum performance and reliability",
        metrics: [
          { value: "99.9%", label: "Uptime SLA" },
          { value: "<5ms", label: "Regional Latency" },
          { value: "1Gbps", label: "Port Speed" },
          { value: "NVMe", label: "SSD Storage" }
        ]
      },
      support: {
        title: "Premium Swiss Support",
        description: "Our expert team provides round-the-clock support with Swiss professionalism and efficiency",
        channels: [
          { name: "24/7 Live Chat", desc: "Instant support from Swiss technical experts" },
          { name: "Priority Email", desc: "Response within 15 minutes guaranteed" },
          { name: "Phone Support", desc: "Direct line to senior engineers" },
          { name: "Dedicated Manager", desc: "Personal account management for enterprise clients" }
        ]
      },
      infrastructure: {
        title: "Swiss Precision Infrastructure",
        subtitle: "Built to the highest Swiss standards",
        item1: {
          title: "Professional Datacenter",
          content: "Our Geneva datacenter follows industry standards with redundant systems. Power backup with generators and UPS ensures reliable 99.9% uptime. The facility has proper cooling and is maintained for stable operations."
        },
        item2: {
          title: "Network Connectivity",
          content: "Good connections to major European networks. 1Gbps port with reliable routing and basic DDoS protection at network level."
        },
        item3: {
          title: "Swiss Data Protection",
          content: "Full compliance with Swiss Federal Data Protection Act (FADP) and EU GDPR. Data sovereignty guaranteed with all data stored exclusively in Switzerland. Regular security audits by independent Swiss security firms. Military-grade encryption for data at rest and in transit."
        },
        item4: {
          title: "Environmental Excellence",
          content: "Powered by 100% renewable Swiss hydroelectric energy. Advanced cooling systems using free cooling technology reduce energy consumption by 40%. Carbon-neutral operations certified by Swiss environmental standards. Heat recovery systems supply local district heating."
        }
      },
      location: {
        title: "Geneva - Global Technology Hub",
        description: "Geneva combines international connectivity with Swiss stability, making it the perfect location for premium VPS hosting. As home to numerous international organizations and a global financial center, Geneva offers unparalleled infrastructure and connectivity.",
        subtitle: "Datacenter Location",
        details: "Chemin des Aulx, Geneva, Switzerland - Ultra-secure facility in Geneva's technology district",
        benefits: [
          "Neutral jurisdiction with strong privacy laws",
          "Direct fiber connections to 50+ countries",
          "Low latency to all major European cities",
          "Political stability and Swiss quality",
          "Home to international organizations (UN, CERN)",
          "Gateway between Northern and Southern Europe"
        ]
      },
      cta: {
        title: "Experience Swiss Excellence",
        subtitle: "Deploy your VPS with Swiss precision today",
        button: "Get Started Now"
      },
      pricing: {
        title: "VPS Switzerland Plans - VPS Geneva Hosting with 1Gbps Port",
        subtitle: "VPS Switzerland Geneva datacenter with 99.9% uptime SLA, 1Gbps network port, NVMe SSD storage. Swiss VPS hosting with GDPR compliance and Swiss privacy laws."
      }
    },
    usa: {
      hero: {
        badge: "USA Datacenter - Los Angeles",
        title: "VPS in USA",
        subtitle: "Deploy VPS in Los Angeles datacenter with 1Gbps port and 99.9% uptime. VPS Los Angeles for US West Coast and Asia-Pacific connectivity.",
        getStarted: "Get Started",
        viewPlans: "View Plans"
      },
      stats: {
        uptimeLabel: "99.9% Uptime SLA",
        latencyLabel: "Regional Latency",
        speedLabel: "1Gbps Network Port",
        customersLabel: "Active Customers"
      },
      bento: {
        title: "Built for Speed & Scale",
        subtitle: "Enterprise-grade infrastructure designed for American businesses",
        items: [
          {
            title: "Los Angeles Datacenter",
            desc: "Reliable facility in LA with good connectivity to West Coast and Asia-Pacific markets"
          },
          {
            title: "Fast Network",
            desc: "1Gbps port with low latency to US West Coast"
          },
          {
            title: "DDoS Protection",
            desc: "Basic DDoS protection and 24/7 monitoring included"
          },
          {
            title: "US Infrastructure",
            desc: "Stable American datacenter with reliable power and cooling"
          },
          {
            title: "Good Connectivity",
            desc: "Well-connected to major US networks and cloud providers"
          }
        ]
      },
      timeline: {
        title: "World-Class Infrastructure",
        subtitle: "Built on American innovation and reliability",
        items: [
          {
            title: "LA Datacenter Location",
            desc: "Professional datacenter in Los Angeles area with reliable infrastructure"
          },
          {
            title: "Network Connectivity",
            desc: "1Gbps port with connections to major US internet providers"
          },
          {
            title: "Security & Monitoring",
            desc: "24/7 monitoring with DDoS protection and standard security measures"
          },
          {
            title: "Reliable Power",
            desc: "Redundant power systems with backup generators for stable operations"
          }
        ]
      },
      testimonials: {
        title: "Trusted by American Businesses",
        items: [
          {
            author: "Michael Chen",
            role: "CTO, StreamTech Inc.",
            text: "Best VPS provider we've used. LA location gives us perfect latency to both US and Asian markets. Support team is incredibly responsive."
          },
          {
            author: "Sarah Williams",
            role: "Founder, DataViz Pro",
            text: "Switched from AWS and cut our costs by 60% while improving performance. The network quality is outstanding."
          },
          {
            author: "James Rodriguez",
            role: "DevOps Lead, CloudNative Solutions",
            text: "Rock-solid uptime and blazing fast speeds. Their LA datacenter location is perfect for our west coast operations."
          },
          {
            author: "Emily Taylor",
            role: "CEO, FinanceHub",
            text: "Security and compliance are top-notch. Peace of mind knowing our data is in a SOC 2 certified facility."
          }
        ]
      },
      location: {
        title: "Los Angeles - Gateway to the Pacific",
        description: "Los Angeles offers unparalleled connectivity to both the United States and Asia-Pacific markets. Our downtown LA datacenter provides premium access to the largest content delivery networks and cloud providers.",
        subtitle: "Datacenter Location",
        details: "One Wilshire Blvd, Los Angeles, CA - The most connected building in the Western US",
        benefits: [
          "Good connectivity to major US carriers",
          "Low latency within US West Coast",
          "Access to Asia-Pacific markets",
          "Reliable US datacenter infrastructure",
          "GDPR compliant operations",
          "Redundant power and cooling systems"
        ]
      },
      cta: {
        title: "Ready to Go Live in LA?",
        subtitle: "Join thousands of businesses running on American infrastructure",
        button: "Deploy Now"
      },
      pricing: {
        title: "VPS USA Plans - VPS Los Angeles Hosting with 1Gbps Port",
        subtitle: "VPS USA Los Angeles datacenter with 99.9% uptime SLA, 1Gbps network port, NVMe SSD storage. US VPS hosting for West Coast and Asia-Pacific connectivity."
      }
    },
    miami: {
      hero: {
        badge: "USA Datacenter - Miami, Florida",
        title: "VPS in Miami",
        subtitle: "Deploy high-performance VPS in Miami — the strategic digital gateway connecting North America, Latin America, and the Caribbean.",
        getStarted: "Get Started",
        viewPlans: "View Plans",
        portSpeed: "Network Port",
        latency: "Regional Latency"
      },
      gateway: {
        title: "Gateway to the Americas",
        subtitle: "Miami is the premier interconnection point bridging the digital economies of three continents",
        items: [
          { title: "Hemisphere Connectivity Hub", desc: "Miami serves as the primary network crossroads for traffic flowing between North America, Central America, South America, and the Caribbean islands. Over 150 submarine cables terminate here, making it unmatched for hemisphere-wide reach." },
          { title: "NAP of the Americas", desc: "Home to one of the largest carrier-neutral data exchange facilities in the world. Direct peering with hundreds of networks ensures minimal hops and maximum throughput for your applications." },
          { title: "Submarine Cable Landing Point", desc: "Miami is where the majority of undersea fiber optic cables connecting the US to Latin America and the Caribbean make landfall. This means the lowest possible latency to markets south of the border." },
          { title: "Multi-Carrier Redundancy", desc: "Access to every major Tier-1 carrier and dozens of regional providers. Built-in redundancy through diverse network paths ensures your services stay online no matter what." }
        ]
      },
      imageBreak: {
        text: "Where Technology Meets the Tropics"
      },
      useCases: {
        title: "Built For Your Workload",
        subtitle: "From streaming platforms to fintech applications, Miami VPS delivers the performance your business demands",
        tabs: [
          { label: "Web & Apps", title: "Web Applications & APIs", desc: "Host responsive web applications, REST APIs, and microservices with guaranteed low latency across the Americas. NVMe storage ensures fast database queries and page loads.", features: ["Sub-10ms response times within Florida", "NVMe SSD for fast I/O operations", "Auto-scaling ready infrastructure", "Full root access with any OS"], stat: "<10ms", statLabel: "Florida Latency" },
          { label: "Databases", title: "Database Hosting & Analytics", desc: "Run MySQL, PostgreSQL, MongoDB, or Redis on high-performance NVMe storage. Ideal for data-intensive applications serving users across the Western Hemisphere.", features: ["NVMe SSD with high IOPS", "Up to 16GB RAM configurations", "Automated backup solutions", "Optimized for read/write workloads"], stat: "NVMe", statLabel: "Fast Storage" },
          { label: "Security", title: "Secure Infrastructure", desc: "Enterprise-grade security with DDoS mitigation, isolated network environments, and full firewall control. Perfect for compliance-sensitive workloads.", features: ["Built-in DDoS protection", "Configurable firewall rules", "Private network isolation", "Regular security monitoring"], stat: "24/7", statLabel: "Monitoring" },
          { label: "DevOps", title: "DevOps & CI/CD Pipelines", desc: "Spin up development, staging, and production environments in seconds. Full API access for infrastructure automation and container orchestration.", features: ["Instant deployment via API", "Docker & Kubernetes ready", "Multiple OS templates available", "Snapshot and restore capabilities"], stat: "60s", statLabel: "Deploy Time" }
        ]
      },
      technical: {
        title: "Technical Specifications",
        subtitle: "Enterprise-grade hardware and network infrastructure powering your Miami VPS",
        items: [
          { title: "Processing Power", desc: "Latest-generation Intel Xeon processors with dedicated vCPU cores. Each VPS receives guaranteed CPU allocation with no overselling, ensuring consistent compute performance for your applications." },
          { title: "Network Architecture", desc: "1Gbps dedicated port per VPS with unmetered bandwidth. Connected through multiple upstream providers with BGP routing for optimal path selection. IPv4 address included with each server." },
          { title: "DDoS Protection", desc: "Hardware-level DDoS mitigation protects your services from volumetric attacks. Automatic detection and filtering ensures legitimate traffic reaches your server without interruption." },
          { title: "Data Security", desc: "Physical security with biometric access controls, CCTV surveillance, and on-site security personnel. Network-level isolation between all customer environments with configurable firewall rules." },
          { title: "Storage Technology", desc: "Pure NVMe SSD storage delivering exceptional I/O performance. RAID protection for data integrity with consistent read and write speeds that outperform traditional SSD and HDD solutions." },
          { title: "Redundant Connectivity", desc: "Multiple fiber paths to major internet exchanges. Redundant power with UPS battery backup and diesel generators. N+1 cooling systems maintain optimal operating temperatures." }
        ]
      },
      location: {
        title: "Miami, Florida — Digital Capital of the Americas",
        description: "Miami has evolved from a tourism hotspot into one of the most important technology hubs in the Western Hemisphere. Its unique geographic position at the tip of the Florida peninsula makes it the natural nexus for digital traffic between continents.",
        subtitle: "Datacenter Location",
        details: "Tier III+ facility in Miami-Dade County, FL — Connected to NAP of the Americas and multiple submarine cable systems",
        benefits: [
          "Direct connections to Latin American and Caribbean networks",
          "Under 30ms latency to major cities in Central and South America",
          "Strategic position for serving US Southeast market",
          "Hurricane-hardened facility with reinforced construction",
          "Redundant power grid connections with generator backup",
          "24/7 on-site technical support and monitoring"
        ]
      },
      cta: {
        title: "Launch Your Miami VPS Today",
        subtitle: "Join businesses leveraging Miami's strategic position to reach customers across the Americas",
        button: "Deploy Now"
      },
      pricing: {
        title: "VPS Miami — Florida Datacenter with 1Gbps Port",
        subtitle: "VPS Miami, Florida datacenter with 99.9% uptime SLA, 1Gbps port, NVMe SSD storage. Strategic gateway to Latin America and the Caribbean."
      }
    },
    czechia: {
      hero: {
        badge: "EU Datacenter - Prague, Czech Republic",
        title: "VPS in Czech Republic",
        subtitle: "Deploy VPS in Prague — the heart of Central Europe with direct peering to major European exchanges and exceptional east-west connectivity.",
        getStarted: "Get Started",
        viewPlans: "View Plans"
      },
      stats: {
        uptimeLabel: "Uptime SLA",
        speedLabel: "Network Port",
        latencyLabel: "To Berlin/Vienna",
        complianceLabel: "GDPR Compliant"
      },
      why: {
        title: "Why Prague for Your VPS?",
        subtitle: "Prague combines Central European connectivity with cost-effective infrastructure and EU regulatory compliance",
        items: [
          { title: "Central European Crossroads", desc: "Prague sits at the geographic center of Europe, providing equally low latency to Western, Eastern, Northern, and Southern European markets. This strategic position makes it ideal for pan-European deployments serving users across the entire continent." },
          { title: "NIX.CZ Internet Exchange", desc: "Direct connection to NIX.CZ — the largest internet exchange point in the Czech Republic with over 200 connected networks. This ensures optimal routing and minimal latency for regional and international traffic." },
          { title: "EU Data Protection", desc: "Full GDPR compliance with Czech data protection laws. Czech Republic is a member of the European Union, providing a strong legal framework for data privacy and cross-border data transfers within the EU." },
          { title: "Carrier-Dense Location", desc: "Prague is a major fiber optic hub with multiple international carriers including Telia, Cogent, and Liberty Global. Diverse upstream connectivity ensures network redundancy and optimal routing paths." },
          { title: "Modern Infrastructure", desc: "State-of-the-art datacenter facilities with latest-generation hardware, redundant power systems, and enterprise-grade cooling. All servers run on NVMe SSD storage for maximum I/O performance." }
        ]
      },
      features: {
        title: "Enterprise-Grade VPS in Prague",
        subtitle: "High-performance virtual servers built on modern infrastructure in one of Europe's fastest-growing tech hubs.",
        items: [
          { title: "NVMe SSD Storage", desc: "Pure NVMe drives delivering exceptional read/write speeds and low-latency I/O operations." },
          { title: "1Gbps Dedicated Port", desc: "Each VPS receives a dedicated 1Gbps network port with unmetered bandwidth." },
          { title: "DDoS Protection", desc: "Hardware-level DDoS mitigation to keep your services online during attacks." },
          { title: "Automated Backups", desc: "Configurable backup schedules to protect your data with point-in-time recovery." },
          { title: "Multiple OS Options", desc: "Choose from Ubuntu, Debian, CentOS, AlmaLinux, Rocky Linux, and Windows Server." },
          { title: "24/7 Monitoring", desc: "Round-the-clock infrastructure monitoring with automated alerting and response." }
        ]
      },
      location: {
        title: "Prague — The Silicon Valley of Central Europe",
        description: "Prague has emerged as one of Europe's leading technology centers, home to hundreds of startups and international tech companies. Its central location, skilled workforce, and excellent infrastructure make it a premier choice for hosting.",
        subtitle: "Datacenter Location",
        details: "Tier III datacenter facility in Prague, Czech Republic — Connected to NIX.CZ and multiple international carriers",
        benefits: [
          "Direct peering at NIX.CZ with 200+ networks",
          "Under 12ms latency to Berlin, Vienna, and Warsaw",
          "Central position for pan-European coverage",
          "Full EU GDPR compliance",
          "Redundant power with N+1 UPS and generators",
          "24/7 on-site security and technical support"
        ]
      },
      cta: {
        title: "Launch Your Prague VPS Today",
        subtitle: "Deploy in the heart of Central Europe with world-class connectivity and EU data protection",
        button: "Deploy Now"
      },
      pricing: {
        title: "VPS Czech Republic — Prague Datacenter with 1Gbps Port",
        subtitle: "VPS Prague, Czech Republic datacenter with 99.9% uptime SLA, 1Gbps port, NVMe SSD. Central European hub with GDPR compliance."
      }
    },
  },
  ru: {
    header: {
      home: "Главная",
      pricing: "Тарифы",
      locations: "Дата-центры",
      support: "Поддержка",
      about: "О нас",
      partners: "Партнёрам",
      login: "Войти",
      language: "Язык"
    },
    hero: {
      badge: "Нам доверяют 12 000+ разработчиков",
      title1: "Быстрый и надёжный VPS",
      title2: "по Европе и США",
      subtitle: "Запустите виртуальный сервер за 60 секунд. NVMe, порт 1 Gbps и аптайм 99,9% — в двенадцати дата-центрах от Амстердама до Майами.",
      signUp: "Начать",
      viewLocations: "Локации",
      nvmeSSD: "NVMe SSD хранилище",
      nvmeDesc: "Высокопроизводительные NVMe диски с минимальной задержкой",
      port10G: "Порт 1Gbps",
      portDesc: "Общее подключение 1 Gigabit с неограниченной передачей данных",
      unlimitedTraffic: "Безлимитный трафик",
      trafficDesc: "Неограниченная пропускная способность для всех ваших потребностей"
    },
    locations: {
      globalNetwork: "Глобальная сеть",
      title: "Дата-центр рядом с вашими пользователями",
      subtitle: "Двенадцать локаций в Европе и США. Выберите ту, где пинг до ваших посетителей будет минимальным.",
      latency: "Средняя задержка",
      uptime: "SLA аптайма",
      networkSpeed: "Скорость сети",
      monitoring: "Мониторинг",
      deploy: "Развертывание VPS за 60 секунд",
      comingSoon: "Скоро"
    },
    pricing: {
      title: "Прозрачные тарифы для вашего бизнеса",
      subtitle: "Гибкие тарифы, созданные для масштабирования вашего бизнеса. Начните с малого или выбирайте максимум — обновляйтесь в любое время",
      specifications: "Характеристики",
      perMonth: "/мес",
      choose: "Выбрать"
    },
    payment: {
      subtitle: "Мы принимаем платежи из более чем 190 стран мира. Оплачивайте банковскими картами, USDT, Bitcoin и другими криптовалютами, а также банковскими переводами без комиссии.",
      crypto: "Криптовалюта",
      card: "Банковские карты",
      bank: "Банковский перевод"
    },
    features: {
      title: "Почему стоит выбрать VPS NetGrid Host?",
      subtitle: "Мы предоставляем инфраструктуру корпоративного класса с функциями, предназначенными для бесперебойной и безопасной работы ваших приложений.",
      nvme: {
        title: "Молниеносный NVMe",
        desc: "NVMe SSD накопители корпоративного класса обеспечивают максимальную производительность для ваших приложений."
      },
      uptime: {
        title: "99.9% SLA аптайма",
        desc: "Гарантированное время работы с резервной инфраструктурой и мониторингом 24/7."
      },
      support: {
        title: "Поддержка 24/7",
        desc: "Наши технические специалисты доступны круглосуточно для помощи."
      },
      root: {
        title: "Полный root доступ",
        desc: "Полный контроль над вашим VPS с root доступом и пользовательскими конфигурациями."
      },
      ip: {
        title: "Выделенный IP адрес",
        desc: "Получите собственные выделенные IPv4 и IPv6 адреса для максимальной гибкости."
      },
      os: {
        title: "Множество ОС",
        desc: "Ubuntu, Debian, CentOS, AlmaLinux, Rocky Linux, Oracle Linux, FreeBSD, Astra Linux, Windows."
      }
    },
    technical: {
      cpu: {
        title: "Мощные процессоры",
        subtitle: "Суперзаряженные Intel Xeon процессоры",
        desc: "Наши серверы работают на последних поколениях Intel Xeon, обеспечивая максимальную производительность, стабильность и надежность. Высокое количество ядер и поддержка современных технологий позволяют запускать сотни виртуальных серверов без потери скорости."
      },
      storage: {
        title: "Сверхбыстрое хранилище",
        subtitle: "Молниеносные NVMe диски",
        desc: "Мы используем только Enterprise NVMe SSD, которые в десятки раз быстрее обычных дисков. Это гарантирует мгновенный отклик, высокий IOPS и устраняет узкие места при работе ваших приложений и баз данных."
      },
      virtualization: {
        title: "Продвинутая виртуализация",
        subtitle: "Аппаратная KVM виртуализация",
        desc: "Каждый VPS работает на технологии KVM, обеспечивая полную изоляцию ресурсов, справедливое распределение CPU и RAM, и максимальную совместимость с любыми операционными системами."
      },
      ipAddress: {
        title: "Гибкая IP адресация",
        subtitle: "IPv4 + опциональная IPv6 подсеть",
        desc: "Мы предоставляем IPv4 адрес с каждым VPS. Дополнительно вы можете заказать IPv6 подсети для современных сетевых требований и перспективных решений подключения."
      },
      deployment: {
        title: "Мгновенное развертывание",
        subtitle: "VM готова менее чем за 60 секунд",
        desc: "Ваша виртуальная машина создается и готова к использованию менее чем за 30 секунд. Никакого ожидания, никаких задержек - начинайте работать с сервером сразу после заказа."
      },
      panel: {
        title: "Продвинутая панель управления",
        subtitle: "Полный набор управления VM",
        desc: "Комплексная панель управления с детальной статистикой, полным управлением VM, переустановкой ОС, управлением перезагрузкой и мониторингом ресурсов сервера в реальном времени."
      },
      backup: {
        title: "Зеркалирование RAID 1",
        subtitle: "Защита данных на аппаратном уровне",
        desc: "Все данные автоматически дублируются на зеркальные массивы RAID 1 для обеспечения избыточности. Защита на аппаратном уровне гарантирует сохранность данных даже при отказе диска."
      },
      monitoring: {
        title: "Мониторинг инфраструктуры",
        subtitle: "Мониторинг узлов и сети в реальном времени",
        desc: "Комплексный мониторинг всех узлов инфраструктуры, серверов и сетевых компонентов. Оповещения в реальном времени, метрики производительности и проактивное обслуживание обеспечивают максимальное время работы и надежность."
      }
    },
    useCases: {
      title: "Для чего используется VPS от NetGrid Host?",
      subtitle: "От VPN решений до игровых серверов, наш VPS хостинг обеспечивает разнообразные приложения в различных отраслях",
      vpn: {
        title: "VPN решения",
        desc: "Безопасные частные сети с несколькими протоколами"
      },
      web: {
        title: "Веб-хостинг",
        desc: "Веб-сайты, интернет-магазины и админ-панели"
      },
      gaming: {
        title: "Игровые серверы",
        desc: "Высокопроизводительные игровые и бизнес-приложения"
      },
      os: {
        title: "Операционные системы",
        desc: "Выбирайте из Linux или Windows окружений"
      },
      dev: {
        title: "Разработка",
        desc: "Идеальная среда для тестирования и разработки"
      },
      scale: {
        title: "Масштабируемость",
        desc: "Плавный переход на более высокие тарифы с автоматическим масштабированием ресурсов. Быстрые и эффективные переходы с минимальным простоем."
      }
    },
    faq: {
      title: "Часто задаваемые вопросы",
      subtitle: "Есть вопросы? У нас есть ответы. Найдите всё, что вам нужно знать о наших VPS услугах.",
      ready: "Готовы начать?",
      readyDesc: "Изучите наши тарифные планы и глобальные локации серверов, чтобы найти идеальное решение для ваших нужд.",
      viewPricing: "Смотреть тарифы",
      viewLocations: "Смотреть локации"
    },
    footer: {
      description: "Премиум VPS хостинг решения по всей Европе. Испытайте молниеносную производительность с инфраструктурой корпоративного класса и экспертной поддержкой 24/7.",
      quickLinks: "Быстрые ссылки",
      legal: "Юридическая информация",
      home: "Главная",
      pricing: "Тарифы",
      locations: "Локации",
      support: "Поддержка",
      wiki: "База знаний",
      about: "О нас",
      blog: "Блог",
      affiliate: "Партнерам",
      terms: "Условия использования",
      privacy: "Политика конфиденциальности",
      cookie: "Политика cookie",
      refund: "Политика возврата",
      rights: "Все права защищены."
    },
    support: {
      hero: {
        title: "Центр поддержки",
        subtitle: "Мы здесь, чтобы помочь вам 24/7. Наша команда экспертов готова ответить на любые вопросы."
      },
      departments: {
        technical: {
          title: "Техническая поддержка",
          description: "Проблемы с сервером, сетью и срочные технические вопросы",
          hours: "Пн-Пт, 9:00-18:00 UTC"
        },
        financial: {
          title: "Финансовый департамент",
          description: "Биллинг, платежи, счета и запросы на возврат средств",
          hours: "Пн-Пт, 9:00-18:00 UTC"
        },
        abuse: {
          title: "Департамент жалоб",
          description: "Сообщения о нарушениях, спаме, авторских правах и инцидентах безопасности",
          hours: "Ответ в течение 24 часов"
        }
      },
      clientNotice: {
        title: "Вы являетесь нашим клиентом?",
        description: "Если вы являетесь нашим клиентом, пожалуйста, откройте тикет в личном кабинете. Это самый быстрый способ получить техническую поддержку с приоритетной обработкой. Используйте эту контактную форму только если вы не являетесь нашим клиентом, забыли пароль от аккаунта или у вас другие общие вопросы.",
        button: "Открыть тикет"
      },
      form: {
        title: "Форма обратной связи",
        name: "Ваше имя",
        email: "Email адрес",
        department: "Департамент",
        subject: "Тема",
        message: "Сообщение",
        agreement: "Отправляя эту форму, вы соглашаетесь с нашей Политикой конфиденциальности",
        submit: "Отправить сообщение",
        sending: "Отправка...",
        successMessage: "Ваше сообщение успешно отправлено! Мы ответим вам в ближайшее время."
      },
      contact: {
        title: "Контактная информация",
        generalQuestions: "Общие вопросы",
        general: "Общая поддержка",
        abuse: "Сообщения о нарушениях"
      },
      info: {
        title: "Нужна срочная помощь?",
        description: "По срочным техническим вопросам наша команда доступна 24/7. Финансовые и административные вопросы обрабатываются в рабочее время (Пн-Пт, 9:00-18:00 UTC). На все запросы обычно отвечают в течение 2-4 часов."
      },
      social: {
        title: "Оперативные уведомления в Telegram",
        subtitle: "Сообщаем о работах на инфраструктуре, инцидентах и плановом обслуживании по факту — подписавшись на канал, вы узнаете о проблемах раньше, чем откроете тикет.",
        description: "Получайте мгновенные уведомления о доступности серверов, плановом обслуживании, проблемах с сетью и важных обновлениях инфраструктуры. Мы публикуем все изменения операционного статуса и технические объявления в нашем Telegram-канале.",
        telegram: "Подписаться на Telegram-канал"
      },
      knowledgeBase: {
        title: "Прежде чем открыть тикет",
        description: "Сэкономьте время на ожидание ответа — посмотрите в базе знаний или в нашем Telegram-канале. Большинство ответов уже там.",
        kbButton: "Открыть базу знаний",
        tgButton: "Telegram-канал"
      }
    },
    about: {
      hero: {
        title: "О компании NetGrid Host",
        subtitle: "Строим будущее VPS инфраструктуры с 15-летним опытом в IT, сетевых технологиях и VPN сервисах."
      },
      stats: {
        years: "Лет опыта",
        clients: "Довольных клиентов",
        locations: "Глобальных локаций",
        uptime: "SLA аптайма"
      },
      story: {
        title: "Наша история",
        paragraph1: "NetGrid Host была основана командой IT-профессионалов с более чем 15-летним совокупным опытом в технологическом секторе. Наш путь начался с сетевой инженерии, VPN-сервисов и разработки программного обеспечения, что дало нам глубокое понимание потребностей бизнеса и частных лиц в VPS провайдере.",
        paragraph2: "На протяжении нашей истории мы работали как VPN-провайдер, разрабатывали сложные сетевые инфраструктуры и создавали инновационные программные решения. Этот разнообразный опыт позволяет нам предлагать VPS хостинг услуги, которые не просто быстры и надежны, но действительно понимают потребности современных приложений.",
        paragraph3: "Сегодня мы с гордостью обслуживаем более 12 000 клиентов в 12 стратегических локациях по всему миру, и это только начало. Наша приверженность доступным ценам без компромиссов в качестве сделала нас одним из самых конкурентоспособных VPS провайдеров на рынке."
      },
      vision: {
        title: "Наше видение и цели",
        subtitle: "Мы строим глобальную инфраструктуру, которая делает VPS хостинг доступным для всех",
        global: {
          title: "Глобальная экспансия в 40 стран",
          desc: "Наша амбициозная цель — расширить нашу VPS инфраструктуру до 40 стран по всему миру, приближая высокопроизводительные виртуальные приватные серверы с низкой задержкой к пользователям повсюду."
        },
        accessibility: {
          title: "Доступный VPS хостинг",
          desc: "Мы верим, что качественный VPS хостинг не должен разорять. Наша миссия — предлагать виртуальные приватные серверы корпоративного класса по ценам, доступным для стартапов, разработчиков и бизнеса любого размера."
        },
        innovation: {
          title: "Постоянные инновации",
          desc: "Мы постоянно развиваемся, внедряем новейшие технологии и улучшаем наши услуги на основе отзывов клиентов, чтобы оставаться впереди отраслевых трендов."
        }
      },
      whyUs: {
        title: "Почему выбирают NetGrid Host?",
        subtitle: "Что отличает нас от других VPS провайдеров"
      },
      values: {
        pricing: {
          title: "Конкурентные цены",
          desc: "Мы предлагаем одни из самых низких цен на рынке без ущерба для качества, надежности или производительности."
        },
        experience: {
          title: "15+ лет опыта",
          desc: "Наша команда обладает обширным опытом в VPN-сервисах, сетевой инженерии и разработке программного обеспечения."
        },
        performance: {
          title: "Высокая производительность",
          desc: "Enterprise NVMe накопители, современные процессоры и оптимизированная сетевая инфраструктура обеспечивают максимальную скорость."
        },
        support: {
          title: "Выделенная поддержка",
          desc: "Наша опытная команда поддержки готова помочь вам с любыми техническими или финансовыми вопросами."
        }
      },
      company: {
        title: "Информация о компании",
        legalName: "Юридическое название",
        address: "Адрес офиса",
        email: "Корпоративный email"
      },
      cta: {
        title: "Готовы начать?",
        subtitle: "Присоединяйтесь к тысячам довольных клиентов, которые доверяют NetGrid Host для своих VPS хостинг потребностей",
        contact: "Связаться с нами",
        pricing: "Смотреть тарифы"
      },
      social: {
        title: "Будьте в курсе",
        subtitle: "Следите за нашими социальными сетями для получения обновлений в реальном времени, уведомлений об инфраструктуре и графиков технических работ",
        description: "Получайте мгновенные уведомления о доступности серверов, плановом обслуживании, проблемах с сетью и важных обновлениях инфраструктуры. Мы публикуем все изменения операционного статуса и технические объявления в наших социальных каналах.",
        twitter: "Подписаться на X",
        telegram: "Присоединиться к Telegram"
      }
    },
    legal: {
      terms: {
        title: "Условия использования",
        subtitle: "Эти условия регулируют использование услуг VPS хостинга NetGrid Host. Пожалуйста, внимательно прочитайте перед использованием.",
        lastUpdated: "Последнее обновление: 1 декабря 2025",
        section1: {
          title: "1. Принятие соглашения и право пользования",
          content: "Настоящие Условия использования представляют собой юридически обязывающее соглашение между вами ('Пользователь' или 'Клиент') и NetGrid Host Ltd ('NetGrid', 'мы', 'нас' или 'наш'). Создавая учетную запись, получая доступ к нашему веб-сайту или используя любые наши услуги VPS хостинга, вы подтверждаете, что прочитали, поняли и согласны соблюдать настоящие Условия. Если вы не согласны с какой-либо частью этих Условий, вы должны немедленно прекратить использование наших услуг. Пользователи должны быть не моложе 18 лет или достигнуть возраста совершеннолетия в своей юрисдикции. Используя наши услуги, вы заявляете и гарантируете, что соответствуете этому возрастному требованию и обладаете правоспособностью заключить настоящее соглашение. Мы оставляем за собой право отказать в обслуживании любому лицу или организации по нашему усмотрению."
        },
        section2: {
          title: "2. Описание услуг и изменения",
          content: "NetGrid Host предоставляет услуги хостинга виртуальных приватных серверов (VPS) с высокопроизводительной инфраструктурой, несколькими глобальными локациями дата-центров и круглосуточной технической поддержкой. Наши услуги включают, помимо прочего: выделенные ресурсы CPU и RAM, хранилище NVMe SSD, сетевое подключение с гарантированной пропускной способностью, установку операционных систем и решения для резервного копирования. Мы стремимся поддерживать время работы 99,9% для всех VPS. NetGrid Host оставляет за собой право изменять, улучшать, приостанавливать или прекращать любой аспект наших услуг, функций или цен в любое время без предварительного уведомления. Мы приложим разумные усилия для уведомления пользователей о значительных изменениях, которые могут повлиять на использование их услуг. Плановое техническое обслуживание будет объявлено заранее, когда это возможно, хотя экстренное обслуживание может быть выполнено без уведомления для защиты целостности и безопасности системы."
        },
        section3: {
          title: "3. Обязанности пользователя и запрещенные действия",
          content: "Вы несете исключительную ответственность за: (а) сохранение конфиденциальности и безопасности учетных данных вашей учетной записи; (б) всю деятельность, происходящую в вашей учетной записи; (в) обеспечение того, что ваше использование услуг соответствует всем применимым законам и правилам; (г) содержимое, данные и приложения, которые вы храните, обрабатываете или передаете с помощью наших услуг VPS. Вы не должны использовать наши услуги для: незаконной деятельности, включая, помимо прочего, нарушение авторских прав, распространение пиратского контента, взлом, фишинг или мошенничество; отправки незапрошенной массовой электронной почты (спам) или участия в любой форме злоупотребления сетью; хостинга или распространения вредоносных программ, вирусов или вредоносного кода; майнинга криптовалюты без предварительного одобрения; запуска выходных узлов Tor или прокси-сервисов без авторизации; хостинга контента, нарушающего права интеллектуальной собственности; участия в деятельности, которая может повредить, отключить или ухудшить нашу инфраструктуру или услуги других пользователей. Вы соглашаетесь принять разумные меры безопасности для защиты вашего VPS и немедленно уведомлять нас о любых нарушениях безопасности или несанкционированном доступе."
        },
        section4: {
          title: "4. Условия оплаты и биллинг",
          content: "Все услуги оплачиваются в соответствии с тарифным планом, который вы выбираете при покупке. Цены указаны в валюте, указанной при оформлении заказа, и не включают применимые налоги, если не указано иное. Оплата должна быть произведена авансом за каждый расчетный период (ежемесячно, ежеквартально или ежегодно, в зависимости от обстоятельств). Мы принимаем различные способы оплаты, отображаемые на нашем веб-сайте, а обработка платежей осуществляется через сторонние платежные процессоры. Предоставляя платежную информацию, вы разрешаете нам списывать указанный способ оплаты за все понесенные сборы. Если платеж не проходит или отклоняется, мы попытаемся уведомить вас и можем повторить попытку списания. Услуга будет немедленно остановлена при просрочке оплаты и удалена через 3 дня в случае неуплаты без возможности восстановления. Вы несете ответственность за то, чтобы ваша платежная информация оставалась актуальной и действительной. Все сборы не подлежат возврату, за исключением случаев, прямо указанных в нашей Политике возврата. Мы оставляем за собой право изменять наши цены с уведомлением существующих клиентов не менее чем за 30 дней."
        },
        section5: {
          title: "5. Соглашение об уровне обслуживания и гарантия времени работы",
          content: "NetGrid Host гарантирует 99,9% месячного времени работы для услуг VPS, рассчитываемого как процент времени, в течение которого ваш VPS доступен и работает в каждом календарном месяце. Эта гарантия исключает: окна планового обслуживания (объявленные не менее чем за 24 часа), экстренное обслуживание, необходимое для безопасности или стабильности системы, простои, вызванные факторами вне нашего контроля (включая проблемы с подключением к Интернету, форс-мажорные обстоятельства или сбои сторонних служб), и простои, вызванные действиями пользователя или неправильными конфигурациями. В случае, если мы не сможем выполнить гарантию времени работы 99,9% в данном месяце, вы можете иметь право на кредиты за обслуживание, рассчитанные следующим образом: 99,5-99,89% времени работы: кредит 5%; 99,0-99,49% времени работы: кредит 10%; ниже 99,0% времени работы: кредит 25%. Кредиты за обслуживание являются вашим единственным средством правовой защиты в случае сбоев гарантии времени работы и должны быть запрошены в течение 7 дней после окончания затронутого месяца. Кредиты выдаются только в виде кредитов учетной записи и не могут быть обменены на наличные."
        },
        section6: {
          title: "6. Защита данных и конфиденциальность",
          content: "Мы стремимся защищать вашу личную информацию и данные. Наш сбор, использование и раскрытие персональных данных регулируется нашей Политикой конфиденциальности, которая является неотъемлемой частью настоящих Условий. Вы сохраняете все права, титул и интерес к своим данным, хранящимся в наших услугах VPS. Мы не будем получать доступ, просматривать или использовать ваши данные, за исключением случаев: когда это требуется законом или судебным процессом; с вашего явного разрешения; по мере необходимости для предоставления технической поддержки или поддержания функциональности службы; для расследования потенциальных нарушений настоящих Условий или для защиты наших прав и собственности. Мы применяем стандартные в отрасли меры безопасности, включая шифрование, контроль доступа и регулярные аудиты безопасности. Однако ни одна система не является полностью безопасной, и мы не можем гарантировать абсолютную безопасность ваших данных. Вы несете ответственность за ведение собственных резервных копий критических данных, поскольку мы не гарантируем восстановление данных во всех обстоятельствах."
        },
        section7: {
          title: "7. Ограничение ответственности и отказ от гарантий",
          content: "В МАКСИМАЛЬНОЙ СТЕПЕНИ, РАЗРЕШЕННОЙ ЗАКОНОМ: Наши услуги предоставляются 'КАК ЕСТЬ' и 'ПО МЕРЕ ДОСТУПНОСТИ' без каких-либо гарантий, явных или подразумеваемых, включая, помимо прочего, гарантии товарной пригодности, пригодности для определенной цели или ненарушения прав. NetGrid не несет ответственности за любые косвенные, случайные, специальные, последующие или штрафные убытки, включая, помимо прочего, упущенную выгоду, данные, использование или другие нематериальные потери, возникающие в результате: вашего использования или невозможности использования наших услуг; несанкционированного доступа к вашим данным или их изменения; любого поведения или контента третьих лиц в наших услугах; любого прерывания или прекращения услуг. Наша общая ответственность перед вами за все претензии, возникающие из или связанные с настоящими Условиями или нашими услугами, не должна превышать сумму, которую вы заплатили NetGrid Host в течение 12 месяцев, предшествующих претензии. Некоторые юрисдикции не допускают исключения определенных гарантий или ограничения ответственности, поэтому эти ограничения могут не применяться к вам."
        },
        section8: {
          title: "8. Возмещение убытков",
          content: "Вы соглашаетесь возместить убытки, защищать и ограждать от ответственности NetGrid Host, его должностных лиц, директоров, сотрудников, агентов и аффилированных лиц от любых претензий, обязательств, убытков, потерь, затрат, расходов или сборов (включая разумные гонорары адвокатов), возникающих в результате: вашего использования или неправильного использования наших услуг; вашего нарушения настоящих Условий; вашего нарушения каких-либо прав третьих лиц, включая права интеллектуальной собственности; вашего нарушения каких-либо применимых законов или правил; любого контента или данных, которые вы загружаете, храните или передаете через наши услуги. Это обязательство по возмещению убытков будет действовать и после прекращения действия настоящих Условий и вашего использования наших услуг."
        },
        section9: {
          title: "9. Прекращение и приостановка",
          content: "Вы можете прекратить действие своей учетной записи и услуг в любое время, связавшись с нашей службой поддержки или через панель управления учетной записью. Прекращение не освобождает вас от каких-либо платежных обязательств за уже оказанные услуги. NetGrid Host может немедленно приостановить или прекратить ваш доступ к услугам без предварительного уведомления, если: вы нарушаете какое-либо положение настоящих Условий; ваша учетная запись значительно просрочена по оплате; ваше использование услуг представляет угрозу безопасности или нарушает применимые законы; мы обязаны сделать это по закону или решению суда. После прекращения ваше право на использование наших услуг немедленно прекращается. Мы приложим разумные усилия, чтобы предоставить вам доступ для получения ваших данных в течение 7 дней после прекращения, после чего все данные, связанные с вашей учетной записью, могут быть безвозвратно удалены. Некоторые положения настоящих Условий будут действовать и после прекращения, включая разделы, касающиеся интеллектуальной собственности, ограничения ответственности и возмещения убытков."
        },
        section10: {
          title: "10. Применимое право и разрешение споров",
          content: "Настоящие Условия регулируются и толкуются в соответствии с законами Англии и Уэльса, без учета положений о коллизионном праве. Любой спор, возникающий из или связанный с настоящими Условиями или нашими услугами, подлежит исключительной юрисдикции судов Англии и Уэльса. Перед началом любого судебного разбирательства стороны соглашаются попытаться разрешить споры посредством добросовестных переговоров. Если спор не может быть разрешен путем переговоров в течение 30 дней, любая из сторон может прибегнуть к формальным юридическим средствам защиты. Вы соглашаетесь, что любая претензия должна быть подана в течение одного года с момента возникновения основания для иска, в противном случае такая претензия будет навсегда запрещена."
        },
        section11: {
          title: "11. Сетевой сервис, общий порт и политика честного использования",
          content: "Каждый VPS получает сетевой порт, заявленный со скоростью до 1 Гбит/с. Клиент явно подтверждает, что этот порт — общая инфраструктура: физический аплинк каждой ноды разделяется между всеми виртуальными машинами на ней, в соответствии со стандартной отраслевой практикой (oversubscription). Цифра 1 Гбит/с обозначает теоретическую пиковую (burst) скорость, доступную в моменты, когда канал ноды свободен, и не является гарантированной выделенной полосой, закреплённой исключительно за Клиентом. Постоянная пропускная способность, доступная конкретному VPS, имеет статистический характер и зависит от текущей активности соседей по ноде, маршрута к точке назначения и пропускной способности самой точки назначения. NetGrid не гарантирует на базовых тарифах конкретную минимальную постоянную пропускную способность, скорость одного TCP-соединения (single-flow), частоту пакетов или конкретный результат speedtest. Замеры скорости, выполненные до произвольных сторонних сервисов (включая, помимо прочего, speedtest.net, iperf3 до случайных публичных серверов, браузерные тесты, тесты через VPN-туннель), измеряют весь сетевой путь и заторы в транзите, а не производительность собственно VPS, и не принимаются в качестве доказательства нарушения SLA. Политика честного использования: Наша сеть рассчитана на типичные задачи веб-хостинга, бэкендов приложений, личных проектов, dev-окружений, mail-relay умеренного объёма и аналогичные смешанные нагрузки. Постоянные высокополосные приложения — в том числе, но не ограничиваясь: публичные файловые зеркала, edge-узлы CDN, источники потокового видео (origin), массовое торрент-сидирование, сервисы обмена трафиком или прокси-сервисы для перепродажи, а также любая модель устойчивого исходящего трафика, существенно ухудшающая сервис для других Клиентов на той же ноде, — выходят за рамки базовых тарифов и могут повлечь: (а) автоматическое ограничение скорости для защиты ёмкости ноды, (б) приостановку сервиса в явных случаях злоупотребления, (в) требование перейти на тариф с выделенной полосой, доступный по запросу в поддержку. NetGrid в любой момент оставляет за собой право применять traffic shaping, ограничивать отдельные VPS или приостанавливать сервис, если по его обоснованному усмотрению использование аккаунта негативно влияет на стабильность работы ноды или качество сервиса других Клиентов. Если для тарифа объявлен месячный лимит исходящего трафика — он обязателен; при превышении скорость порта может быть снижена до конца расчётного периода, либо может быть предложена покупка дополнительного трафика на условиях, отображаемых в личном кабинете. Входящий трафик не учитывается, но подчиняется тем же принципам честного использования и активной анти-abuse фильтрации. Тарифы, лимиты и пороги могут обновляться со временем; актуальное состояние всегда отражается на netgrid.host и в личном кабинете, и приоритет имеет именно оно — не любые исторические рекламные материалы. Доступное объяснение того, как работает общая полоса на VPS, опубликовано по адресу netgrid.host/wiki и включено в настоящие Условия по ссылке для разъяснения, а не как альтернативный источник обязательств."
        }
      },
      privacy: {
        title: "Политика конфиденциальности",
        subtitle: "NetGrid Host Ltd стремится защищать ваши персональные данные и права на конфиденциальность",
        lastUpdated: "Последнее обновление: 1 декабря 2025",
        section1: {
          title: "1. Сбор информации и типы данных",
          content: "NetGrid Host собирает несколько типов информации для предоставления и улучшения наших услуг VPS хостинга: Персональная информация - При регистрации учетной записи мы собираем ваше имя, адрес электронной почты, физический адрес, номер телефона и платежную информацию. Эта информация необходима для создания вашей учетной записи, обработки платежей и связи с вами по поводу ваших услуг. Техническая информация - Мы автоматически собираем технические данные, включая IP-адреса, тип и версию браузера, операционную систему, журналы сервера, время доступа и просмотренные страницы. Эта информация помогает нам поддерживать качество обслуживания, устранять проблемы и предотвращать мошенничество. Данные об использовании - Мы собираем информацию о том, как вы используете наши услуги VPS, включая потребление ресурсов (CPU, RAM, пропускная способность), настройки конфигурации и тикеты поддержки. Эти данные помогают нам оптимизировать нашу инфраструктуру и обеспечивать лучшую поддержку. Cookies и отслеживание - Наш веб-сайт использует cookies и аналогичные технологии отслеживания для улучшения пользовательского опыта, запоминания предпочтений и анализа трафика веб-сайта. Пожалуйста, обратитесь к нашей Политике Cookie для подробной информации."
        },
        section2: {
          title: "2. Как мы используем вашу информацию",
          content: "Мы обрабатываем ваши персональные данные для следующих целей: Предоставление услуг - Для создания и управления вашей учетной записью, предоставления ресурсов VPS, поддержания инфраструктуры и обеспечения доступности и производительности услуг. Коммуникация - Для отправки уведомлений об услугах, выписок по счетам, технических оповещений, обновлений безопасности и ответов на ваши запросы в службу поддержки. Мы также можем отправлять маркетинговые сообщения, если вы согласились, и вы можете отписаться в любое время. Обработка платежей - Для обработки платежей, предотвращения мошенничества и ведения записей о выставлении счетов. Мы работаем с надежными сторонними платежными процессорами, соответствующими стандартам PCI DSS. Соблюдение законов - Для соблюдения применимых законов и правил, ответа на юридические запросы от государственных органов, соблюдения наших Условий использования и защиты наших прав и собственности. Улучшение услуг - Для анализа моделей использования, выявления технических проблем, разработки новых функций и повышения общего качества обслуживания. Безопасность - Для обнаружения и предотвращения несанкционированного доступа, поддержания безопасности системы и защиты от вредоносной деятельности. Мы никогда не продаем, не сдаем в аренду и не обмениваем вашу личную информацию третьим лицам для их маркетинговых целей."
        },
        section3: {
          title: "3. Обмен данными и сторонние службы",
          content: "Мы можем передавать вашу информацию в следующих обстоятельствах: Поставщики услуг - Мы работаем с тщательно отобранными сторонними поставщиками услуг, которые помогают нам в предоставлении наших услуг, включая платежные процессоры, операторов дата-центров, провайдеров CDN и инструменты поддержки. Эти провайдеры связаны соглашениями о конфиденциальности и могут использовать вашу информацию только для выполнения услуг от нашего имени. Юридические требования - Мы можем раскрывать вашу информацию, когда это требуется законом, судебным постановлением или государственным регулированием, или когда мы считаем, что раскрытие необходимо для защиты наших прав, вашей безопасности или безопасности других. Информация WHOIS - Если вы регистрируете домен через нас или используете наши услуги, определенная информация (имя, адрес, электронная почта, телефон) может быть опубликована в общедоступных базах данных WHOIS в соответствии с требованиями реестров доменов и правилами ICANN. Передача бизнеса - В случае слияния, приобретения или продажи активов ваша информация может быть передана приобретающей стороне. Мы уведомим вас о любом таком изменении в собственности. С вашего согласия - Мы можем передавать вашу информацию другим третьим лицам, когда вы дали нам явное разрешение на это. Мы не передаем ваши данные третьим лицам для их независимых маркетинговых целей без вашего явного согласия."
        },
        section4: {
          title: "4. Безопасность данных и меры защиты",
          content: "Мы применяем комплексные меры безопасности для защиты ваших персональных данных: Технические меры защиты - Все передачи данных шифруются с использованием стандартных протоколов TLS/SSL. Данные в состоянии покоя шифруются с использованием шифрования AES-256. Мы используем межсетевые экраны, системы обнаружения вторжений и регулярные аудиты безопасности для защиты нашей инфраструктуры. Контроль доступа - Доступ к персональным данным ограничен только уполномоченным персоналом на основе необходимости знать. Все сотрудники подписывают соглашения о конфиденциальности и проходят регулярное обучение по безопасности. Мы используем многофакторную аутентификацию и надежные политики паролей для всего административного доступа. Безопасность платежей - Мы не храним полную информацию о кредитных картах на наших серверах. Вся обработка платежей осуществляется через сертифицированные PCI DSS Level 1 платежные процессоры, обеспечивающие высочайший уровень безопасности платежей. Физическая безопасность - Наши дата-центры оснащены круглосуточной физической безопасностью, биометрическим контролем доступа, видеонаблюдением и системами мониторинга окружающей среды. Реагирование на инциденты - Мы поддерживаем план реагирования на инциденты для быстрого обнаружения, реагирования и восстановления после инцидентов безопасности. В случае утечки данных, которая может затронуть вас, мы уведомим вас в соответствии с применимыми законами. Хотя мы применяем строгие меры безопасности, ни одна система не является полностью безопасной. Вы несете ответственность за поддержание безопасности учетных данных своей учетной записи и своевременное уведомление нас о любом несанкционированном доступе."
        },
        section5: {
          title: "5. Хранение и удаление данных",
          content: "Мы храним ваши персональные данные в течение разных периодов в зависимости от типа информации и цели: Активные учетные записи - Персональная информация и информация об учетной записи сохраняются до тех пор, пока ваша учетная запись остается активной и вы продолжаете использовать наши услуги. Закрытые учетные записи - После закрытия вашей учетной записи мы сохраняем определенную информацию в течение до 24 месяцев для соблюдения юридических обязательств, разрешения споров и предотвращения мошенничества. Записи о выставлении счетов - Финансовые записи и счета хранятся в течение 7 лет для соблюдения налоговых и бухгалтерских правил. Журналы сервера - Технические журналы обычно хранятся в течение 90 дней для устранения неполадок и целей безопасности, после чего они автоматически удаляются. Маркетинговые данные - Если вы отказываетесь от маркетинговых сообщений, мы сохраним минимальную информацию для выполнения вашего предпочтения отказа. Вы можете запросить удаление своих персональных данных в любое время, связавшись с нашей службой поддержки по адресу support@netgrid.host. Мы обработаем ваш запрос в течение 30 дней, при условии соблюдения наших юридических обязательств по сохранению определенной информации."
        },
        section6: {
          title: "6. Ваши права на конфиденциальность",
          content: "В соответствии с применимыми законами о защите данных, включая GDPR и UK GDPR, вы имеете следующие права: Право на доступ - Вы можете запросить копию персональных данных, которые мы храним о вас. Право на исправление - Вы можете запросить исправление неточных или неполных персональных данных. Право на удаление - Вы можете запросить удаление ваших персональных данных с учетом требований законного хранения. Право на ограничение - Вы можете запросить, чтобы мы ограничили обработку ваших персональных данных в определенных обстоятельствах. Право на переносимость данных - Вы можете запросить копию ваших данных в структурированном, машиночитаемом формате. Право на возражение - Вы можете возражать против обработки ваших персональных данных для определенных целей, включая маркетинг. Право на отзыв согласия - Если обработка основана на согласии, вы можете отозвать согласие в любое время. Право на подачу жалобы - Вы имеете право подать жалобу в Управление комиссара по информации (ICO) в Великобритании, если считаете, что мы нарушили ваши права на конфиденциальность. Чтобы воспользоваться любым из этих прав, пожалуйста, свяжитесь с нами по адресу support@netgrid.host с указанием данных вашей учетной записи и конкретного запроса. Мы ответим в течение 30 дней."
        },
        section7: {
          title: "7. Международные передачи данных",
          content: "NetGrid Host работает на глобальном уровне и может передавать ваши персональные данные в страны за пределами вашей страны проживания, включая страны, которые могут не иметь таких же законов о защите данных. Когда мы передаем данные на международном уровне, мы применяем соответствующие меры защиты, включая: Стандартные договорные положения - Мы используем стандартные договорные положения ЕС, одобренные Европейской комиссией, для передач из ЕЭЗ в страны без адекватной защиты. Решения об адекватности - Мы можем передавать данные в страны, которые признаны обеспечивающими адекватную защиту данных Европейской комиссией или властями Великобритании. Меры безопасности - Независимо от местоположения, все передачи данных шифруются и подчиняются нашим комплексным политикам безопасности. Используя наши услуги, вы соглашаетесь на передачу вашей информации в наши объекты и объекты третьих лиц, с которыми мы ее передаем, как описано в настоящей политике."
        },
        section8: {
          title: "8. Конфиденциальность детей",
          content: "Наши услуги не предназначены для лиц младше 18 лет, и мы сознательно не собираем личную информацию от детей. Если вы являетесь родителем или опекуном и считаете, что ваш ребенок предоставил нам личную информацию, пожалуйста, немедленно свяжитесь с нами по адресу support@netgrid.host, и мы предпримем шаги для удаления такой информации из наших систем."
        },
        section9: {
          title: "9. Изменения в настоящей Политике конфиденциальности",
          content: "Мы можем время от времени обновлять настоящую Политику конфиденциальности, чтобы отразить изменения в наших практиках, технологиях, юридических требованиях или других факторах. Мы опубликуем обновленную политику на этой странице с новой датой 'Последнее обновление'. В случае существенных изменений мы предоставим заметное уведомление на нашем веб-сайте или отправим вам уведомление по электронной почте не менее чем за 30 дней до вступления изменений в силу. Ваше продолжающееся использование наших услуг после даты вступления в силу означает принятие обновленной политики."
        },
        section10: {
          title: "10. Контактная информация",
          content: "Если у вас есть какие-либо вопросы, проблемы или запросы относительно настоящей Политики конфиденциальности или наших практик обработки данных, пожалуйста, свяжитесь с нами по адресу: Email: support@netgrid.host, Корпоративный Email: about@netgrid.host, Адрес: NetGrid Host Ltd, Unit A, 82 James Carter Road, Mildenhall, IP28 7DE, United Kingdom. Мы стремимся решать любые проблемы конфиденциальности, которые у вас могут возникнуть, и ответим на все запросы в разумные сроки."
        }
      },
      cookie: {
        title: "Политика Cookie",
        subtitle: "Понимание того, как NetGrid Host использует cookies и аналогичные технологии отслеживания",
        lastUpdated: "Последнее обновление: 1 декабря 2025",
        section1: {
          title: "1. Что такое Cookies и как они работают",
          content: "Cookies — это небольшие текстовые файлы, которые размещаются на вашем компьютере, смартфоне или другом устройстве при посещении нашего веб-сайта. Они содержат информацию, которая передается на жесткий диск вашего устройства и позволяют нашему веб-сайту распознавать ваше устройство и запоминать определенную информацию о вашем посещении. Cookies служат различным целям, от обеспечения базовой функциональности до помощи нам в понимании того, как посетители взаимодействуют с нашим веб-сайтом. Они могут быть 'сессионными cookies', которые истекают при закрытии браузера, или 'постоянными cookies', которые остаются на вашем устройстве в течение установленного периода или до тех пор, пока вы их не удалите. Собственные cookies устанавливаются непосредственно нашим веб-сайтом, в то время как сторонние cookies устанавливаются другими службами, которые появляются на наших страницах. Используя наш веб-сайт, вы соглашаетесь с использованием cookies в соответствии с настоящей Политикой Cookie. Если вы не согласны с использованием нами cookies, вам следует соответствующим образом настроить параметры браузера или не использовать наш веб-сайт."
        },
        section2: {
          title: "2. Типы Cookies, которые мы используем",
          content: "Строго необходимые Cookies - Эти cookies необходимы для правильной работы веб-сайта и не могут быть отключены в наших системах. Обычно они устанавливаются в ответ на действия, которые вы совершаете, такие как вход в систему, заполнение форм или установка параметров конфиденциальности. Эти cookies не хранят никакой личной идентифицирующей информации. Примеры включают cookies аутентификации, cookies безопасности и cookies балансировки нагрузки. Функциональные Cookies - Эти cookies обеспечивают расширенную функциональность и персонализацию, такую как запоминание предпочтения языка, выбора региона или информации для входа. Они могут быть установлены нами или сторонними провайдерами, чьи услуги мы используем. Если вы отключите эти cookies, некоторые или все эти функции могут работать неправильно. Cookies производительности и аналитики - Мы используем эти cookies для подсчета посещений и источников трафика, чтобы мы могли измерять и улучшать производительность нашего сайта. Они помогают нам понять, какие страницы наиболее популярны, как посетители перемещаются по нашему веб-сайту и выявлять технические проблемы. Вся информация, собираемая этими cookies, агрегирована и анонимна. Если вы не разрешите эти cookies, мы не сможем отслеживать производительность нашего сайта или улучшать пользовательский опыт на основе поведения посетителей. Cookies предпочтений - Эти cookies запоминают ваш выбор и настройки для обеспечения более персонализированного опыта, такие как предпочитаемая валюта, язык или настройки уведомлений."
        },
        section3: {
          title: "3. Конкретные Cookies, которые мы используем",
          content: "Наш веб-сайт использует следующие конкретные cookies: Сессионный Cookie (PHPSESSID) - Необходимый cookie, который поддерживает состояние вашей сессии при навигации по нашему веб-сайту. Истекает при закрытии браузера. Токен аутентификации (auth_token) - Поддерживает вас в системе в вашей учетной записи во время сессии. Истекает через 30 дней бездействия. Предпочтение языка (lang_pref) - Запоминает выбранное вами предпочтение языка. Постоянный cookie, который действует в течение 1 года. Cookies аналитики (Google Analytics: _ga, _gid, _gat) - Эти cookies помогают нам понять, как посетители взаимодействуют с нашим веб-сайтом, собирая и сообщая информацию анонимно. Cookie _ga действует в течение 2 лет, _gid в течение 24 часов, а _gat в течение 1 минуты. Cookie безопасности (csrf_token) - Защищает от атак межсайтовой подделки запросов. Необходим для безопасности, истекает с сессией. Конкретные cookies, которые мы используем, могут меняться со временем по мере улучшения наших услуг и внедрения новых технологий. Мы обновим эту политику, чтобы отразить любые значительные изменения."
        },
        section4: {
          title: "4. Сторонние Cookies и службы",
          content: "Наш веб-сайт может включать контент и услуги от третьих лиц, которые могут устанавливать свои собственные cookies. Мы не контролируем эти сторонние cookies и рекомендуем ознакомиться с их политиками конфиденциальности и cookies: Платежные процессоры - Когда вы совершаете платеж, наши платежные партнеры могут устанавливать cookies для облегчения безопасных транзакций и предотвращения мошенничества. Инструменты поддержки клиентов - Мы используем сторонние службы поддержки, которые могут устанавливать cookies для предоставления функциональности чата и отслеживания взаимодействий с поддержкой. Сети доставки контента (CDN) - Наши провайдеры CDN могут использовать cookies для оптимизации доставки контента и улучшения времени загрузки. Поставщики аналитики - Мы используем сторонние службы аналитики для понимания использования веб-сайта и улучшения пользовательского опыта. Обратите внимание, что мы не контролируем сторонние cookies, и их использование подчиняется политикам конфиденциальности и cookies соответствующих третьих лиц. Мы рекомендуем вам ознакомиться с этими политиками, чтобы понять, как может использоваться ваша информация."
        },
        section5: {
          title: "5. Как управлять и удалять Cookies",
          content: "Вы имеете право решать, принимать или отклонять cookies. Большинство веб-браузеров автоматически принимают cookies, но обычно вы можете изменить настройки браузера, чтобы отклонять cookies, если предпочитаете. Настройки браузера - Вы можете управлять cookies через настройки браузера. Каждый браузер отличается, поэтому проверьте меню 'Справка' вашего браузера, чтобы узнать, как изменить предпочтения cookies. Обратите внимание, что если вы отключите cookies, некоторые функции нашего веб-сайта могут работать неправильно, и ваш пользовательский опыт может быть ухудшен. Инструкции для конкретных браузеров: Chrome - Настройки > Конфиденциальность и безопасность > Cookies и другие данные сайта; Firefox - Настройки > Конфиденциальность и безопасность > Cookies и данные сайта; Safari - Настройки > Конфиденциальность > Cookies и данные веб-сайта; Edge - Настройки > Cookies и разрешения сайта > Cookies и данные сайта. Инструменты отказа - Вы можете отказаться от cookies аналитики, установив дополнения браузера, такие как дополнение браузера для отказа от Google Analytics. Мобильные устройства - Пользователи мобильных устройств могут управлять cookies через настройки устройства или через настройки приложения браузера. Сигналы Do Not Track - Наш веб-сайт в настоящее время не реагирует на сигналы Do Not Track (DNT), поскольку не существует отраслевого стандарта для интерпретации сигналов DNT."
        },
        section6: {
          title: "6. Обновления настоящей Политики Cookie",
          content: "Мы можем время от времени обновлять настоящую Политику Cookie, чтобы отразить изменения в наших практиках использования cookies или по юридическим, нормативным или операционным причинам. Мы уведомим вас о любых существенных изменениях, опубликовав новую Политику Cookie на этой странице с обновленной датой 'Последнее обновление'. Мы рекомендуем вам периодически просматривать настоящую Политику Cookie, чтобы быть в курсе нашего использования cookies и того, как вы можете ими управлять. Ваше продолжающееся использование нашего веб-сайта после любых изменений в настоящей Политике Cookie будет означать ваше принятие таких изменений."
        }
      },
      refund: {
        title: "Политика возврата",
        subtitle: "Наша приверженность вашему удовлетворению - четкие и справедливые условия возврата",
        lastUpdated: "Последнее обновление: 1 декабря 2025",
        section1: {
          title: "1. Обзор гарантии возврата денег",
          content: "NetGrid Host стремится предоставлять высококачественные услуги VPS хостинга и удовлетворенность клиентов. Мы предлагаем 3-дневную гарантию возврата денег для новых клиентов, которые не удовлетворены нашими услугами. Эта гарантия действует с момента первоначальной активации учетной записи на netgrid.host или любом из его поддоменов. Если вы решите, что наши услуги VPS не подходят для ваших нужд в течение первых 3 дней, вы можете запросить возврат средств при условии соблюдения условий, изложенных в настоящей политике. Если вы одновременно заказываете несколько экземпляров VPS, только первая услуга имеет право на возврат. Эта политика возврата демонстрирует нашу уверенность в наших услугах и гарантирует, что вы можете попробовать NetGrid Host с минимальным финансовым риском. Пожалуйста, внимательно прочитайте эту политику, чтобы понять условия, положения и процедуры запроса возврата."
        },
        section2: {
          title: "2. Подходящие услуги и клиенты",
          content: "Возвраты доступны при следующих условиях: Только новые клиенты - Гарантия возврата денег применяется только к клиентам, впервые приобретающим услуги NetGrid Host VPS. Возвращающиеся клиенты, которые ранее использовали наши услуги, не имеют права на возврат. Только первая услуга - Возвраты предоставляются только для первой заказанной услуги VPS. Если вы одновременно заказываете несколько экземпляров VPS, только первая услуга имеет право на возврат. Другие услуги, заказанные одновременно, не подлежат возврату. Только услуги VPS - Эта политика возврата применяется исключительно к услугам VPS хостинга. Она не распространяется на регистрацию доменов, SSL-сертификаты, выделенные IP-адреса, услуги резервного копирования или любые дополнительные услуги, приобретенные отдельно. Временные рамки - Вы должны запросить возврат в течение 3 дней (72 часа) с момента первоначальной активации вашей услуги VPS. Запросы на возврат, поданные после этого периода, не будут обработаны. Статус учетной записи - Ваша учетная запись должна быть в хорошем состоянии без нарушений наших Условий использования. Учетные записи, приостановленные или прекращенные за нарушения политики, не имеют права на возврат."
        },
        section3: {
          title: "3. Процесс запроса возврата",
          content: "Чтобы запросить возврат по нашей гарантии возврата денег, пожалуйста, выполните следующие шаги: Шаг 1: Удалите все активные услуги - Перед подачей запроса на возврат вы должны удалить все активные услуги VPS из своей учетной записи. Услуги, которые остаются активными в течение периода обработки возврата, аннулируют ваш запрос на возврат. Шаг 2: Свяжитесь со службой поддержки - Откройте тикет поддержки ТОЛЬКО через панель управления учетной записью. Запросы по электронной почте обрабатываться не будут. Укажите адрес электронной почты учетной записи, номер заказа и причину запроса возврата (необязательно). Шаг 3: KYC идентификация - В целях безопасности и предотвращения мошенничества все клиенты должны пройти KYC (Know Your Customer) верификацию, предоставив документ, удостоверяющий личность, выданный государством. Бизнес-клиенты должны подать официальную заявку на возврат на фирменном бланке компании, подписанную уполномоченным представителем и с печатью компании. Шаг 4: Время обработки - Запросы на возврат обрабатываются в течение 30 дней с момента подачи при условии отсутствия жалоб на злоупотребления в отношении вашей учетной записи. Фактическое время появления средств на вашем счете зависит от вашего платежного провайдера и может занять дополнительные 3-7 рабочих дней. Шаг 5: Способ возврата - Возвраты выдаются на исходный способ оплаты, использованный для покупки. Если исходный способ оплаты больше не доступен, альтернативные договоренности могут быть обсуждены с нашей службой поддержки."
        },
        section4: {
          title: "4. Расчеты возврата и вычеты",
          content: "Возврату подлежит только стоимость самого продукта (услуги) за вычетом комиссии за возврат и с учётом скидок. Комиссия за возврат зависит от способа оплаты и может достигать до 14% от суммы платежа — уточните её в поддержке до оплаты. Комиссии и расходы, связанные с самим платежом, не возвращаются: комиссия платёжной системы, сервисный сбор, комиссия банка или обменника, комиссия сети для криптовалюты, расходы на конвертацию валюты и любые иные расходы на проведение оплаты. Если валюта возврата не совпадает с валютой платежа, дополнительно удерживается комиссия за конвертацию; конвертация выполняется по среднерыночному курсу на дату возврата, определяемому нами. Скидки и бонусы вычитаются из возвращаемой базы: возвращается фактически уплаченная сумма, а не цена до скидок. Понятия «неиспользованные дни» не существует: вне 3-дневного окна услуга считается полностью оплаченной и оказанной, возврат за оставшийся срок не производится. В отдельных случаях мы вправе запросить верификацию личности (KYC) или юридического лица (KYB); если проверка не пройдена или документы не предоставлены, возврат не выполняется. Средства на балансе аккаунта возврату не подлежат (возможен возврат только конкретного платежа-пополнения, целиком, в течение 3 дней и если из него ничего не израсходовано) — это правило действует в том числе в целях политики противодействия отмыванию денег (AML/KYC)."
        },
        section5: {
          title: "5. Невозвратные услуги и сборы",
          content: "Следующие элементы НЕ покрываются нашей политикой возврата и не подлежат возврату ни при каких обстоятельствах: Жалобы на злоупотребления - Если была подана любая жалоба на злоупотребления на адреса abuse@netgrid.host или abuse-report@netgrid.host в отношении вашей услуги, ваша учетная запись немедленно теряет право на возврат. Регистрация доменов - Сборы за регистрацию и продление доменных имен не подлежат возврату. Регистрация доменов включает сторонних регистраторов и не может быть отменена. SSL-сертификаты - Покупки SSL-сертификатов обрабатываются через сторонние центры сертификации и не подлежат возврату после выдачи. Выделенные IP-адреса - Сборы за дополнительные IP-адреса не подлежат возврату после их выделения вашей учетной записи. Сборы за настройку - Любые единовременные сборы за настройку или миграцию не подлежат возврату. Услуги резервного копирования - Сборы за автоматическое резервное копирование за использованный период не подлежат возврату. Превышения пропускной способности - Плата за использование пропускной способности, превышающее лимиты вашего плана, не подлежит возврату. Услуги сверх 3 дней - Любое использование услуги VPS за пределами 3-дневного периода гарантии возврата денег не подлежит возврату. Если вы отмените после 3 дней, возврат не будет предоставлен, но ваша услуга останется активной до конца вашего текущего расчетного периода. Платежи за продление - Автоматические платежи за продление не подлежат возврату, если услуга была продлена и использована за пределами первоначального 3-дневного периода гарантии."
        },
        section6: {
          title: "6. Условия дисквалификации и отказа",
          content: "Запросы на возврат будут отклонены в следующих обстоятельствах: Нарушения Условий использования - Если ваша учетная запись была приостановлена или прекращена за нарушение наших Условий использования, включая, помимо прочего: отправку спама, хостинг вредоносного контента, участие в незаконной деятельности, чрезмерное использование ресурсов или злоупотребление нашими системами. Жалобы на злоупотребление - Если мы получим жалобу на злоупотребление о вашем VPS или IP-адресе, выделенном вашей учетной записи, по адресу abuse@netgrid.host в течение 3-дневного периода гарантии или периода обработки возврата, ваш запрос на возврат будет автоматически отклонен. Мошенническая деятельность - Любые признаки мошеннической деятельности, включая споры о возврате платежей, поданные платежным провайдерам, ложную информацию, предоставленную во время регистрации, или попытку манипулировать процессом возврата. Множественные учетные записи - Создание нескольких учетных записей с одной и той же платежной информацией без предварительного уведомления и одобрения от NetGrid Host. Злоупотребление ресурсами - Чрезмерное использование системных ресурсов, которое влияет на других пользователей или нашу инфраструктуру, включая, помимо прочего, майнинг криптовалюты, операции ботнетов или DDoS-атаки. Предыдущие возвраты - Клиенты, которые ранее получали возвраты от NetGrid, не имеют права на дополнительные возвраты при новых покупках."
        },
        section7: {
          title: "7. Статус учетной записи после возврата",
          content: "После обработки возврата: Закрытие учетной записи - Ваша учетная запись NetGrid Host будет навсегда закрыта, и вы потеряете доступ ко всем услугам, данным и информации об учетной записи. Удаление данных - Все данные, хранящиеся на вашем VPS, включая файлы, базы данных, конфигурации и резервные копии, будут безвозвратно удалены в течение 7 дней после одобрения возврата. Мы настоятельно рекомендуем загрузить любые важные данные перед подачей запроса на возврат. Нет восстановления данных - После закрытия учетной записи и удаления данных мы не можем восстановить какую-либо информацию. Услуги восстановления данных недоступны для закрытых учетных записей. Будущие услуги - Если вы захотите снова использовать услуги NetGrid Host в будущем, вам нужно будет создать новую учетную запись. Однако новая учетная запись не будет иметь права на гарантию возврата денег, поскольку вы больше не будете считаться новым клиентом."
        },
        section8: {
          title: "8. Отмена без возврата",
          content: "Если вы хотите отменить свою услугу VPS после истечения 3-дневного периода гарантии возврата денег: Нет возврата - Возврат не будет предоставлен за оставшееся время в вашем расчетном периоде. Непрерывность услуги - Ваша услуга VPS останется активной и доступной до конца вашего текущего оплаченного периода. Автопродление - Чтобы предотвратить будущие платежи, вы должны отключить автопродление в настройках учетной записи. Если автопродление не отключено, ваша услуга автоматически продлится в конце расчетного периода. Процесс отмены - Чтобы отменить, войдите в панель управления учетной записью, перейдите к своим активным услугам и выберите опцию отмены. Вы также можете связаться с нашей службой поддержки для помощи с отменой. Окончательный счет - Вы остаетесь ответственными за любые непогашенные счета или сборы, понесенные до даты отмены."
        },
        section9: {
          title: "9. Разрешение споров",
          content: "Если вы считаете, что ваш запрос на возврат был несправедливо отклонен, или у вас есть проблемы с нашим процессом возврата: Внутренняя проверка - Свяжитесь с нашей службой поддержки, чтобы запросить пересмотр решения о возврате. Предоставьте любую дополнительную информацию или документацию, которая может поддержать ваше дело. Эскалация руководству - Если первоначальная проверка не решит вашу проблему, вы можете запросить эскалацию руководству для дальнейшего рассмотрения. Возвраты платежей - Мы настоятельно не рекомендуем инициировать возвраты платежей с вашим платежным провайдером без предварительной попытки решить проблему с нашей службой поддержки. Возвраты платежей могут привести к дополнительным сборам, прекращению учетной записи и потенциальным юридическим действиям. Обратите внимание, что инициирование возврата платежа аннулирует любые текущие или будущие запросы на возврат. Альтернативное разрешение споров - Для неразрешенных споров мы открыты для альтернативных методов разрешения споров, таких как посредничество, как указано в наших Условиях использования."
        },
        section10: {
          title: "10. Обновления политики и контактная информация",
          content: "NetGrid Host оставляет за собой право изменять настоящую Политику возврата в любое время. Изменения вступают в силу немедленно после публикации на этой странице с обновленной датой редакции. Продолжающееся использование наших услуг после изменений означает принятие измененной политики. По вопросам настоящей Политики возврата или для запроса возврата, пожалуйста, свяжитесь с нами: Email: support@netgrid.host, Тема письма: Запрос на возврат, Необходимая информация: электронная почта учетной записи, номер заказа и причина возврата. Наша служба поддержки обычно отвечает в течение 24 часов в рабочие дни (понедельник-пятница, 9:00-18:00 UTC). Мы стремимся обрабатывать все законные запросы на возврат справедливо и оперативно."
        }
      }
    },
    seo: {
      home: {
        title: "NetGrid Host — Быстрый VPS хостинг по Европе и США",
        description: "Быстрый и надёжный VPS хостинг по Европе и США. NVMe, порт 1 Gbps, аптайм 99,9%. Двенадцать дата-центров от Амстердама до Майами. От €2.98/мес.",
        keywords: "VPS хостинг, виртуальный приватный сервер, облачный хостинг, выделенный сервер, недорогой VPS, дешевый VPS, высокопроизводительный VPS, NVMe VPS, Linux VPS, VPS провайдер"
      },
      about: {
        title: "О компании NetGrid Host - 15+ лет превосходства в VPS хостинге",
        description: "Узнайте о NetGrid Host Ltd - ведущем провайдере VPS хостинга с опытом более 15 лет. Мы обслуживаем 12 000+ клиентов в 12 глобальных локациях с доступными высокопроизводительными виртуальными приватными серверами.",
        keywords: "о NetGrid, VPS компания, провайдер хостинга, NetGrid Host Ltd, провайдер виртуальных приватных серверов, VPS хостинг компания"
      },
      support: {
        title: "Поддержка NetGrid Host - Техническая поддержка 24/7 и обслуживание клиентов",
        description: "Получите помощь от экспертной команды поддержки NetGrid Host. Свяжитесь с нами для технической поддержки, вопросов о биллинге или сообщений о нарушениях. Ответ в течение 24 часов. Email: support@netgrid.host",
        keywords: "поддержка VPS, техническая поддержка, обслуживание клиентов, поддержка хостинга, контакт NetGrid Host, помощь VPS"
      },
      terms: {
        title: "Условия использования - VPS хостинг NetGrid Host",
        description: "Ознакомьтесь с Условиями использования NetGrid Host. Четкие и справедливые условия для использования наших услуг VPS хостинга. Узнайте об обязанностях пользователей, условиях оплаты и нашем SLA 99,9% времени работы.",
        keywords: "условия использования, условия VPS, условия хостинга, соглашение об услугах, пользовательское соглашение"
      },
      privacy: {
        title: "Политика конфиденциальности - Как NetGrid Host защищает ваши данные",
        description: "Политика конфиденциальности NetGrid Host объясняет, как мы собираем, используем и защищаем ваши персональные данные. Соответствие GDPR. Узнайте о ваших правах на конфиденциальность и мерах безопасности данных.",
        keywords: "политика конфиденциальности, защита данных, GDPR, персональные данные, безопасность данных, права на конфиденциальность"
      },
      cookie: {
        title: "Политика Cookie - Как NetGrid Host использует Cookies",
        description: "Узнайте о cookies, используемых на сайте NetGrid Host. Мы используем необходимые, функциональные и аналитические cookies для улучшения вашего опыта. Управляйте настройками cookies.",
        keywords: "политика cookie, cookies, веб-сайт cookies, управление cookies, отслеживающие cookies"
      },
      refund: {
        title: "Политика возврата - 3-дневная гарантия возврата денег | NetGrid Host",
        description: "NetGrid Host предлагает 3-дневную гарантию возврата денег для новых клиентов VPS. Узнайте о нашем процессе возврата, требованиям к праву на возврат и условиях. Справедливая и прозрачная политика возврата.",
        keywords: "политика возврата, гарантия возврата денег, возврат VPS, возврат хостинга, гарантия 3 дня"
      },
      affiliateTerms: {
        title: "Правила партнёрской программы | NetGrid Host",
        description: "Правила партнёрской программы NetGrid Host: требования к промо-материалам, запрет спама и введения в заблуждение, начисление и выплата вознаграждения, прекращение партнёрства.",
        keywords: "правила партнёрской программы, условия реферальной программы, партнёрская программа хостинга"
      },
      legal: {
        title: "Правовая информация | NetGrid Host",
        description: "Все правовые документы NetGrid Host Ltd в одном месте: условия использования, политика конфиденциальности, возврат средств, политика cookie, правила партнёрской программы и санкционный комплаенс.",
        keywords: "правовая информация, правовые документы, условия использования, политика конфиденциальности, политика возврата, политика cookie, санкционный комплаенс"
      },
      compliance: {
        title: "Санкционный комплаенс | NetGrid Host",
        description: "Как NetGrid Host Ltd соблюдает санкционные режимы Великобритании (OFSI), ЕС, США (OFAC) и ООН, список ограниченных юрисдикций и как мы проверяем местонахождение клиентов.",
        keywords: "санкционный комплаенс, ограниченные юрисдикции, OFSI, OFAC, санкционная политика, комплаенс хостинга"
      },
      affiliate: {
        title: "Партнерам - Заработайте 20% комиссии | NetGrid Host VPS Партнеры",
        description: "Присоединяйтесь к партнерской программе VPS NetGrid Host и зарабатывайте 20% комиссии без ограничения по времени с каждой продажи VPS. Лучшие ставки партнерки VPS хостинга в индустрии. Вывод заработка партнерки VPS в USDT TRC20 в течение 24 часов. Начните зарабатывать с партнерской программой VPS сегодня!",
        keywords: "партнерская программа VPS, партнерка VPS хостинга, партнерка хостинга, комиссия VPS партнерка, заработок на VPS, пассивный доход VPS, 20% комиссия VPS, партнерство VPS, вывод USDT партнерка, реферальная программа VPS, партнерская сеть хостинга, программа партнеров VPS"
      },
      netherlands: {
        title: "VPS Нидерланды - VPS хостинг в Меппеле | NetGrid Host",
        description: "VPS хостинг в Нидерландах (Меппел). Инфраструктура enterprise-уровня с портом 1Gbps, NVMe SSD, безлимитный трафик. Защита данных ЕС, 99.9% uptime. Закажите VPS в Нидерландах сегодня!",
        keywords: "VPS Нидерланды, VPS Netherlands, хостинг VPS Нидерланды, дата-центр Меппел, VPS ЕС, сервер Нидерланды, голландский VPS, VPS Голландия, выделенный сервер Нидерланды, европейский VPS"
      },
      germany: {
        title: "VPS Германия - VPS хостинг в Дюссельдорфе | NetGrid Host",
        description: "VPS хостинг в Германии (Дюссельдорф). Прямое подключение к DE-CIX, крупнейшей точке обмена трафиком в Европе. Enterprise NVMe SSD, порт 1Gbps, 99.9% uptime. Закажите немецкий VPS сервер сегодня!",
        keywords: "VPS Германия, VPS Дюссельдорф, немецкий VPS хостинг, DE-CIX дата-центр, Dusseldorf VPS, сервер Германия, VPS Deutschland, европейский VPS, выделенный сервер Германия"
      },
      poland: {
        title: "VPS Польша - VPS хостинг в Гданьске | NetGrid Host",
        description: "VPS хостинг в Польше (Гданьск). Экономичный европейский VPS премиум качества. NVMe SSD, порт 1Gbps, Baltic connectivity. Идеально для стартапов и восточноевропейских рынков.",
        keywords: "VPS Польша, VPS Гданьск, польский VPS хостинг, дата-центр Гданьск, сервер Польша, VPS Polska, VPS Восточная Европа, Baltic VPS, доступный европейский VPS"
      },
      latvia: {
        title: "VPS Латвия - VPS хостинг в Риге | NetGrid Host",
        description: "VPS хостинг в Латвии (Рига). Премиум Baltic connectivity, enterprise NVMe SSD, порт 1Gbps. Защита данных ЕС, низкая задержка до Северной Европы. Разверните VPS в Риге сегодня!",
        keywords: "VPS Латвия, VPS Рига, латвийский VPS хостинг, дата-центр Рига, сервер Латвия, Baltic VPS хостинг, Riga VPS, EU VPS, Северная Европа VPS"
      },
      romania: {
        title: "VPS Румыния - VPS хостинг в Бухаресте | NetGrid Host",
        description: "VPS хостинг в Румынии (Бухарест). Премиум связность с Юго-Восточной Европой, enterprise NVMe SSD, порт 1Gbps. Защита данных ЕС, низкая задержка. Разверните VPS в Бухаресте сегодня!",
        keywords: "VPS Румыния, VPS Бухарест, румынский VPS хостинг, дата-центр Бухарест, сервер Румыния, Юго-Восточная Европа VPS, Bucharest VPS, EU VPS, румынский хостинг"
      },
      snapshots: {
        title: "Снапшоты VPS — точка восстановления в один клик | NetGrid Host",
        description: "Снимок всего VPS в один клик и откат за минуты после неудачного обновления, взлома или ошибки. Снапшот стоит 30% от месячной цены VPS.",
        keywords: "снапшот VPS, снимок сервера, точка восстановления, бэкап VPS, откат VPS, NetGrid Host снапшот"
      },
      api: {
        title: "API для разработчиков — REST API NetGrid Host",
        description: "Управляйте VPS программно через REST API NetGrid Host: создание, переустановка, перезагрузка серверов, тарифы, ОС и дата-центры. Bearer-авторизация и IP allowlist.",
        keywords: "VPS API, API хостинга, REST API сервер, NetGrid Host API, создать VPS через API"
      },
      ukraine: {
        title: "VPS Украина - VPS хостинг в Киеве | NetGrid Host",
        description: "VPS хостинг в Украине (Киев). Низкая задержка по Украине, NVMe SSD, порт 1 Гбит/с, защита от DDoS.",
        keywords: "VPS Украина, VPS Киев, хостинг Украина"
      },
      italy: {
        title: "VPS Италия - VPS хостинг в Милане | NetGrid Host",
        description: "VPS хостинг в Италии (Милан). Премиум связность с Южной Европой, enterprise NVMe SSD, порт 1Gbps. Защита данных ЕС, низкая задержка. Разверните VPS в Милане сегодня!",
        keywords: "VPS Италия, VPS Милан, итальянский VPS хостинг, дата-центр Милан, сервер Италия, Южная Европа VPS, Milan VPS, EU VPS, итальянский хостинг"
      },
      switzerland: {
        title: "VPS Швейцария - Премиум VPS хостинг в Женеве | NetGrid Host",
        description: "Премиум VPS хостинг в Швейцарии (Женева). Швейцарское качество, безопасность банковского уровня, сеть 1Gbps. Швейцарские законы о конфиденциальности, 99.99% uptime. Разверните в Женеве сегодня!",
        keywords: "VPS Швейцария, VPS Женева, швейцарский VPS хостинг, дата-центр Женева, сервер Швейцария, швейцарский хостинг, премиум VPS, защищённый VPS, Geneva VPS, швейцарская конфиденциальность"
      },
      czechia: {
        title: "VPS Чехия - VPS хостинг в Праге | NetGrid Host",
        description: "VPS хостинг в Чехии (Прага). Центральноевропейский хаб с пирингом NIX.CZ, порт 1Gbps, NVMe SSD, uptime 99.9%. GDPR. Разверните VPS в Праге!",
        keywords: "VPS Чехия, VPS Прага, чешский VPS хостинг, дата-центр Прага, VPS сервер Чехия, Центральная Европа VPS, Прага хостинг"
      },
      miami: {
        title: "VPS Майами - VPS хостинг во Флориде | NetGrid Host",
        description: "VPS хостинг в Майами, Флорида. Стратегический шлюз в Латинскую Америку и Карибский бассейн. Порт 1Gbps, NVMe SSD, uptime 99.9%. Разверните VPS в Майами!",
        keywords: "VPS Майами, VPS Флорида, Майами VPS хостинг, дата-центр Флорида, VPS сервер Майами, хостинг Юго-Восток США, Латинская Америка VPS"
      },
      usa: {
        title: "VPS США - VPS хостинг в Лос-Анджелесе | NetGrid Host",
        description: "Премиум VPS хостинг в США (Лос-Анджелес). Связность мирового класса, инфраструктура enterprise, сеть 100Gbps. Сертификация SOC 2, задержка менее 5мс по США. Разверните в Лос-Анджелесе сегодня!",
        keywords: "VPS США, VPS Лос-Анджелес, американский VPS хостинг, дата-центр Лос-Анджелес, сервер США, Los Angeles VPS, хостинг Западное побережье, US VPS, California VPS, LA хостинг"
      },
      vpn: {
        title: "Личный VPN с выделенным IP — WireGuard, OpenVPN, AmneziaVPN, XRay VLESS | NetGrid Host",
        description: "Поднимите свой приватный VPN на выделенном IP, которым кроме вас никто не пользуется. Поддержка WireGuard, OpenVPN, AmneziaVPN и XRay VLESS. 13 локаций, безлимитный трафик, тарифы от €6/мес.",
        keywords: "личный VPN, VPN с выделенным IP, WireGuard VPN, OpenVPN хостинг, AmneziaVPN, XRay VLESS, приватный VPN сервер, VPN со своим IP, NetGrid Host VPN"
      },
      wiki: {
        title: "База знаний — как устроен VPS-хостинг | NetGrid Host",
        description: "Простыми словами о том, как реально работает VPS-хостинг: общая полоса, fair use, биллинг, шаблоны ОС, сетевая политика. То, что большинство хостеров умалчивают.",
        keywords: "база знаний VPS, wiki хостинга, общий порт объяснение, пропускная способность VPS, fair use хостинг, документация VPS"
      },
      "wiki-shared-1gbps-port-explained": {
        title: "Как устроен общий порт 1 Гбит/с в VPS | NetGrid Host",
        description: "Почему каждый VPS-хостер пишет 1 Gbps, но никогда не даёт честный гигабит круглосуточно. Подробное объяснение общего порта, oversubscription, burst vs sustained и политики справедливого использования.",
        keywords: "общий порт 1 Гбит/с, пропускная способность VPS, oversubscription, burst rate, sustained bandwidth, fair use VPS, шейпинг трафика"
      },
      "wiki-internet-speed-explained": {
        title: "Скорость интернета на VPS — что на самом деле меряет ваш speedtest | NetGrid Host",
        description: "1 Гбит/с на порту VPS — это не 1 Гбит/с до вас. Что именно меряет ваш speedtest, почему VPN обычно теряет скорость и сколько реально стоит выделенный канал между двумя городами.",
        keywords: "скорость интернета VPS, VPN потеря скорости, публичный интернет, выделенный канал цена, iperf3, speedtest, задержка, packet loss, RTT, пиринг, fair use"
      },
      "wiki-throttling-explained": {
        title: "Троттлинг на VPS — объясняем по-человечески неудобный вопрос провайдеру | NetGrid Host",
        description: "Троттлинг применяет каждый VPS-провайдер на планете на базовых тарифах, но почти никто не пишет о нём на лендинге. По-человечески: почему за €2.98 нельзя продать вечный гигабит, когда срабатывает наш шейпер и как отличить реальный троттлинг от других причин потерь скорости.",
        keywords: "троттлинг, шейпер, fair use, пропускная способность VPS, sustained трафик, rate limit, oversubscription, shared порт, точность speedtest, повторные замеры скорости"
      },
      "wiki-ip-geolocation-explained": {
        title: "Геолокация IP — почему ваш VPS может показывать не ту страну | NetGrid Host",
        description: "У IP-адреса нет встроенной страны. Геолокация — это сторонняя оценка из частных баз, которые обновляются с очень разной скоростью. Как это устроено, что мы делаем при каждом новом блоке IP и почему свежий сервер первые 2 недели может показываться не в той стране.",
        keywords: "геолокация IP, GeoIP, MaxMind, IPinfo, DB-IP, IP2Location, Ipregistry, IPGeolocation, GeoMyIP, WHOIS, BGP, точность геолокации, VPS не та страна"
      },
      "wiki-firewall-and-ports-explained": {
        title: "Открытые порты, фаерволы и «порт показывается закрытым извне» на VPS | NetGrid Host",
        description: "Все TCP/UDP-порты на вашем VPS открыты по умолчанию, кроме SMTP. Если внешний чекер говорит «closed», причина внутри VM: никто не слушает, не тот фаервол активен, либо сервис привязан к localhost. Как продиагностировать каждый случай меньше чем за минуту.",
        keywords: "открыть порт VPS, фаервол VPS, порт закрыт извне, ufw, iptables, nftables, firewalld, ss, netstat, блокировка SMTP, порт 25, listen 0.0.0.0, listen 127.0.0.1, проверка порта"
      },
      "wiki-essential-linux-diagnostics": {
        title: "Полезные команды диагностики Linux-сервера — ежедневный набор | NetGrid Host",
        description: "Копи-пейст-чеклист команд, которыми каждый день пользуется админ Linux VPS: информация о системе, CPU/RAM, диск, сеть, ping, mtr, speedtest, прослушиваемые порты, фаервол, логи. Команды установки во вкладках по Ubuntu/Debian и RHEL/Rocky/AlmaLinux.",
        keywords: "диагностика Linux, команды VPS чеклист, htop установка, mtr установка, ping, traceroute, ss netstat, df du, free, journalctl, dig, iperf3, speedtest, smartctl, ufw firewalld"
      },
      "wiki-launch-website-quick-start": {
        title: "Запустить сайт на VPS за 30 минут — домен, Cloudflare, бесплатный SSL и DDoS | NetGrid Host",
        description: "Самый дешёвый и быстрый путь до живого HTTPS-сайта в 2026: домен в GoDaddy, Cloudflare для бесплатного SSL и защиты от DDoS, VPS на NetGrid Host. Пошагово, с готовыми командами для HTML, PHP, Python и Node.js.",
        keywords: "развернуть сайт VPS, GoDaddy Cloudflare VPS, бесплатный SSL для сайта, бесплатная DDoS защита, A-запись VPS, настройка nginx, LEMP, gunicorn nginx, pm2 nginx, Origin SSL, Full strict"
      },
      "wiki-wireguard-vpn-setup": {
        title: "Свой WireGuard VPN на VPS — один скрипт, пять минут | NetGrid Host",
        description: "WireGuard — современный, быстрый VPN-протокол прямо в ядре Linux, заменивший OpenVPN. Поднимаем личный VPN на любом VPS NetGrid Host одной командой — установщик создаёт сервер, первого пользователя и печатает QR-код в терминале для приложения WireGuard.",
        keywords: "настройка WireGuard, WireGuard VPS, скрипт установки WireGuard, WireGuard vs OpenVPN, личный VPN, self-hosted VPN, WireGuard QR код, WireGuard конфиг, wg0.conf"
      },
      "wiki-crypto-payment-exact-amount": {
        title: "Оплата криптовалютой: почему сумма должна совпадать до последнего знака | NetGrid Host",
        description: "Наш крипто-шлюз узнаёт платёж по точной сумме. Отправите другую — хоть на один знак — и платёж не сопоставится и будет потерян. Почему так устроено и как безопасно платить с биржи через собственный кошелёк (SafePal).",
        keywords: "оплата криптовалютой, точная сумма, USDT TRC-20, оплата биткоином, недоплата, комиссия биржи за вывод, SafePal, оплата VPS криптой",
      },
      bulgaria: {
        title: "VPS Болгария — VPS хостинг в Софии | NetGrid Host",
        description: "VPS хостинг в Софии, Болгария. Балканский перекрёсток с пирингом BIX.BG, один AS-хоп до Стамбула, Бухареста и Афин. NVMe SSD, порт 1 Гбит/с, uptime 99.9%, GDPR.",
        keywords: "VPS Болгария, VPS София, болгарский VPS хостинг, дата-центр София, BIX.BG, Балканы хостинг, ЕС VPS, сервер София, Восточная Европа VPS"
      },
      greece: {
        title: "VPS Греция — VPS хостинг в Салониках | NetGrid Host",
        description: "VPS хостинг в Салониках, Греция. Средиземноморский порт данных с пирингом GR-IX и приземлением подводных кабелей. NVMe SSD, порт 1 Гбит/с, низкая задержка до Афин, Кипра и Леванта.",
        keywords: "VPS Греция, VPS Салоники, греческий VPS хостинг, дата-центр Салоники, GR-IX, Средиземноморский VPS, Афины VPS, сервер Греция, Кипр хостинг"
      },
      spain: {
        title: "VPS Испания — VPS хостинг в Барселоне | NetGrid Host",
        description: "VPS хостинг в Барселоне, Испания. Пиринг CATNIX, приземление подводных кабелей MAREA / 2Africa. NVMe SSD, порт 1 Гбит/с, uptime 99.9%. Менее 4 мс до Мадрида, GDPR.",
        keywords: "VPS Испания, VPS Барселона, испанский VPS хостинг, дата-центр Барселона, CATNIX, Мадрид VPS, Иберийский VPS, сервер Испания, Средиземноморский хостинг"
      }
    },
    affiliate: {
      hero: {
        badge: "Лучшие комиссионные в индустрии",
        title: "Зарабатывайте 20% Комиссии",
        subtitle: "Присоединяйтесь к самой прибыльной партнерской программе в индустрии хостинга — она охватывает и VPS, и VPN. Получайте щедрые комиссионные без ограничения по времени с каждой продажи и продления. Выплаты в USDT в течение 24 часов. Начните зарабатывать с партнерской программой NetGrid Host сегодня.",
        joinNow: "Стать партнером",
        learnMore: "Узнать больше"
      },
      stats: {
        commission: "20%",
        commissionLabel: "Ставка комиссии",
        duration: "Не ограничено",
        durationLabel: "Срок Cookie",
        payout: "24 Часа",
        payoutLabel: "Быстрые выплаты",
        minimum: "€50",
        minimumLabel: "Минимальный вывод"
      },
      why: {
        title: "Почему выбирают партнерскую программу VPS и VPN NetGrid Host?",
        subtitle: "Лучшие комиссионные с продаж и VPS, и VPN, и непревзойденные преимущества для наших партнеров",
        commission: {
          title: "20% за VPS и VPN",
          desc: "Зарабатывайте 20% комиссии с любой продажи VPS или VPN и любого продления — одна ставка, без ограничения по времени. Лучшие условия партнёрки в хостинг-индустрии."
        },
        duration: {
          title: "Бессрочный Cookie партнерки",
          desc: "Ваша реферальная ссылка VPS партнерки активна без ограничения по времени. Максимальный потенциал конверсии продаж VPS хостинга."
        },
        renewals: {
          title: "Повторяющийся доход VPS",
          desc: "Зарабатывайте комиссию с любого продления — VPS или VPN — без ограничения по времени. Создайте стабильный пассивный доход с партнерской программой NetGrid Host."
        },
        payout: {
          title: "Быстрые выплаты партнерам",
          desc: "Выводите заработок партнерской программы VPS на USDT TRC20 в течение 24 часов в рабочие дни."
        }
      },
      howItWorks: {
        title: "Как работает партнерская программа VPS",
        subtitle: "Начните зарабатывать за 4 простых шага с партнерской программой VPS",
        step1: {
          title: "Регистрация в партнерке VPS",
          desc: "Зарегистрируйтесь бесплатно в партнерской программе VPS и получите уникальную реферальную ссылку VPS мгновенно"
        },
        step2: {
          title: "Продвигайте VPS и VPN",
          desc: "Делитесь партнёрской ссылкой (засчитывает и VPS, и VPN) с вашей аудиторией через сайт, блог или социальные сети"
        },
        step3: {
          title: "Зарабатывайте",
          desc: "Получайте 20% комиссии с каждой продажи VPS или VPN без ограничения по времени, продления включены"
        },
        step4: {
          title: "Выводите заработок",
          desc: "Запрашивайте выплату партнерской программы VPS на USDT TRC20. Обрабатывается в течение 24 часов в рабочие дни"
        }
      },
      comparison: {
        title: "Сравнение партнерских программ хостинга",
        subtitle: "Посмотрите, почему NetGrid Host предлагает лучшие условия в индустрии хостинга — и по VPS, и по VPN",
        tableHeaders: {
          program: "Программа",
          commission: "Комиссия",
          cookie: "Срок Cookie",
          renewals: "Продления",
          payout: "Метод выплат",
          speed: "Скорость выплат"
        },
        netgrid: "NetGrid Host",
        competitor1: "Конкурент A",
        competitor2: "Конкурент B",
        competitor3: "Конкурент C",
        yes: "Да (бессрочно)",
        limited: "Ограничено (3 месяца)",
        no: "Нет",
        months: "мес.",
        days: "дней",
        hours: "24 часа",
        slowPayout: "5-7 дней",
        verySlow: "7-14 дней"
      },
      terms: {
        title: "Условия выплат партнерской программы VPS",
        withdrawalTitle: "Вывод средств партнерки VPS",
        accrualTitle: "Начисление комиссии VPS",
        minimum: "Минимальный вывод партнерки VPS: €50",
        fee: "Комиссия вывода: €3 (конвертируется по текущему курсу)",
        method: "Метод выплат партнерской программы: USDT TRC20",
        timing: "Время обработки: В течение 24 часов в рабочие дни (Пн-Пт)",
        monthlyAccrual: "Начисление комиссии партнерской программы VPS каждое 1-е число месяца",
        commission60: "Зарабатывайте 20% комиссии с каждой покупки VPS или VPN",
        renewals12: "Зарабатывайте комиссию с любого продления — VPS или VPN — без ограничения по времени",
        realtime: "Отслеживайте заработок партнерки VPS в реальном времени в панели",
        support: "Нужна помощь? Свяжитесь с нашей службой поддержки партнеров VPS"
      },
      form: {
        title: "Регистрация в партнерской программе",
        subtitle: "Заполните форму ниже, чтобы присоединиться к нашей партнерской программе",
        name: "Полное имя",
        email: "Email адрес",
        website: "Сайт/URL социальных сетей",
        experience: "Опыт в партнерках",
        experienceOptions: {
          beginner: "Начинающий (0-1 год)",
          intermediate: "Средний (1-3 года)",
          expert: "Эксперт (3+ лет)"
        },
        traffic: "Месячный трафик/Размер аудитории",
        message: "Расскажите о вашей стратегии продвижения (опционально)",
        agreement: "Я согласен с Условиями партнерской программы",
        submit: "Отправить заявку",
        submitting: "Отправка...",
        successMessage: "Заявка отправлена! Мы рассмотрим её и свяжемся с вами в течение 24 часов."
      },
      cta: {
        title: "Готовы начать зарабатывать с нашей партнерской программой?",
        subtitle: "Присоединяйтесь к тысячам партнёров, зарабатывающих пассивный доход с NetGrid Host — продажи и VPS, и VPN дают одинаковые 20% комиссии",
        button: "Стать партнером"
      }
    },
    netherlands: {
      seo: {
        title: "VPS Нидерланды - VPS хостинг в Меппеле | NetGrid Host",
        description: "VPS хостинг в Нидерландах (Меппел). Инфраструктура enterprise-уровня с портом 1Gbps, NVMe SSD, безлимитный трафик. Защита данных ЕС, 99.9% uptime. Закажите VPS в Нидерландах сегодня!",
        keywords: "VPS Нидерланды, VPS Netherlands, хостинг VPS Нидерланды, дата-центр Меппел, VPS ЕС, сервер Нидерланды, голландский VPS, VPS Голландия, выделенный сервер Нидерланды, европейский VPS"
      },
      hero: {
        badge: "Дата-центр Нидерланды - Меппел",
        title: "VPS хостинг в Нидерландах",
        subtitle: "Разверните VPS в Нидерландах (Меппел) с молниеносной скоростью 1Gbps, защитой данных ЕС и гарантией uptime 99.9%. Идеальная локация для европейских и глобальных проектов.",
        getStarted: "Начать",
        viewPricing: "Смотреть тарифы"
      },
      stats: {
        uptime: "99.9%",
        uptimeLabel: "Гарантированный Uptime",
        speed: "1 Гбит/с",
        speedLabel: "Скорость сети",
        traffic: "Безлимитный",
        trafficLabel: "Передача данных",
        location: "Меппел",
        locationLabel: "Город в Нидерландах"
      },
      why: {
        title: "Почему выбирают VPS в Нидерландах?",
        subtitle: "Нидерланды предлагают лучшую инфраструктуру для VPS хостинга в Европе",
        privacy: {
          title: "Защита данных ЕС",
          desc: "Строгие законы Европейского Союза о конфиденциальности (GDPR) обеспечивают максимальную защиту данных и анонимность для вашего VPS в Нидерландах."
        },
        infrastructure: {
          title: "Инфраструктура мирового класса",
          desc: "Нидерланды имеют одну из лучших интернет-инфраструктур в мире. Большинство VPN-сервисов и крупных сайтов выбирают Нидерланды для превосходной связности."
        },
        speed: {
          title: "Сверхбыстрое подключение",
          desc: "Прямое подключение к крупным европейским точкам обмена интернет-трафиком (AMS-IX). Порт 1Gbps с безлимитным трафиком для вашего VPS Нидерланды."
        },
        location: {
          title: "Стратегическое расположение в Европе",
          desc: "Дата-центр в Меппеле обеспечивает отличную связность со всей Европой с низкой задержкой до крупных городов ЕС."
        }
      },
      features: {
        title: "Технические характеристики VPS Нидерланды",
        subtitle: "VPS хостинг в Нидерландах enterprise-уровня с продвинутыми функциями",
        nvme: {
          title: "NVMe SSD накопители",
          desc: "Сверхбыстрые NVMe диски обеспечивают в 10 раз лучшую производительность, чем традиционные SSD для вашего VPS Нидерланды"
        },
        network: {
          title: "Сетевой порт 1Gbps",
          desc: "Общее подключение 1 Гигабит с безлимитной пропускной способностью для вашего VPS сервера в Нидерландах"
        },
        traffic: {
          title: "Безлимитный трафик",
          desc: "Без ограничений по пропускной способности - используйте столько передачи данных, сколько нужно для VPS в Нидерландах"
        },
        uptime: {
          title: "SLA 99.9% Uptime",
          desc: "Гарантированный uptime, обеспеченный резервной инфраструктурой в нашем дата-центре в Нидерландах"
        }
      },
      payment: {
        title: "Гибкие способы оплаты",
        subtitle: "Мы принимаем множество вариантов оплаты для VPS Нидерланды",
        methods: "Банковские карты, PayPal, Криптовалюты (Bitcoin, USDT), Банковский перевод"
      },
      location: {
        title: "Расположение дата-центра: Меппел, Нидерланды",
        subtitle: "Наш дата-центр в Нидерландах расположен в Меппеле, обеспечивая отличную связность по всей Европе",
        about: "Меппел стратегически расположен на северо-востоке Нидерландов, обеспечивая прямые оптоволоконные соединения с Амстердамской точкой обмена интернет-трафиком (AMS-IX) и другими крупными европейскими узлами. Это расположение гарантирует низкую задержку и высокоскоростное подключение для вашего VPS хостинга в Нидерландах.",
        benefits: [
          "Прямое подключение к AMS-IX (Амстердам)",
          "Низкая задержка по всей Европе (5-15мс)",
          "Резервное питание и охлаждение",
          "Безопасность и мониторинг 24/7",
          "Инфраструктура дата-центра соответствует требованиям ЕС"
        ]
      },
      cta: {
        title: "Готовы развернуть VPS в Нидерландах?",
        subtitle: "Начните работу с VPS хостингом в Нидерландах (Меппел) уже сегодня",
        button: "Заказать VPS Нидерланды"
      },
      pricing: {
        title: "VPS Нидерланды тарифы - VPS Меппел хостинг с портом 1Gbps",
        subtitle: "VPS Нидерланды Меппел дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Нидерландский VPS с GDPR соответствием для проектов ЕС."
      },
      flipCards: {
        title: "Интерактивные функции",
        subtitle: "Нажмите на карточки, чтобы узнать, что делает VPS в Нидерландах особенным",
        clickFlip: "Нажмите для переворота",
        items: [
          { title: "Прямой AMS-IX", desc: "Прямой пиринг с Amsterdam Internet Exchange - одной из крупнейших IXP в мире с 900+ участниками" },
          { title: "Конфиденциальность ЕС", desc: "Строгое соответствие GDPR и голландские законы о защите данных обеспечивают максимальную конфиденциальность" },
          { title: "Зелёная энергия", desc: "Дата-центр на 100% работает на возобновляемой энергии - Нидерланды лидируют в устойчивой инфраструктуре" },
          { title: "Поддержка 24/7", desc: "Экспертная команда поддержки на голландском и английском языках доступна круглосуточно" },
          { title: "Низкая задержка", desc: "Задержка менее 5мс по всей Европе, отличное подключение к Великобритании, Германии, Франции и Бенилюксу" },
          { title: "DDoS защита", desc: "Передовая DDoS защита с пропускной способностью 100Gbps+ для защиты ваших сервисов" }
        ]
      },
      masonry: {
        title: "Почему Нидерланды?",
        subtitle: "Откройте для себя преимущества голландского VPS хостинга",
        items: [
          { title: "Цифровой хаб", desc: "Амстердам - цифровая столица Европы с высочайшей плотностью дата-центров", badge: "Инфраструктура" },
          { title: "Свобода интернета", desc: "Нидерланды занимают 1 место по свободе интернета и сетевому нейтралитету", badge: "Свобода" },
          { title: "Оптоволоконная сеть", desc: "99% покрытия оптоволокном - лучшая интернет-инфраструктура в ЕС", badge: "Связность" },
          { title: "Технологические таланты", desc: "Дом ведущих европейских технологических компаний и стартапов", badge: "Инновации" },
          { title: "Стабильное питание", desc: "Надёжность питания 99.99% с резервным питанием от ветра и солнца", badge: "Надёжность" },
          { title: "Стратегическое расположение", desc: "Ворота между Великобританией, Германией и Скандинавией", badge: "География" }
        ]
      },
      process: {
        title: "Простой процесс развертывания",
        subtitle: "От заказа до онлайн в 4 простых шага",
        steps: [
          { title: "Выберите план", desc: "Выберите характеристики VPS под ваши нужды" },
          { title: "Настройте", desc: "Выберите ОС и дополнения мгновенно" },
          { title: "Разверните", desc: "Автоматическое развертывание за 60 секунд" },
          { title: "Запустите", desc: "Ваш VPS готов к использованию!" }
        ]
      },
      comparison: {
        title: "Нидерланды vs Другие",
        subtitle: "Посмотрите, почему NetGrid Host Нидерланды выделяется",
        feature: "Функция",
        netgrid: "NetGrid NL",
        others: "Другие",
        items: [
          { feature: "Прямой пиринг AMS-IX", netgrid: "Включено", others: "❌ Нет" },
          { feature: "NVMe хранилище", netgrid: "100%", others: "SSD или HDD" },
          { feature: "Время настройки", netgrid: "< 60 секунд", others: "Часы/Дни" },
          { feature: "DDoS защита", netgrid: "100Gbps+", others: "Базовая/Платная" },
          { feature: "Зелёная энергия", netgrid: "100%", others: "Частично" },
          { feature: "Язык поддержки", netgrid: "RU/EN/NL", others: "Только EN" }
        ]
      }
    },
    germany: {
      hero: {
        badge: "Дата-центр Дюссельдорф - Подключение к DE-CIX",
        title: "Премиум VPS хостинг в Германии",
        subtitle: "Запустите VPS в Дюссельдорфе с прямым подключением к DE-CIX, немецкими стандартами защиты данных и молниеносной производительностью. Оптимальный выбор для европейских бизнес-приложений.",
        getStarted: "Развернуть сейчас",
        viewPlans: "Смотреть тарифы"
      },
      stats: {
        latency: "<2мс",
        latencyLabel: "Задержка до DE-CIX",
        speed: "1 Гбит/с",
        speedLabel: "Сетевой порт",
        uptime: "99.9%",
        uptimeLabel: "SLA Uptime",
        exchange: "DE-CIX",
        exchangeLabel: "Точка обмена"
      },
      why: {
        title: "Почему выбирают VPS хостинг в Германии?",
        subtitle: "Германия предлагает непревзойденную инфраструктуру и связность для критически важных приложений",
        decix: {
          title: "Хаб DE-CIX Дюссельдорф",
          desc: "Прямое подключение к DE-CIX, крупнейшей в мире точке обмена интернет-трафиком по объему данных. Ваш VPS Германия получает непревзойденную глобальную связность и минимальную задержку."
        },
        dataProtection: {
          title: "Немецкая защита данных",
          desc: "Воспользуйтесь строгими немецкими законами о защите данных и соответствием GDPR. Идеально для финансовых услуг, здравоохранения и корпоративных приложений, требующих максимальной безопасности."
        },
        centralLocation: {
          title: "Сердце Европы",
          desc: "Стратегическое расположение Дюссельдорфа обеспечивает оптимальную связность по всей Европе, России и Ближнему Востоку. Идеальная задержка для обслуживания международной аудитории."
        },
        financial: {
          title: "Хостинг в бизнес-центре",
          desc: "Размещение в динамичном бизнес-районе Дюссельдорфа, одном из ведущих экономических центров Германии. Идеально для корпоративных приложений и международного бизнеса."
        }
      },
      infrastructure: {
        title: "Инфраструктура мирового класса",
        subtitle: "VPS хостинг в Германии enterprise-уровня с передовыми технологиями",
        network: {
          title: "Tier-1 сетевая связность",
          desc: "Множественные подключения к операторам Tier-1 и прямой пиринг с DE-CIX обеспечивают максимальный uptime и избыточность для вашего VPS Дюссельдорф"
        },
        storage: {
          title: "Enterprise NVMe массивы",
          desc: "Высокопроизводительные NVMe SSD накопители в конфигурации RAID10 обеспечивают исключительную скорость и защиту данных"
        },
        power: {
          title: "N+1 резервирование питания",
          desc: "Полностью резервированные системы питания с резервными генераторами гарантируют, что ваш немецкий VPS остается онлайн 24/7"
        },
        cooling: {
          title: "Продвинутые системы охлаждения",
          desc: "Современная инфраструктура охлаждения поддерживает оптимальную температуру для пиковой производительности VPS"
        }
      },
      useCases: {
        title: "Идеальные решения VPS Германия для",
        subtitle: "Узнайте, как бизнес использует наш VPS хостинг в Дюссельдорфе",
        ecommerce: {
          title: "E-Commerce платформы",
          desc: "Быстрая загрузка страниц по всей Европе с хостингом в Дюссельдорфе. Идеально для онлайн-магазинов, ориентированных на клиентов ЕС, со встроенным соответствием GDPR."
        },
        fintech: {
          title: "Финансовые приложения",
          desc: "Сверхнизкая задержка для торговых платформ и финтех-приложений. Размещение в бизнес-столице Германии с максимальной безопасностью."
        },
        gaming: {
          title: "Игровые серверы",
          desc: "Отличная связность для европейских игровых серверов. Низкий пинг по всему континенту для оптимального игрового опыта."
        },
        saas: {
          title: "SaaS приложения",
          desc: "Надежный хостинг для SaaS платформ, обслуживающих европейских клиентов. Немецкая инфраструктура обеспечивает соответствие суверенитету данных."
        }
      },
      location: {
        title: "Расположение дата-центра Дюссельдорф",
        subtitle: "Стратегическое позиционирование в бизнес и технологическом хабе Германии",
        about: "Наш дата-центр в Дюссельдорфе стратегически расположен в одном из важнейших бизнес-центров Германии, с прямым подключением к DE-CIX - ведущей мировой точке обмена интернет-трафиком. Это расположение предлагает непревзойденные возможности пиринга и гарантирует, что ваш VPS хостинг в Германии обеспечивает исключительную производительность по всей Европе, России, Ближнему Востоку и за их пределами.",
        benefits: [
          "Прямой пиринг с DE-CIX Дюссельдорф",
          "Множественные подключения к операторам Tier-1",
          "Задержка менее 2мс до крупных точек обмена",
          "Сертифицированный по ISO 27001 объект",
          "Немецкие стандарты дата-центра Tier III+"
        ]
      },
      cta: {
        title: "Готовы развернуть VPS в Германии?",
        subtitle: "Испытайте премиум VPS хостинг в Дюссельдорфе с инфраструктурой enterprise-уровня",
        button: "Начать сейчас"
      },
      pricing: {
        title: "VPS Германия тарифы - VPS Дюссельдорф хостинг с портом 1Gbps",
        subtitle: "VPS Германия Дюссельдорф дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Немецкий VPS с GDPR соответствием."
      }
    },
    poland: {
      hero: {
        badge: "Дата-центр Гданьск - Балтийский хаб",
        title: "Доступный VPS хостинг в Польше",
        subtitle: "Запустите VPS в Гданьске с европейским качеством по конкурентным ценам. Идеально для стартапов, восточноевропейских рынков и бизнеса, ищущего ценность без компромиссов.",
        getStarted: "Начать сейчас",
        viewPlans: "Смотреть тарифы"
      },
      stats: {
        price: "40%",
        priceLabel: "Ниже цена",
        speed: "1 Гбит/с",
        speedLabel: "Сетевой порт",
        uptime: "99.9%",
        uptimeLabel: "SLA Uptime",
        location: "Гданьск",
        locationLabel: "Tech хаб"
      },
      costEffective: {
        title: "Европейское качество, конкурентные цены",
        subtitle: "Получите премиум VPS хостинг без премиум цены",
        value: {
          title: "Лучшая цена в Европе",
          desc: "До 40% ниже стоимость по сравнению с западноевропейскими дата-центрами при сохранении той же инфраструктуры enterprise-уровня и стандартов производительности."
        },
        quality: {
          title: "Без компромиссов в качестве",
          desc: "Те же NVMe SSD накопители, резервированная сеть и мониторинг 24/7, как в наших премиум локациях. Европейские стандарты защиты данных полностью соблюдаются."
        },
        market: {
          title: "Идеально для растущих рынков",
          desc: "Оптимальное расположение для обслуживания клиентов из Восточной Европы, Прибалтики и Скандинавии. Низкая задержка по всему региону."
        },
        startup: {
          title: "Инфраструктура для стартапов",
          desc: "Запустите бизнес с минимальными вложениями. Масштабируйтесь по мере роста без больших затрат. Идеально для стартапов и MVP."
        }
      },
      techHub: {
        title: "Гданьск: Растущий Tech-хаб Польши",
        subtitle: "Почему стоит выбрать VPS хостинг в Гданьске",
        itCenter: {
          title: "Растущий IT-центр",
          desc: "Гданьск - один из самых быстрорастущих технологических городов Польши, где расположены многочисленные IT-компании, стартапы и международные tech-компании."
        },
        connectivity: {
          title: "Отличная связность",
          desc: "Стратегическое расположение на Балтийском море с отличными оптоволоконными соединениями со Скандинавией, Германией и Восточной Европой."
        },
        talent: {
          title: "База IT-талантов",
          desc: "Доступ к сильному польскому IT-сообществу и растущему сообществу разработчиков. Гданьский технический университет - крупный центр IT-образования."
        },
        infrastructure: {
          title: "Современная инфраструктура",
          desc: "Современный дата-центр со стандартами Tier III, резервированное питание и охлаждение, множественные подключения к операторам для максимальной надежности."
        }
      },
      startups: {
        title: "Идеальные решения VPS Польша для стартапов",
        subtitle: "Запускайте и масштабируйте свой бизнес с уверенностью",
        mvp: {
          title: "Разработка MVP",
          desc: "Тестируйте идеи без огромных первоначальных затрат. Наш доступный VPS хостинг в Гданьске позволяет быстро и эффективно валидировать продукт."
        },
        saas: {
          title: "SaaS платформы",
          desc: "Создавайте и развивайте SaaS бизнес с масштабируемой VPS инфраструктурой. Европейское расположение обеспечивает соответствие GDPR для клиентов ЕС."
        },
        agencies: {
          title: "Веб-агентства",
          desc: "Размещайте множество клиентских сайтов на надежной инфраструктуре. Конкурентные цены означают лучшую маржу для вашего агентства."
        },
        ecommerce: {
          title: "Интернет-магазины",
          desc: "Быстрая загрузка для польских и восточноевропейских клиентов. Экономичный хостинг для онлайн-магазинов, ориентированных на региональные рынки."
        }
      },
      location: {
        title: "Расположение дата-центра Гданьск",
        subtitle: "Стратегическое позиционирование на побережье Балтийского моря",
        about: "Наш дата-центр в Гданьске стратегически расположен в крупном портовом и технологическом городе Польши. Это первоклассное расположение на Балтийском море обеспечивает отличную связность с Северной и Восточной Европой, что делает его идеальным для бизнеса, ориентированного на эти быстрорастущие рынки. В сочетании с конкурентными ценами - это идеальный выбор для стартапов и экономных компаний, ищущих европейское качество.",
        benefits: [
          "Стандарты дата-центра Tier III",
          "Множественные подключения к операторам",
          "Низкая задержка до Прибалтики и Восточной Европы",
          "Соответствие защите данных ЕС",
          "На 40% ниже стоимость vs Западная Европа"
        ]
      },
      cta: {
        title: "Готовы запустить VPS в Польше?",
        subtitle: "Начните с экономичного VPS хостинга в Гданьске сегодня",
        button: "Начать сейчас"
      },
      pricing: {
        title: "VPS Польша тарифы - VPS Гданьск хостинг с портом 1Gbps",
        subtitle: "VPS Польша Гданьск дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Польский VPS с GDPR соответствием для Центральной Европы."
      }
    },
    latvia: {
      hero: {
        badge: "Дата-центр Латвия - Балтийские ворота",
        title: "VPS хостинг в Латвии",
        subtitle: "Разверните VPS в Латвии с отличной Baltic connectivity. Идеальные ворота к Северной Европе и балтийским рынкам с защитой данных ЕС.",
        getStarted: "Развернуть сейчас",
        viewPlans: "Смотреть тарифы"
      },
      stats: {
        latency: "<3мс",
        latencyLabel: "Задержка Baltic",
        speed: "1 Гбит/с",
        speedLabel: "Сетевой порт",
        uptime: "99.9%",
        uptimeLabel: "SLA Uptime",
        location: "Рига",
        locationLabel: "Столица"
      },
      why: {
        title: "Почему выбирают VPS хостинг в Латвии?",
        subtitle: "Стратегическое балтийское расположение с премиум инфраструктурой и связностью",
        gateway: {
          title: "Балтийские ворота",
          desc: "Стратегическое положение Риги делает её идеальными воротами к странам Балтии, Скандинавии и России. Отличная оптоволоконная связность по всему региону."
        },
        infrastructure: {
          title: "Современная инфраструктура",
          desc: "Дата-центр enterprise-класса с новейшими NVMe накопителями, резервированными системами питания и carrier-neutral связностью для максимальной надежности."
        },
        compliance: {
          title: "Защита данных ЕС",
          desc: "Полное соответствие GDPR и стандартам защиты данных ЕС. Идеально для бизнеса, обслуживающего европейских клиентов со строгими требованиями конфиденциальности."
        },
        connectivity: {
          title: "Превосходная связность",
          desc: "Множественные подключения к операторам Tier-1 и прямой пиринг обеспечивают низкую задержку до Северной Европы, балтийского региона и Скандинавии."
        }
      },
      technical: {
        title: "Enterprise техническая инфраструктура",
        subtitle: "Дата-центр мирового класса в Риге с передовыми технологиями",
        network: {
          title: "Резервированная сеть",
          desc: "Множественные upstream провайдеры и BGP маршрутизация обеспечивают максимальный uptime и возможности failover для вашего VPS Рига"
        },
        storage: {
          title: "NVMe SSD производительность",
          desc: "Массивы NVMe SSD последнего поколения обеспечивают исключительную I/O производительность для требовательных приложений"
        },
        power: {
          title: "Резервированные системы питания",
          desc: "N+1 резервирование питания с UPS резервным копированием и дизельными генераторами гарантируют непрерывную работу"
        },
        monitoring: {
          title: "Мониторинг 24/7",
          desc: "Круглосуточный мониторинг инфраструктуры и поддержка гарантируют, что ваш VPS остается онлайн и работает оптимально"
        }
      },
      useCases: {
        title: "Идеальные решения VPS Латвия",
        subtitle: "Откройте для себя применения VPS хостинга в Риге",
        regional: {
          title: "Региональные сервисы",
          desc: "Обслуживайте клиентов из Балтии и Северной Европы с локальным присутствием. Оптимальная задержка для Эстонии, Литвы, Финляндии и Швеции."
        },
        fintech: {
          title: "Финансовые сервисы",
          desc: "Воспользуйтесь растущим финтех-сектором Латвии. Совместимая инфраструктура для обработки платежей и финансовых приложений."
        },
        media: {
          title: "Медиа и стриминг",
          desc: "Высокопропускная связность идеальна для доставки медиа, стриминговых сервисов и сетей распространения контента."
        },
        business: {
          title: "Бизнес-приложения",
          desc: "Размещайте CRM, ERP и бизнес-ПО с надежной инфраструктурой и резидентностью данных ЕС для соответствия требованиям."
        }
      },
      location: {
        title: "Расположение дата-центра Рига",
        subtitle: "Столица Латвии и хаб балтийского региона",
        about: "Наш дата-центр в Риге стратегически расположен в столице Латвии, ключевом хабе для связности балтийского региона. Как один из крупнейших городов Балтии, Рига предлагает отличную инфраструктуру и служит естественными воротами к северноевропейским рынкам. Расположение обеспечивает оптимальную связность с Эстонией, Литвой, Финляндией, Швецией и за их пределами, что делает его идеальным для бизнеса, ориентированного на балтийские и скандинавские регионы.",
        benefits: [
          "Премиум дата-центр Tier III",
          "Множественные международные подключения к операторам",
          "Низкая задержка до стран Балтии и Скандинавии",
          "Полное соответствие EU GDPR",
          "Стратегические ворота в Северную Европу"
        ]
      },
      cta: {
        title: "Готовы развернуть VPS в Латвии?",
        subtitle: "Начните с премиум VPS хостинга в Риге сегодня",
        button: "Начать сейчас"
      },
      pricing: {
        title: "VPS Латвия тарифы - VPS Рига хостинг с портом 1Gbps",
        subtitle: "VPS Латвия Рига дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Латвийский VPS с GDPR соответствием для Балтийского региона."
      }
    },
    romania: {
      hero: {
        badge: "Дата-центр Румыния - Хаб Юго-Восточной Европы",
        title: "VPS Румыния Бухарест",
        subtitle: "Разверните VPS в дата-центре Румынии Бухарест с портом 1Gbps и EU соответствием. VPS Бухарест для связности с Юго-Восточной Европой.",
        getStarted: "Развернуть сейчас",
        viewPlans: "Смотреть тарифы"
      },
      stats: {
        latency: "<3мс",
        latencyLabel: "Региональная задержка",
        speed: "1 Гбит/с",
        speedLabel: "Сетевой порт",
        uptime: "99.9%",
        uptimeLabel: "SLA Uptime",
        location: "Бухарест",
        locationLabel: "Локация"
      },
      why: {
        title: "Почему выбрать VPS Румыния?",
        subtitle: "Стратегически расположенный в Бухаресте, наш румынский дата-центр предлагает исключительную ценность и производительность",
        gateway: {
          title: "Ворота в Юго-Восточную Европу",
          desc: "Идеальное расположение для обслуживания Румынии, Болгарии, Молдовы, Украины и всего региона Юго-Восточной Европы с низкой задержкой."
        },
        infrastructure: {
          title: "Современная инфраструктура",
          desc: "Современный дата-центр с оборудованием enterprise-класса, резервным питанием и передовыми системами охлаждения."
        },
        compliance: {
          title: "Защита данных ЕС",
          desc: "Полное соответствие нормам ЕС, включая GDPR. Ваши данные защищены европейскими стандартами защиты данных."
        },
        connectivity: {
          title: "Премиум связность",
          desc: "Несколько Tier-1 операторов обеспечивают отличную связность по всей Европе и за её пределами с низкими задержками."
        }
      },
      features: {
        title: "Функции VPS Румыния",
        subtitle: "Функции enterprise-класса включены в каждый тариф VPS Румыния",
        nvme: {
          title: "NVMe SSD хранилище",
          desc: "Молниеносное NVMe хранилище для максимальной производительности и надёжности."
        },
        security: {
          title: "DDoS защита",
          desc: "Расширенная защита от DDoS включена для поддержания ваших сервисов онлайн."
        },
        deployment: {
          title: "Мгновенное развертывание",
          desc: "Разверните VPS менее чем за 60 секунд с нашей автоматизированной системой."
        },
        backup: {
          title: "Автоматические бэкапы",
          desc: "Регулярные автоматические резервные копии для защиты ваших данных и обеспечения непрерывности бизнеса."
        },
        network: {
          title: "Порт 1 Гбит/с",
          desc: "Разделяемый порт 1 Гигабит с неограниченным трафиком для всех ваших потребностей."
        },
        monitoring: {
          title: "Мониторинг 24/7",
          desc: "Круглосуточный мониторинг обеспечивает максимальное время работы и быстрое решение проблем."
        }
      },
      infrastructure: {
        title: "Современная инфраструктура дата-центра",
        description: "Наш дата-центр в Бухаресте оснащён передовыми технологиями и инфраструктурой для максимальной производительности, надёжности и безопасности. Построен по европейским стандартам с компонентами enterprise-класса.",
        item1: "Дата-центр сертификации Tier III с резервными системами питания и охлаждения",
        item2: "Множественные оптоволоконные подключения к основным европейским точкам обмена (DE-CIX, AMS-IX)",
        item3: "Круглосуточная охрана на месте, мониторинг и техперсонал для немедленного решения проблем",
        item4: "Передовые системы пожаротушения, климат-контроля и мониторинга окружающей среды"
      },
      location: {
        title: "Стратегическое расположение в Бухаресте",
        description: "Бухарест, столица и крупнейший город Румынии, предлагает идеальное расположение для VPS хостинга в Юго-Восточной Европе. С отличной связностью к Балканам, Восточной Европе и за её пределами, наш дата-центр служит идеальным хабом для ваших приложений.",
        subtitle: "Расположение дата-центра",
        details: "Str. Gara Herăstrău, Бухарест, Румыния - Современный дата-центр в центре технологического района Румынии",
        benefits: [
          "Прямое подключение к основным европейским и азиатским сетям",
          "Низкая задержка до Румынии, Болгарии, Молдовы, Украины и Турции",
          "Полное соответствие защите данных ЕС (GDPR)",
          "Стратегические ворота к рынкам Юго-Восточной Европы",
          "Отличное соотношение цены и производительности по сравнению с Западной Европой",
          "Растущий технологический хаб с квалифицированными IT-специалистами"
        ]
      },
      cta: {
        title: "Готовы развернуть VPS в Румынии?",
        subtitle: "Начните с надёжного VPS хостинга в Румынии сегодня",
        button: "Начать сейчас"
      },
      pricing: {
        title: "VPS Румыния тарифы - VPS Бухарест хостинг с портом 1Gbps",
        subtitle: "VPS Румыния Бухарест дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Румынский VPS с GDPR соответствием для Юго-Восточной Европы."
      }
    },
    italy: {
      hero: {
        badge: "Дата-центр Италия - Хаб Южной Европы",
        title: "VPS Италия Милан хостинг",
        subtitle: "Разверните VPS в дата-центре Италии Милан с портом 1Gbps и EU GDPR соответствием. VPS Милан для связности с Южной Европой и Средиземноморьем.",
        getStarted: "Развернуть сейчас",
        viewPlans: "Смотреть тарифы"
      },
      stats: {
        latency: "<2мс",
        latencyLabel: "Региональная задержка",
        speed: "1 Гбит/с",
        speedLabel: "Сетевой порт",
        uptime: "99.9%",
        uptimeLabel: "SLA Uptime",
        location: "Милан",
        locationLabel: "Локация"
      },
      why: {
        title: "Почему выбрать VPS Италия?",
        subtitle: "Стратегически расположенный в Милане, наш итальянский дата-центр предлагает исключительную связность и производительность",
        gateway: {
          title: "Ворота в Южную Европу",
          desc: "Идеальное расположение для обслуживания Италии, Швейцарии, Франции и всего Средиземноморского региона с низкой задержкой."
        },
        infrastructure: {
          title: "Премиум инфраструктура",
          desc: "Современный миланский дата-центр с оборудованием enterprise-класса, резервными системами и передовым охлаждением."
        },
        compliance: {
          title: "Защита данных ЕС",
          desc: "Полное соответствие нормам ЕС, включая GDPR. Ваши данные защищены строгими европейскими стандартами."
        },
        connectivity: {
          title: "Связность мирового класса",
          desc: "Прямое подключение к MIX (Milan Internet Exchange) и нескольким Tier-1 операторам для оптимальной производительности."
        }
      },
      features: {
        title: "Функции VPS Италия",
        subtitle: "Функции enterprise-класса включены в каждый тариф VPS Милан",
        nvme: {
          title: "NVMe SSD хранилище",
          desc: "Молниеносное NVMe хранилище для максимальной производительности и надёжности."
        },
        security: {
          title: "DDoS защита",
          desc: "Расширенная защита от DDoS включена для поддержания ваших сервисов онлайн."
        },
        deployment: {
          title: "Мгновенное развертывание",
          desc: "Разверните VPS менее чем за 60 секунд с нашей автоматизированной системой."
        },
        backup: {
          title: "Автоматические бэкапы",
          desc: "Регулярные автоматические резервные копии для защиты ваших данных и обеспечения непрерывности бизнеса."
        },
        network: {
          title: "Порт 1 Гбит/с",
          desc: "Разделяемый порт 1 Гигабит с неограниченным трафиком для всех ваших потребностей."
        },
        monitoring: {
          title: "Мониторинг 24/7",
          desc: "Круглосуточный мониторинг обеспечивает максимальное время работы и быстрое решение проблем."
        }
      },
      infrastructure: {
        title: "Превосходство миланского дата-центра",
        description: "Наш миланский дата-центр представляет вершину итальянской технологической инфраструктуры. Построен по высшим европейским стандартам с передовым оборудованием и резервными системами.",
        item1: "Сертифицированный объект Tier III+ с резервированием N+1 для питания и охлаждения",
        item2: "Прямое подключение к MIX (Milan Internet Exchange) для оптимальной европейской связности",
        item3: "Круглосуточная охрана на месте, мониторинг и команда технической поддержки",
        item4: "Передовые системы климат-контроля и пожаротушения для максимального времени работы"
      },
      location: {
        title: "Милан - технологическая столица Италии",
        description: "Милан, финансовый и технологический хаб Италии, предоставляет идеальное расположение для VPS хостинга в Южной Европе. Наш дата-центр извлекает выгоду из инфраструктуры и связности мирового класса Милана.",
        subtitle: "Расположение дата-центра",
        details: "Via Caldera, Милан, Италия - Премиум дата-центр в технологическом районе Милана",
        benefits: [
          "Прямое подключение к средиземноморским и южноевропейским рынкам",
          "Низкая задержка до Италии, Швейцарии, Франции и региона MENA",
          "Полное соответствие EU GDPR",
          "Стратегические ворота в Южную Европу и Северную Африку",
          "Подключение к крупнейшей точке обмена интернет-трафиком Италии (MIX)",
          "Хаб моды, финансов и технологий с квалифицированной рабочей силой"
        ]
      },
      cta: {
        title: "Готовы развернуть VPS в Италии?",
        subtitle: "Начните с надёжного VPS хостинга в Милане сегодня",
        button: "Начать сейчас"
      },
      pricing: {
        title: "VPS Италия тарифы - VPS Милан хостинг с портом 1Gbps",
        subtitle: "VPS Италия Милан дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Итальянский VPS с GDPR соответствием для Южной Европы."
      }
    },
    switzerland: {
      hero: {
        badge: "Дата-центр Швейцария - Премиум хостинг",
        title: "VPS Швейцария Женева",
        subtitle: "Разверните VPS в дата-центре Швейцарии Женева с швейцарскими законами конфиденциальности и GDPR. VPS Женева с портом 1Gbps и надёжной европейской связностью.",
        getStarted: "Развернуть сейчас",
        viewPlans: "Смотреть тарифы"
      },
      stats: {
        latency: "<5мс",
        latencyLabel: "Региональная задержка",
        speed: "1 Гбит/с",
        speedLabel: "Сетевой порт",
        uptime: "99.9%",
        uptimeLabel: "Uptime SLA",
        location: "Женева",
        locationLabel: "Локация"
      },
      tabs: {
        title: "Швейцарское совершенство в каждом аспекте",
        subtitle: "Узнайте, что делает швейцарский VPS хостинг премиум выбором",
        features: "Функции",
        security: "Безопасность",
        performance: "Производительность",
        support: "Поддержка"
      },
      features: {
        items: [
          {
            title: "Швейцарское NVMe хранилище",
            desc: "NVMe enterprise-класса с швейцарской точностью инженерии"
          },
          {
            title: "Безопасность банковского уровня",
            desc: "Стандарты безопасности швейцарских банковских учреждений"
          },
          {
            title: "Мгновенное развертывание",
            desc: "Развертывание менее чем за 30 секунд со швейцарской эффективностью"
          },
          {
            title: "Автоматические бэкапы",
            desc: "Защита данных и резервирование по швейцарским стандартам"
          },
          {
            title: "Премиум сеть",
            desc: "Связность 1Gbps с прямым пирингом"
          },
          {
            title: "Швейцарские законы о конфиденциальности",
            desc: "Защита самыми строгими в мире правилами конфиденциальности"
          }
        ]
      },
      security: {
        title: "Безопасность швейцарского банковского уровня",
        description: "Наша инфраструктура безопасности соответствует стандартам швейцарских финансовых учреждений, обеспечивая защиту данных с военным шифрованием и многоуровневыми системами защиты.",
        items: [
          "Дата-центр с сертификацией ISO 27001",
          "Аппаратное шифрование для всего хранилища",
          "DDoS защита со швейцарской точностью фильтрации",
          "Биометрические системы контроля доступа",
          "Вооружённая охрана 24/7",
          "Резервные системы с воздушным зазором"
        ]
      },
      performance: {
        title: "Швейцарское превосходство производительности",
        description: "Спроектировано со швейцарской точностью для максимальной производительности и надёжности",
        metrics: [
          { value: "99.99%", label: "SLA Uptime" },
          { value: "<1мс", label: "Задержка сети" },
          { value: "10Гбит/с", label: "Скорость порта" },
          { value: "100%", label: "NVMe хранилище" }
        ]
      },
      support: {
        title: "Премиум швейцарская поддержка",
        description: "Наша экспертная команда обеспечивает круглосуточную поддержку со швейцарским профессионализмом и эффективностью",
        channels: [
          { name: "Чат 24/7", desc: "Мгновенная поддержка от швейцарских технических экспертов" },
          { name: "Приоритетная почта", desc: "Гарантированный ответ в течение 15 минут" },
          { name: "Телефонная поддержка", desc: "Прямая линия к старшим инженерам" },
          { name: "Выделенный менеджер", desc: "Персональное управление аккаунтом для корпоративных клиентов" }
        ]
      },
      infrastructure: {
        title: "Инфраструктура швейцарской точности",
        subtitle: "Построено по высочайшим швейцарским стандартам",
        item1: {
          title: "Дата-центр Tier IV",
          content: "Наш женевский дата-центр построен по спецификациям Tier IV с резервированием 2N+1 для всех критических систем. Множественные независимые линии питания, генераторы и UPS системы обеспечивают 99.99% uptime. Объект оснащён передовым охлаждением с изоляцией горячих коридоров и рассчитан на максимальные нагрузки без простоев."
        },
        item2: {
          title: "Премиум сетевая связность",
          content: "Прямые подключения к основным европейским и глобальным точкам обмена интернет-трафиком, включая SwissIX, DE-CIX и AMS-IX. Несколько операторов Tier-1 с BGP маршрутизацией обеспечивают оптимальные пути и автоматическое переключение. Выделенные uplink 1Gbps с DDoS митигацией на границе сети."
        },
        item3: {
          title: "Швейцарская защита данных",
          content: "Полное соответствие Федеральному закону Швейцарии о защите данных (FADP) и EU GDPR. Гарантированный суверенитет данных с хранением исключительно в Швейцарии. Регулярные аудиты безопасности независимыми швейцарскими компаниями. Военное шифрование для данных в покое и при передаче."
        },
        item4: {
          title: "Экологическое превосходство",
          content: "Питание на 100% от возобновляемой швейцарской гидроэлектроэнергии. Передовые системы охлаждения с использованием free cooling технологии снижают потребление энергии на 40%. Углеродно-нейтральные операции сертифицированы швейцарскими экологическими стандартами. Системы рекуперации тепла обеспечивают местное отопление."
        }
      },
      location: {
        title: "Женева - глобальный технологический хаб",
        description: "Женева сочетает международную связность со швейцарской стабильностью, что делает её идеальным местом для премиум VPS хостинга. Как дом многочисленных международных организаций и глобальный финансовый центр, Женева предлагает непревзойденную инфраструктуру и связность.",
        subtitle: "Расположение дата-центра",
        details: "Chemin des Aulx, Женева, Швейцария - Ультра-защищённый объект в технологическом районе Женевы",
        benefits: [
          "Нейтральная юрисдикция с сильными законами о конфиденциальности",
          "Прямые оптоволоконные подключения к 50+ странам",
          "Низкая задержка до всех крупных европейских городов",
          "Политическая стабильность и швейцарское качество",
          "Дом международных организаций (ООН, ЦЕРН)",
          "Ворота между Северной и Южной Европой"
        ]
      },
      cta: {
        title: "Испытайте швейцарское совершенство",
        subtitle: "Разверните VPS со швейцарской точностью сегодня",
        button: "Начать сейчас"
      },
      pricing: {
        title: "VPS Швейцария тарифы - VPS Женева хостинг с портом 1Gbps",
        subtitle: "VPS Швейцария Женева дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Швейцарский VPS с GDPR соответствием и швейцарскими законами конфиденциальности."
      }
    },
    usa: {
      hero: {
        badge: "Дата-центр США - Лос-Анджелес",
        title: "VPS в США",
        subtitle: "Разверните VPS в дата-центре Лос-Анджелеса с портом 1Gbps и uptime 99.9%. VPS Лос-Анджелес для связности с Западным побережьем США и Азиатско-Тихоокеанским регионом.",
        getStarted: "Начать",
        viewPlans: "Смотреть тарифы"
      },
      stats: {
        uptimeLabel: "99.9% Uptime SLA",
        latencyLabel: "Региональная задержка",
        speedLabel: "Порт 1Gbps",
        customersLabel: "Активных клиентов"
      },
      bento: {
        title: "Созданы для скорости и масштаба",
        subtitle: "Инфраструктура enterprise-класса для американского бизнеса",
        items: [
          {
            title: "Дата-центр Лос-Анджелеса",
            desc: "Надёжный объект в Лос-Анджелесе с хорошей связностью к Западному побережью"
          },
          {
            title: "Быстрая сеть",
            desc: "Порт 1Gbps с низкой задержкой по Западному побережью США"
          },
          {
            title: "DDoS защита",
            desc: "Базовая DDoS защита и мониторинг 24/7 включены"
          },
          {
            title: "Американская инфраструктура",
            desc: "Стабильный американский дата-центр с надёжным питанием"
          },
          {
            title: "Хорошая связность",
            desc: "Подключение к основным американским сетям"
          }
        ]
      },
      timeline: {
        title: "Инфраструктура мирового класса",
        subtitle: "Построена на американских инновациях и надёжности",
        items: [
          {
            title: "Расположение Carrier Hotel",
            desc: "Расположен в One Wilshire - самом подключённом здании на Западе США с 250+ операторами"
          },
          {
            title: "Премиум связность",
            desc: "Прямые подключения к нескольким провайдерам Tier-1, включая Level3, Cogent и Hurricane Electric с пропускной способностью 100Gbps"
          },
          {
            title: "Передовая безопасность",
            desc: "Объект с сертификацией SOC 2 Type II с биометрическим доступом, персоналом безопасности 24/7 и передовой DDoS защитой"
          },
          {
            title: "Зелёные технологии",
            desc: "100% углеродно-нейтральные операции с возобновляемой энергией из Калифорнии и передовой эффективностью охлаждения"
          }
        ]
      },
      testimonials: {
        title: "Доверяют американские компании",
        items: [
          {
            author: "Майкл Чен",
            role: "CTO, StreamTech Inc.",
            text: "Лучший VPS провайдер, которым мы пользовались. Локация в Лос-Анджелесе даёт нам идеальную задержку как для рынков США, так и Азии. Команда поддержки невероятно отзывчива."
          },
          {
            author: "Сара Уильямс",
            role: "Основатель, DataViz Pro",
            text: "Переключились с AWS и сократили затраты на 60%, улучшив при этом производительность. Качество сети выдающееся."
          },
          {
            author: "Джеймс Родригес",
            role: "DevOps Lead, CloudNative Solutions",
            text: "Стабильный uptime и молниеносная скорость. Их дата-центр в Лос-Анджелесе идеально подходит для наших операций на западном побережье."
          },
          {
            author: "Эмили Тейлор",
            role: "CEO, FinanceHub",
            text: "Безопасность и соответствие на высшем уровне. Спокойствие, зная, что наши данные находятся в сертифицированном SOC 2 объекте."
          }
        ]
      },
      location: {
        title: "Лос-Анджелес - ворота в Тихий океан",
        description: "Лос-Анджелес предлагает непревзойдённую связность как с рынками США, так и Азиатско-Тихоокеанского региона. Наш дата-центр в центре Лос-Анджелеса предоставляет премиум доступ к крупнейшим сетям доставки контента и облачным провайдерам.",
        subtitle: "Расположение дата-центра",
        details: "One Wilshire Blvd, Лос-Анджелес, CA - Самое подключённое здание на Западе США",
        benefits: [
          "Прямое подключение к 250+ операторам и интернет-провайдерам",
          "Задержка менее 5мс до Сан-Франциско, Сиэтла и Лас-Вегаса",
          "Быстрейшие маршруты к рынкам Азиатско-Тихоокеанского региона",
          "Основной хаб для развлекательной и медиа инфраструктуры",
          "Соответствие калифорнийской конфиденциальности потребителей (CCPA)",
          "Сейсмически укреплённый объект с резервными системами"
        ]
      },
      cta: {
        title: "Готовы запуститься в Лос-Анджелесе?",
        subtitle: "Присоединяйтесь к тысячам компаний, работающих на американской инфраструктуре",
        button: "Развернуть сейчас"
      },
      pricing: {
        title: "VPS США тарифы - VPS Лос-Анджелес хостинг с портом 1Gbps",
        subtitle: "VPS США Лос-Анджелес дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Американский VPS для связности с Западным побережьем и Азиатско-Тихоокеанским регионом."
      }
    },
    miami: {
      hero: {
        badge: "Дата-центр США - Майами, Флорида",
        title: "VPS в Майами",
        subtitle: "Разверните высокопроизводительный VPS в Майами — стратегическом цифровом шлюзе, соединяющем Северную Америку, Латинскую Америку и Карибский бассейн.",
        getStarted: "Начать",
        viewPlans: "Смотреть тарифы",
        portSpeed: "Сетевой порт",
        latency: "Региональная задержка"
      },
      gateway: {
        title: "Шлюз в Америку",
        subtitle: "Майами — главная точка пересечения цифровых экономик трёх континентов",
        items: [
          { title: "Хаб связности полушария", desc: "Майами служит основным сетевым перекрёстком для трафика между Северной, Центральной, Южной Америкой и Карибскими островами. Более 150 подводных кабелей терминируются здесь, обеспечивая непревзойдённый охват всего полушария." },
          { title: "NAP of the Americas", desc: "Расположен один из крупнейших в мире объектов обмена трафиком. Прямой пиринг с сотнями сетей обеспечивает минимальное количество переходов и максимальную пропускную способность для ваших приложений." },
          { title: "Точка посадки подводных кабелей", desc: "Майами — место, где большинство подводных оптоволоконных кабелей, соединяющих США с Латинской Америкой и Карибским бассейном, выходят на сушу. Это означает минимально возможную задержку до рынков к югу от границы." },
          { title: "Мульти-операторная избыточность", desc: "Доступ ко всем основным Tier-1 операторам и десяткам региональных провайдеров. Встроенная избыточность через разнообразные сетевые маршруты гарантирует, что ваши сервисы остаются онлайн при любых обстоятельствах." }
        ]
      },
      imageBreak: {
        text: "Где технологии встречаются с тропиками"
      },
      useCases: {
        title: "Создано для вашей нагрузки",
        subtitle: "От стриминговых платформ до финтех-приложений — VPS Майами обеспечивает производительность, которую требует ваш бизнес",
        tabs: [
          { label: "Веб и приложения", title: "Веб-приложения и API", desc: "Размещайте отзывчивые веб-приложения, REST API и микросервисы с гарантированно низкой задержкой по всей Америке. NVMe хранилище обеспечивает быстрые запросы к базам данных и загрузку страниц.", features: ["Время отклика менее 10мс в пределах Флориды", "NVMe SSD для быстрых операций ввода-вывода", "Инфраструктура, готовая к автомасштабированию", "Полный root-доступ с любой ОС"], stat: "<10ms", statLabel: "Задержка во Флориде" },
          { label: "Базы данных", title: "Хостинг баз данных и аналитика", desc: "Запускайте MySQL, PostgreSQL, MongoDB или Redis на высокопроизводительном NVMe хранилище. Идеально для приложений с интенсивной работой с данными, обслуживающих пользователей по всему Западному полушарию.", features: ["NVMe SSD с высоким IOPS", "Конфигурации до 16ГБ RAM", "Автоматизированные решения резервного копирования", "Оптимизировано для нагрузок чтения/записи"], stat: "NVMe", statLabel: "Быстрое хранилище" },
          { label: "Безопасность", title: "Безопасная инфраструктура", desc: "Безопасность корпоративного класса с защитой от DDoS, изолированными сетевыми средами и полным контролем брандмауэра. Идеально для рабочих нагрузок, чувствительных к требованиям соответствия.", features: ["Встроенная защита от DDoS", "Настраиваемые правила брандмауэра", "Изоляция приватной сети", "Регулярный мониторинг безопасности"], stat: "24/7", statLabel: "Мониторинг" },
          { label: "DevOps", title: "DevOps и CI/CD пайплайны", desc: "Запускайте среды разработки, тестирования и продакшн за секунды. Полный API-доступ для автоматизации инфраструктуры и оркестрации контейнеров.", features: ["Мгновенное развёртывание через API", "Поддержка Docker и Kubernetes", "Множество шаблонов ОС", "Возможности создания снимков и восстановления"], stat: "60s", statLabel: "Время развёртывания" }
        ]
      },
      technical: {
        title: "Технические характеристики",
        subtitle: "Оборудование и сетевая инфраструктура корпоративного класса для вашего VPS в Майами",
        items: [
          { title: "Вычислительная мощность", desc: "Процессоры Intel Xeon последнего поколения с выделенными ядрами vCPU. Каждый VPS получает гарантированное выделение CPU без перепродажи, обеспечивая стабильную вычислительную производительность." },
          { title: "Сетевая архитектура", desc: "Выделенный порт 1Gbps на каждый VPS с безлимитным трафиком. Подключение через множество вышестоящих провайдеров с BGP-маршрутизацией для оптимального выбора пути. IPv4 адрес включён." },
          { title: "Защита от DDoS", desc: "Аппаратная защита от DDoS-атак защищает ваши сервисы от объёмных атак. Автоматическое обнаружение и фильтрация гарантируют, что легитимный трафик достигает вашего сервера." },
          { title: "Безопасность данных", desc: "Физическая безопасность с биометрическим контролем доступа, видеонаблюдением и персоналом безопасности на месте. Сетевая изоляция между всеми клиентскими средами." },
          { title: "Технология хранения", desc: "Чистое NVMe SSD хранилище с исключительной производительностью ввода-вывода. RAID-защита для целостности данных со стабильной скоростью чтения и записи." },
          { title: "Избыточная связность", desc: "Множество оптоволоконных маршрутов к основным точкам обмена трафиком. Избыточное электропитание с ИБП и дизельными генераторами. Системы охлаждения N+1." }
        ]
      },
      location: {
        title: "Майами, Флорида — цифровая столица Америки",
        description: "Майами превратился из туристического центра в один из важнейших технологических хабов Западного полушария. Его уникальное географическое положение на оконечности полуострова Флорида делает его естественным узлом цифрового трафика между континентами.",
        subtitle: "Расположение дата-центра",
        details: "Объект Tier III+ в округе Майами-Дейд, Флорида — подключён к NAP of the Americas и множеству подводных кабельных систем",
        benefits: [
          "Прямые подключения к сетям Латинской Америки и Карибского бассейна",
          "Задержка менее 30мс до крупных городов Центральной и Южной Америки",
          "Стратегическая позиция для обслуживания рынка Юго-Востока США",
          "Укреплённый против ураганов объект с усиленной конструкцией",
          "Избыточное подключение к электросети с генераторным резервом",
          "Техническая поддержка и мониторинг 24/7 на месте"
        ]
      },
      cta: {
        title: "Запустите VPS в Майами сегодня",
        subtitle: "Присоединяйтесь к компаниям, использующим стратегическую позицию Майами для работы с клиентами по всей Америке",
        button: "Развернуть сейчас"
      },
      pricing: {
        title: "VPS Майами — дата-центр во Флориде с портом 1Gbps",
        subtitle: "VPS Майами, Флорида дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Стратегический шлюз в Латинскую Америку и Карибский бассейн."
      }
    },
    czechia: {
      hero: {
        badge: "Дата-центр ЕС - Прага, Чехия",
        title: "VPS в Чехии",
        subtitle: "Разверните VPS в Праге — в самом сердце Центральной Европы с прямым пирингом к крупнейшим европейским точкам обмена трафиком.",
        getStarted: "Начать",
        viewPlans: "Смотреть тарифы"
      },
      stats: {
        uptimeLabel: "Uptime SLA",
        speedLabel: "Сетевой порт",
        latencyLabel: "До Берлина/Вены",
        complianceLabel: "GDPR соответствие"
      },
      why: {
        title: "Почему Прага для VPS?",
        subtitle: "Прага сочетает связность Центральной Европы с экономичной инфраструктурой и соответствием нормам ЕС",
        items: [
          { title: "Перекрёсток Центральной Европы", desc: "Прага расположена в географическом центре Европы, обеспечивая одинаково низкую задержку до рынков Западной, Восточной, Северной и Южной Европы. Идеальная позиция для общеевропейских развёртываний, обслуживающих пользователей по всему континенту." },
          { title: "Точка обмена NIX.CZ", desc: "Прямое подключение к NIX.CZ — крупнейшей точке обмена интернет-трафиком в Чехии с более чем 200 подключёнными сетями. Оптимальная маршрутизация и минимальная задержка для регионального и международного трафика." },
          { title: "Защита данных ЕС", desc: "Полное соответствие GDPR и чешским законам о защите данных. Чехия — член Европейского Союза, обеспечивающий надёжную правовую базу для конфиденциальности данных и трансграничной передачи данных." },
          { title: "Плотность операторов", desc: "Прага — крупный хаб оптоволоконных сетей с множеством международных операторов, включая Telia, Cogent и Liberty Global. Разнообразная вышестоящая связность обеспечивает избыточность сети." },
          { title: "Современная инфраструктура", desc: "Современные дата-центры с оборудованием последнего поколения, резервными системами питания и охлаждением корпоративного класса. Все серверы работают на NVMe SSD." }
        ]
      },
      features: {
        title: "VPS корпоративного класса в Праге",
        subtitle: "Высокопроизводительные виртуальные серверы на современной инфраструктуре в одном из быстрорастущих технологических хабов Европы.",
        items: [
          { title: "NVMe SSD хранилище", desc: "Чистые NVMe диски с исключительной скоростью чтения/записи и низкой задержкой операций ввода-вывода." },
          { title: "Выделенный порт 1Gbps", desc: "Каждый VPS получает выделенный сетевой порт 1Gbps с безлимитным трафиком." },
          { title: "DDoS защита", desc: "Аппаратная защита от DDoS-атак для обеспечения непрерывной работы ваших сервисов." },
          { title: "Автоматические бэкапы", desc: "Настраиваемое расписание резервного копирования с возможностью восстановления на определённый момент." },
          { title: "Множество ОС", desc: "Выбор из Ubuntu, Debian, CentOS, AlmaLinux, Rocky Linux и Windows Server." },
          { title: "Мониторинг 24/7", desc: "Круглосуточный мониторинг инфраструктуры с автоматическим оповещением и реагированием." }
        ]
      },
      location: {
        title: "Прага — Кремниевая долина Центральной Европы",
        description: "Прага стала одним из ведущих технологических центров Европы, где расположены сотни стартапов и международных IT-компаний. Центральное расположение, квалифицированные кадры и отличная инфраструктура делают её премиальным выбором для хостинга.",
        subtitle: "Расположение дата-центра",
        details: "Дата-центр Tier III в Праге, Чехия — подключён к NIX.CZ и множеству международных операторов",
        benefits: [
          "Прямой пиринг на NIX.CZ с 200+ сетями",
          "Задержка менее 12мс до Берлина, Вены и Варшавы",
          "Центральная позиция для охвата всей Европы",
          "Полное соответствие GDPR",
          "Резервное питание N+1 ИБП и генераторы",
          "Охрана и техническая поддержка 24/7 на месте"
        ]
      },
      cta: {
        title: "Запустите VPS в Праге сегодня",
        subtitle: "Разверните в сердце Центральной Европы с первоклассной связностью и защитой данных ЕС",
        button: "Развернуть сейчас"
      },
      pricing: {
        title: "VPS Чехия — дата-центр в Праге с портом 1Gbps",
        subtitle: "VPS Прага, Чехия дата-центр с uptime SLA 99.9%, портом 1Gbps, NVMe SSD. Центральноевропейский хаб с GDPR соответствием."
      }
    },
  }
};
